/* splitting */
!function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):n.Splitting=t()}(this,function(){"use strict"
  var u=document,a=u.createTextNode.bind(u)
  function l(n,t,e){n.style.setProperty(t,e)}function f(n,t){return n.appendChild(t)}function d(n,t,e,r){var o=u.createElement("span")
  return t&&(o.className=t),e&&(r||o.setAttribute("data-"+t,e),o.textContent=e),n&&f(n,o)||o}function p(n,t){return n.getAttribute("data-"+t)}function m(n,t){return n&&0!=n.length?n.nodeName?[n]:[].slice.call(n[0].nodeName?n:(t||u).querySelectorAll(n)):[]}function i(n){for(var t=[];n--;)t[n]=[]
  return t}function h(n,t){n&&n.some(t)}function o(t){return function(n){return t[n]}}var c={}
  function n(n,t,e,r){return{by:n,depends:t,key:e,split:r}}function e(n){return function t(e,n,r){var o=r.indexOf(e)
  if(-1==o){r.unshift(e)
  var u=c[e]
  if(!u)throw new Error("plugin not loaded: "+e)
  h(u.depends,function(n){t(n,e,r)})}else u=r.indexOf(n),r.splice(o,1),r.splice(u,0,e)
  return r}(n,0,[]).map(o(c))}function t(n){c[n.by]=n}function g(n,e,r,o,u){n.normalize()
  var i=[],c=document.createDocumentFragment(),s=(o&&i.push(n.previousSibling),[])
  return m(n.childNodes).some(function(n){var t
  n.tagName&&!n.hasChildNodes()?s.push(n):n.childNodes&&n.childNodes.length?(s.push(n),i.push.apply(i,g(n,e,r,o,u))):(t=(n=n.wholeText||"").trim()).length&&(" "===n[0]&&s.push(a(" ")),h(""===r&&"function"==typeof Intl.Segmenter?Array.from((new Intl.Segmenter).segment(t)).map(function(n){return n.segment}):t.split(r),function(n,t){t&&u&&s.push(d(c,"whitespace"," ",u))
  t=d(c,e,n)
  i.push(t),s.push(t)})," "===n[n.length-1])&&s.push(a(" "))}),h(s,function(n){f(c,n)}),n.innerHTML="",f(n,c),i}var v=0
  var s="words",r=n(s,v,"word",function(n){return g(n,"word",/\s+/,0,1)}),y="chars",w=n(y,[s],"char",function(n,e,t){var r=[]
  return h(t[s],function(n,t){r.push.apply(r,g(n,"char","",e.whitespace&&t))}),r})
  function b(t){var a=(t=t||{}).key
  return m(t.target||"[data-splitting]").map(function(i){var n,c,s=i["🍌"]
  return!t.force&&s||(s=i["🍌"]={el:i},n=e(n=(n=t.by||p(i,"splitting"))&&"true"!=n?n:y),c=function(n,t){for(var e in t)n[e]=t[e]
  return n}({},t),h(n,function(n){var t,e,r,o,u
  n.split&&(t=n.by,r=(a?"-"+a:"")+n.key,n=n.split(i,c,s),r&&(e=i,u=(r="--"+(r=r))+"-index",h(o=n,function(n,t){Array.isArray(n)?h(n,function(n){l(n,u,t)}):l(n,u,t)}),l(e,r+"-total",o.length)),s[t]=n,i.classList.add(t))}),i.classList.add("splitting")),s})}function N(n,t,e){var t=m(t.matching||n.children,n),r={}
  return h(t,function(n){var t=Math.round(n[e]);(r[t]||(r[t]=[])).push(n)}),Object.keys(r).map(Number).sort(x).map(o(r))}function x(n,t){return n-t}b.html=function(n){var t=(n=n||{}).target=d()
  return t.innerHTML=n.content,b(n),t.outerHTML}
  var S=n("lines",[s],"line",function(n,t,e){return N(n,{matching:e[s]},"offsetTop")}),T=n("items",v,"item",function(n,t){return m(t.matching||n.children,n)}),A=n("rows",v,"row",function(n,t){return N(n,t,"offsetTop")}),L=n("cols",v,"col",function(n,t){return N(n,t,"offsetLeft")}),k=n("grid",["rows","cols"]),C="layout",M=n(C,v,v,function(n,t){for(var e,r=t.rows=+(t.rows||p(n,"rows")||1),o=t.columns=+(t.columns||p(n,"columns")||1),u=(t.image=t.image||p(n,"image")||n.currentSrc||n.src,t.image&&(e=m("img",n)[0],t.image=e&&(e.currentSrc||e.src)),t.image&&l(n,"background-image","url("+t.image+")"),r*o),i=[],c=d(v,"cell-grid");u--;){var s=d(c,"cell")
  d(s,"cell-inner"),i.push(s)}return f(n,c),i}),H=n("cellRows",[C],"row",function(n,t,e){var r=t.rows,o=i(r)
  return h(e[C],function(n,t,e){o[Math.floor(t/(e.length/r))].push(n)}),o}),O=n("cellColumns",[C],"col",function(n,t,e){var r=t.columns,o=i(r)
  return h(e[C],function(n,t){o[t%r].push(n)}),o}),j=n("cells",["cellRows","cellColumns"],"cell",function(n,t,e){return e[C]})
  return(b.add=t)(r),t(w),t(S),t(T),t(A),t(L),t(k),t(M),t(H),t(O),t(j),b})
  
  /* gsap */
  /*!
   * GSAP 3.12.5
   * https://gsap.com
   * 
   * @license Copyright 2024, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license or for Club GSAP members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
   */
  
  !function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).window=t.window||{})}(this,function(e){"use strict";function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _assertThisInitialized(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function r(t){return"string"==typeof t}function s(t){return"function"==typeof t}function t(t){return"number"==typeof t}function u(t){return void 0===t}function v(t){return"object"==typeof t}function w(t){return!1!==t}function x(){return"undefined"!=typeof window}function y(t){return s(t)||r(t)}function P(t){return(i=yt(t,ot))&&ze}function Q(t,e){return console.warn("Invalid property",t,"set to",e,"Missing plugin? gsap.registerPlugin()")}function R(t,e){return!e&&console.warn(t)}function S(t,e){return t&&(ot[t]=e)&&i&&(i[t]=e)||ot}function T(){return 0}function ea(t){var e,r,i=t[0];if(v(i)||s(i)||(t=[t]),!(e=(i._gsap||{}).harness)){for(r=gt.length;r--&&!gt[r].targetTest(i););e=gt[r]}for(r=t.length;r--;)t[r]&&(t[r]._gsap||(t[r]._gsap=new Vt(t[r],e)))||t.splice(r,1);return t}function fa(t){return t._gsap||ea(Mt(t))[0]._gsap}function ga(t,e,r){return(r=t[e])&&s(r)?t[e]():u(r)&&t.getAttribute&&t.getAttribute(e)||r}function ha(t,e){return(t=t.split(",")).forEach(e)||t}function ia(t){return Math.round(1e5*t)/1e5||0}function ja(t){return Math.round(1e7*t)/1e7||0}function ka(t,e){var r=e.charAt(0),i=parseFloat(e.substr(2));return t=parseFloat(t),"+"===r?t+i:"-"===r?t-i:"*"===r?t*i:t/i}function la(t,e){for(var r=e.length,i=0;t.indexOf(e[i])<0&&++i<r;);return i<r}function ma(){var t,e,r=dt.length,i=dt.slice(0);for(ct={},t=dt.length=0;t<r;t++)(e=i[t])&&e._lazy&&(e.render(e._lazy[0],e._lazy[1],!0)._lazy=0)}function na(t,e,r,i){dt.length&&!L&&ma(),t.render(e,r,i||L&&e<0&&(t._initted||t._startAt)),dt.length&&!L&&ma()}function oa(t){var e=parseFloat(t);return(e||0===e)&&(t+"").match(at).length<2?e:r(t)?t.trim():t}function pa(t){return t}function qa(t,e){for(var r in e)r in t||(t[r]=e[r]);return t}function ta(t,e){for(var r in e)"__proto__"!==r&&"constructor"!==r&&"prototype"!==r&&(t[r]=v(e[r])?ta(t[r]||(t[r]={}),e[r]):e[r]);return t}function ua(t,e){var r,i={};for(r in t)r in e||(i[r]=t[r]);return i}function va(t){var e=t.parent||I,r=t.keyframes?function _setKeyframeDefaults(i){return function(t,e){for(var r in e)r in t||"duration"===r&&i||"ease"===r||(t[r]=e[r])}}(Z(t.keyframes)):qa;if(w(t.inherit))for(;e;)r(t,e.vars.defaults),e=e.parent||e._dp;return t}function xa(t,e,r,i,n){void 0===r&&(r="_first"),void 0===i&&(i="_last");var a,s=t[i];if(n)for(a=e[n];s&&s[n]>a;)s=s._prev;return s?(e._next=s._next,s._next=e):(e._next=t[r],t[r]=e),e._next?e._next._prev=e:t[i]=e,e._prev=s,e.parent=e._dp=t,e}function ya(t,e,r,i){void 0===r&&(r="_first"),void 0===i&&(i="_last");var n=e._prev,a=e._next;n?n._next=a:t[r]===e&&(t[r]=a),a?a._prev=n:t[i]===e&&(t[i]=n),e._next=e._prev=e.parent=null}function za(t,e){t.parent&&(!e||t.parent.autoRemoveChildren)&&t.parent.remove&&t.parent.remove(t),t._act=0}function Aa(t,e){if(t&&(!e||e._end>t._dur||e._start<0))for(var r=t;r;)r._dirty=1,r=r.parent;return t}function Ca(t,e,r,i){return t._startAt&&(L?t._startAt.revert(ht):t.vars.immediateRender&&!t.vars.autoRevert||t._startAt.render(e,!0,i))}function Ea(t){return t._repeat?Tt(t._tTime,t=t.duration()+t._rDelay)*t:0}function Ga(t,e){return(t-e._start)*e._ts+(0<=e._ts?0:e._dirty?e.totalDuration():e._tDur)}function Ha(t){return t._end=ja(t._start+(t._tDur/Math.abs(t._ts||t._rts||X)||0))}function Ia(t,e){var r=t._dp;return r&&r.smoothChildTiming&&t._ts&&(t._start=ja(r._time-(0<t._ts?e/t._ts:((t._dirty?t.totalDuration():t._tDur)-e)/-t._ts)),Ha(t),r._dirty||Aa(r,t)),t}function Ja(t,e){var r;if((e._time||!e._dur&&e._initted||e._start<t._time&&(e._dur||!e.add))&&(r=Ga(t.rawTime(),e),(!e._dur||Ot(0,e.totalDuration(),r)-e._tTime>X)&&e.render(r,!0)),Aa(t,e)._dp&&t._initted&&t._time>=t._dur&&t._ts){if(t._dur<t.duration())for(r=t;r._dp;)0<=r.rawTime()&&r.totalTime(r._tTime),r=r._dp;t._zTime=-X}}function Ka(e,r,i,n){return r.parent&&za(r),r._start=ja((t(i)?i:i||e!==I?xt(e,i,r):e._time)+r._delay),r._end=ja(r._start+(r.totalDuration()/Math.abs(r.timeScale())||0)),xa(e,r,"_first","_last",e._sort?"_start":0),bt(r)||(e._recent=r),n||Ja(e,r),e._ts<0&&Ia(e,e._tTime),e}function La(t,e){return(ot.ScrollTrigger||Q("scrollTrigger",e))&&ot.ScrollTrigger.create(e,t)}function Ma(t,e,r,i,n){return Qt(t,e,n),t._initted?!r&&t._pt&&!L&&(t._dur&&!1!==t.vars.lazy||!t._dur&&t.vars.lazy)&&f!==Rt.frame?(dt.push(t),t._lazy=[n,i],1):void 0:1}function Ra(t,e,r,i){var n=t._repeat,a=ja(e)||0,s=t._tTime/t._tDur;return s&&!i&&(t._time*=a/t._dur),t._dur=a,t._tDur=n?n<0?1e10:ja(a*(n+1)+t._rDelay*n):a,0<s&&!i&&Ia(t,t._tTime=t._tDur*s),t.parent&&Ha(t),r||Aa(t.parent,t),t}function Sa(t){return t instanceof Xt?Aa(t):Ra(t,t._dur)}function Va(e,r,i){var n,a,s=t(r[1]),o=(s?2:1)+(e<2?0:1),u=r[o];if(s&&(u.duration=r[1]),u.parent=i,e){for(n=u,a=i;a&&!("immediateRender"in n);)n=a.vars.defaults||{},a=w(a.vars.inherit)&&a.parent;u.immediateRender=w(n.immediateRender),e<2?u.runBackwards=1:u.startAt=r[o-1]}return new $t(r[0],u,r[1+o])}function Wa(t,e){return t||0===t?e(t):e}function Ya(t,e){return r(t)&&(e=st.exec(t))?e[1]:""}function _a(t,e){return t&&v(t)&&"length"in t&&(!e&&!t.length||t.length-1 in t&&v(t[0]))&&!t.nodeType&&t!==h}function cb(r){return r=Mt(r)[0]||R("Invalid scope")||{},function(t){var e=r.current||r.nativeElement||r;return Mt(t,e.querySelectorAll?e:e===r?R("Invalid scope")||a.createElement("div"):r)}}function db(t){return t.sort(function(){return.5-Math.random()})}function eb(t){if(s(t))return t;var p=v(t)?t:{each:t},_=jt(p.ease),m=p.from||0,g=parseFloat(p.base)||0,y={},e=0<m&&m<1,T=isNaN(m)||e,b=p.axis,w=m,x=m;return r(m)?w=x={center:.5,edges:.5,end:1}[m]||0:!e&&T&&(w=m[0],x=m[1]),function(t,e,r){var i,n,a,s,o,u,h,l,f,d=(r||p).length,c=y[d];if(!c){if(!(f="auto"===p.grid?0:(p.grid||[1,U])[1])){for(h=-U;h<(h=r[f++].getBoundingClientRect().left)&&f<d;);f<d&&f--}for(c=y[d]=[],i=T?Math.min(f,d)*w-.5:m%f,n=f===U?0:T?d*x/f-.5:m/f|0,l=U,u=h=0;u<d;u++)a=u%f-i,s=n-(u/f|0),c[u]=o=b?Math.abs("y"===b?s:a):K(a*a+s*s),h<o&&(h=o),o<l&&(l=o);"random"===m&&db(c),c.max=h-l,c.min=l,c.v=d=(parseFloat(p.amount)||parseFloat(p.each)*(d<f?d-1:b?"y"===b?d/f:f:Math.max(f,d/f))||0)*("edges"===m?-1:1),c.b=d<0?g-d:g,c.u=Ya(p.amount||p.each)||0,_=_&&d<0?Yt(_):_}return d=(c[t]-c.min)/c.max||0,ja(c.b+(_?_(d):d)*c.v)+c.u}}function fb(i){var n=Math.pow(10,((i+"").split(".")[1]||"").length);return function(e){var r=ja(Math.round(parseFloat(e)/i)*i*n);return(r-r%1)/n+(t(e)?0:Ya(e))}}function gb(h,e){var l,f,r=Z(h);return!r&&v(h)&&(l=r=h.radius||U,h.values?(h=Mt(h.values),(f=!t(h[0]))&&(l*=l)):h=fb(h.increment)),Wa(e,r?s(h)?function(t){return f=h(t),Math.abs(f-t)<=l?f:t}:function(e){for(var r,i,n=parseFloat(f?e.x:e),a=parseFloat(f?e.y:0),s=U,o=0,u=h.length;u--;)(r=f?(r=h[u].x-n)*r+(i=h[u].y-a)*i:Math.abs(h[u]-n))<s&&(s=r,o=u);return o=!l||s<=l?h[o]:e,f||o===e||t(e)?o:o+Ya(e)}:fb(h))}function hb(t,e,r,i){return Wa(Z(t)?!e:!0===r?!!(r=0):!i,function(){return Z(t)?t[~~(Math.random()*t.length)]:(r=r||1e-5)&&(i=r<1?Math.pow(10,(r+"").length-2):1)&&Math.floor(Math.round((t-r/2+Math.random()*(e-t+.99*r))/r)*r*i)/i})}function lb(e,r,t){return Wa(t,function(t){return e[~~r(t)]})}function ob(t){for(var e,r,i,n,a=0,s="";~(e=t.indexOf("random(",a));)i=t.indexOf(")",e),n="["===t.charAt(e+7),r=t.substr(e+7,i-e-7).match(n?at:tt),s+=t.substr(a,e-a)+hb(n?r:+r[0],n?0:+r[1],+r[2]||1e-5),a=i+1;return s+t.substr(a,t.length-a)}function rb(t,e,r){var i,n,a,s=t.labels,o=U;for(i in s)(n=s[i]-e)<0==!!r&&n&&o>(n=Math.abs(n))&&(a=i,o=n);return a}function tb(t){return za(t),t.scrollTrigger&&t.scrollTrigger.kill(!!L),t.progress()<1&&Ct(t,"onInterrupt"),t}function wb(t){if(t)if(t=!t.name&&t.default||t,x()||t.headless){var e=t.name,r=s(t),i=e&&!r&&t.init?function(){this._props=[]}:t,n={init:T,render:he,add:Wt,kill:ce,modifier:fe,rawVars:0},a={targetTest:0,get:0,getSetter:ne,aliases:{},register:0};if(Ft(),t!==i){if(pt[e])return;qa(i,qa(ua(t,n),a)),yt(i.prototype,yt(n,ua(t,a))),pt[i.prop=e]=i,t.targetTest&&(gt.push(i),ft[e]=1),e=("css"===e?"CSS":e.charAt(0).toUpperCase()+e.substr(1))+"Plugin"}S(e,i),t.register&&t.register(ze,i,_e)}else At.push(t)}function zb(t,e,r){return(6*(t+=t<0?1:1<t?-1:0)<1?e+(r-e)*t*6:t<.5?r:3*t<2?e+(r-e)*(2/3-t)*6:e)*St+.5|0}function Ab(e,r,i){var n,a,s,o,u,h,l,f,d,c,p=e?t(e)?[e>>16,e>>8&St,e&St]:0:zt.black;if(!p){if(","===e.substr(-1)&&(e=e.substr(0,e.length-1)),zt[e])p=zt[e];else if("#"===e.charAt(0)){if(e.length<6&&(e="#"+(n=e.charAt(1))+n+(a=e.charAt(2))+a+(s=e.charAt(3))+s+(5===e.length?e.charAt(4)+e.charAt(4):"")),9===e.length)return[(p=parseInt(e.substr(1,6),16))>>16,p>>8&St,p&St,parseInt(e.substr(7),16)/255];p=[(e=parseInt(e.substr(1),16))>>16,e>>8&St,e&St]}else if("hsl"===e.substr(0,3))if(p=c=e.match(tt),r){if(~e.indexOf("="))return p=e.match(et),i&&p.length<4&&(p[3]=1),p}else o=+p[0]%360/360,u=p[1]/100,n=2*(h=p[2]/100)-(a=h<=.5?h*(u+1):h+u-h*u),3<p.length&&(p[3]*=1),p[0]=zb(o+1/3,n,a),p[1]=zb(o,n,a),p[2]=zb(o-1/3,n,a);else p=e.match(tt)||zt.transparent;p=p.map(Number)}return r&&!c&&(n=p[0]/St,a=p[1]/St,s=p[2]/St,h=((l=Math.max(n,a,s))+(f=Math.min(n,a,s)))/2,l===f?o=u=0:(d=l-f,u=.5<h?d/(2-l-f):d/(l+f),o=l===n?(a-s)/d+(a<s?6:0):l===a?(s-n)/d+2:(n-a)/d+4,o*=60),p[0]=~~(o+.5),p[1]=~~(100*u+.5),p[2]=~~(100*h+.5)),i&&p.length<4&&(p[3]=1),p}function Bb(t){var r=[],i=[],n=-1;return t.split(Et).forEach(function(t){var e=t.match(rt)||[];r.push.apply(r,e),i.push(n+=e.length+1)}),r.c=i,r}function Cb(t,e,r){var i,n,a,s,o="",u=(t+o).match(Et),h=e?"hsla(":"rgba(",l=0;if(!u)return t;if(u=u.map(function(t){return(t=Ab(t,e,1))&&h+(e?t[0]+","+t[1]+"%,"+t[2]+"%,"+t[3]:t.join(","))+")"}),r&&(a=Bb(t),(i=r.c).join(o)!==a.c.join(o)))for(s=(n=t.replace(Et,"1").split(rt)).length-1;l<s;l++)o+=n[l]+(~i.indexOf(l)?u.shift()||h+"0,0,0,0)":(a.length?a:u.length?u:r).shift());if(!n)for(s=(n=t.split(Et)).length-1;l<s;l++)o+=n[l]+u[l];return o+n[s]}function Fb(t){var e,r=t.join(" ");if(Et.lastIndex=0,Et.test(r))return e=Dt.test(r),t[1]=Cb(t[1],e),t[0]=Cb(t[0],e,Bb(t[1])),!0}function Ob(t){var e=(t+"").split("("),r=Lt[e[0]];return r&&1<e.length&&r.config?r.config.apply(null,~t.indexOf("{")?[function _parseObjectInString(t){for(var e,r,i,n={},a=t.substr(1,t.length-3).split(":"),s=a[0],o=1,u=a.length;o<u;o++)r=a[o],e=o!==u-1?r.lastIndexOf(","):r.length,i=r.substr(0,e),n[s]=isNaN(i)?i.replace(Bt,"").trim():+i,s=r.substr(e+1).trim();return n}(e[1])]:function _valueInParentheses(t){var e=t.indexOf("(")+1,r=t.indexOf(")"),i=t.indexOf("(",e);return t.substring(e,~i&&i<r?t.indexOf(")",r+1):r)}(t).split(",").map(oa)):Lt._CE&&It.test(t)?Lt._CE("",t):r}function Qb(t,e){for(var r,i=t._first;i;)i instanceof Xt?Qb(i,e):!i.vars.yoyoEase||i._yoyo&&i._repeat||i._yoyo===e||(i.timeline?Qb(i.timeline,e):(r=i._ease,i._ease=i._yEase,i._yEase=r,i._yoyo=e)),i=i._next}function Sb(t,e,r,i){void 0===r&&(r=function easeOut(t){return 1-e(1-t)}),void 0===i&&(i=function easeInOut(t){return t<.5?e(2*t)/2:1-e(2*(1-t))/2});var n,a={easeIn:e,easeOut:r,easeInOut:i};return ha(t,function(t){for(var e in Lt[t]=ot[t]=a,Lt[n=t.toLowerCase()]=r,a)Lt[n+("easeIn"===e?".in":"easeOut"===e?".out":".inOut")]=Lt[t+"."+e]=a[e]}),a}function Tb(e){return function(t){return t<.5?(1-e(1-2*t))/2:.5+e(2*(t-.5))/2}}function Ub(r,t,e){function Jm(t){return 1===t?1:i*Math.pow(2,-10*t)*H((t-a)*n)+1}var i=1<=t?t:1,n=(e||(r?.3:.45))/(t<1?t:1),a=n/N*(Math.asin(1/i)||0),s="out"===r?Jm:"in"===r?function(t){return 1-Jm(1-t)}:Tb(Jm);return n=N/n,s.config=function(t,e){return Ub(r,t,e)},s}function Vb(e,r){function Rm(t){return t?--t*t*((r+1)*t+r)+1:0}void 0===r&&(r=1.70158);var t="out"===e?Rm:"in"===e?function(t){return 1-Rm(1-t)}:Tb(Rm);return t.config=function(t){return Vb(e,t)},t}var F,L,l,I,h,n,a,i,o,f,d,c,p,_,m,g,b,O,k,M,C,A,z,E,D,B,Y,j,q={autoSleep:120,force3D:"auto",nullTargetWarn:1,units:{lineHeight:""}},V={duration:.5,overwrite:!1,delay:0},U=1e8,X=1/U,N=2*Math.PI,G=N/4,W=0,K=Math.sqrt,J=Math.cos,H=Math.sin,$="function"==typeof ArrayBuffer&&ArrayBuffer.isView||function(){},Z=Array.isArray,tt=/(?:-?\.?\d|\.)+/gi,et=/[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,rt=/[-+=.]*\d+[.e-]*\d*[a-z%]*/g,it=/[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,nt=/[+-]=-?[.\d]+/,at=/[^,'"\[\]\s]+/gi,st=/^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,ot={},ut={suppressEvents:!0,isStart:!0,kill:!1},ht={suppressEvents:!0,kill:!1},lt={suppressEvents:!0},ft={},dt=[],ct={},pt={},_t={},mt=30,gt=[],vt="",yt=function _merge(t,e){for(var r in e)t[r]=e[r];return t},Tt=function _animationCycle(t,e){var r=Math.floor(t/=e);return t&&r===t?r-1:r},bt=function _isFromOrFromStart(t){var e=t.data;return"isFromStart"===e||"isStart"===e},wt={_start:0,endTime:T,totalDuration:T},xt=function _parsePosition(t,e,i){var n,a,s,o=t.labels,u=t._recent||wt,h=t.duration()>=U?u.endTime(!1):t._dur;return r(e)&&(isNaN(e)||e in o)?(a=e.charAt(0),s="%"===e.substr(-1),n=e.indexOf("="),"<"===a||">"===a?(0<=n&&(e=e.replace(/=/,"")),("<"===a?u._start:u.endTime(0<=u._repeat))+(parseFloat(e.substr(1))||0)*(s?(n<0?u:i).totalDuration()/100:1)):n<0?(e in o||(o[e]=h),o[e]):(a=parseFloat(e.charAt(n-1)+e.substr(n+1)),s&&i&&(a=a/100*(Z(i)?i[0]:i).totalDuration()),1<n?_parsePosition(t,e.substr(0,n-1),i)+a:h+a)):null==e?h:+e},Ot=function _clamp(t,e,r){return r<t?t:e<r?e:r},kt=[].slice,Mt=function toArray(t,e,i){return l&&!e&&l.selector?l.selector(t):!r(t)||i||!n&&Ft()?Z(t)?function _flatten(t,e,i){return void 0===i&&(i=[]),t.forEach(function(t){return r(t)&&!e||_a(t,1)?i.push.apply(i,Mt(t)):i.push(t)})||i}(t,i):_a(t)?kt.call(t,0):t?[t]:[]:kt.call((e||a).querySelectorAll(t),0)},Pt=function mapRange(e,t,r,i,n){var a=t-e,s=i-r;return Wa(n,function(t){return r+((t-e)/a*s||0)})},Ct=function _callback(t,e,r){var i,n,a,s=t.vars,o=s[e],u=l,h=t._ctx;if(o)return i=s[e+"Params"],n=s.callbackScope||t,r&&dt.length&&ma(),h&&(l=h),a=i?o.apply(n,i):o.call(n),l=u,a},At=[],St=255,zt={aqua:[0,St,St],lime:[0,St,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,St],navy:[0,0,128],white:[St,St,St],olive:[128,128,0],yellow:[St,St,0],orange:[St,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[St,0,0],pink:[St,192,203],cyan:[0,St,St],transparent:[St,St,St,0]},Et=function(){var t,e="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";for(t in zt)e+="|"+t+"\\b";return new RegExp(e+")","gi")}(),Dt=/hsl[a]?\(/,Rt=(k=Date.now,M=500,C=33,A=k(),z=A,D=E=1e3/240,g={time:0,frame:0,tick:function tick(){yl(!0)},deltaRatio:function deltaRatio(t){return b/(1e3/(t||60))},wake:function wake(){o&&(!n&&x()&&(h=n=window,a=h.document||{},ot.gsap=ze,(h.gsapVersions||(h.gsapVersions=[])).push(ze.version),P(i||h.GreenSockGlobals||!h.gsap&&h||{}),At.forEach(wb)),m="undefined"!=typeof requestAnimationFrame&&requestAnimationFrame,p&&g.sleep(),_=m||function(t){return setTimeout(t,D-1e3*g.time+1|0)},c=1,yl(2))},sleep:function sleep(){(m?cancelAnimationFrame:clearTimeout)(p),c=0,_=T},lagSmoothing:function lagSmoothing(t,e){M=t||1/0,C=Math.min(e||33,M)},fps:function fps(t){E=1e3/(t||240),D=1e3*g.time+E},add:function add(n,t,e){var a=t?function(t,e,r,i){n(t,e,r,i),g.remove(a)}:n;return g.remove(n),B[e?"unshift":"push"](a),Ft(),a},remove:function remove(t,e){~(e=B.indexOf(t))&&B.splice(e,1)&&e<=O&&O--},_listeners:B=[]}),Ft=function _wake(){return!c&&Rt.wake()},Lt={},It=/^[\d.\-M][\d.\-,\s]/,Bt=/["']/g,Yt=function _invertEase(e){return function(t){return 1-e(1-t)}},jt=function _parseEase(t,e){return t&&(s(t)?t:Lt[t]||Ob(t))||e};function yl(t){var e,r,i,n,a=k()-z,s=!0===t;if((M<a||a<0)&&(A+=a-C),(0<(e=(i=(z+=a)-A)-D)||s)&&(n=++g.frame,b=i-1e3*g.time,g.time=i/=1e3,D+=e+(E<=e?4:E-e),r=1),s||(p=_(yl)),r)for(O=0;O<B.length;O++)B[O](i,b,n,t)}function gn(t){return t<j?Y*t*t:t<.7272727272727273?Y*Math.pow(t-1.5/2.75,2)+.75:t<.9090909090909092?Y*(t-=2.25/2.75)*t+.9375:Y*Math.pow(t-2.625/2.75,2)+.984375}ha("Linear,Quad,Cubic,Quart,Quint,Strong",function(t,e){var r=e<5?e+1:e;Sb(t+",Power"+(r-1),e?function(t){return Math.pow(t,r)}:function(t){return t},function(t){return 1-Math.pow(1-t,r)},function(t){return t<.5?Math.pow(2*t,r)/2:1-Math.pow(2*(1-t),r)/2})}),Lt.Linear.easeNone=Lt.none=Lt.Linear.easeIn,Sb("Elastic",Ub("in"),Ub("out"),Ub()),Y=7.5625,j=1/2.75,Sb("Bounce",function(t){return 1-gn(1-t)},gn),Sb("Expo",function(t){return t?Math.pow(2,10*(t-1)):0}),Sb("Circ",function(t){return-(K(1-t*t)-1)}),Sb("Sine",function(t){return 1===t?1:1-J(t*G)}),Sb("Back",Vb("in"),Vb("out"),Vb()),Lt.SteppedEase=Lt.steps=ot.SteppedEase={config:function config(t,e){void 0===t&&(t=1);var r=1/t,i=t+(e?0:1),n=e?1:0;return function(t){return((i*Ot(0,.99999999,t)|0)+n)*r}}},V.ease=Lt["quad.out"],ha("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",function(t){return vt+=t+","+t+"Params,"});var qt,Vt=function GSCache(t,e){this.id=W++,(t._gsap=this).target=t,this.harness=e,this.get=e?e.get:ga,this.set=e?e.getSetter:ne},Ut=((qt=Animation.prototype).delay=function delay(t){return t||0===t?(this.parent&&this.parent.smoothChildTiming&&this.startTime(this._start+t-this._delay),this._delay=t,this):this._delay},qt.duration=function duration(t){return arguments.length?this.totalDuration(0<this._repeat?t+(t+this._rDelay)*this._repeat:t):this.totalDuration()&&this._dur},qt.totalDuration=function totalDuration(t){return arguments.length?(this._dirty=0,Ra(this,this._repeat<0?t:(t-this._repeat*this._rDelay)/(this._repeat+1))):this._tDur},qt.totalTime=function totalTime(t,e){if(Ft(),!arguments.length)return this._tTime;var r=this._dp;if(r&&r.smoothChildTiming&&this._ts){for(Ia(this,t),!r._dp||r.parent||Ja(r,this);r&&r.parent;)r.parent._time!==r._start+(0<=r._ts?r._tTime/r._ts:(r.totalDuration()-r._tTime)/-r._ts)&&r.totalTime(r._tTime,!0),r=r.parent;!this.parent&&this._dp.autoRemoveChildren&&(0<this._ts&&t<this._tDur||this._ts<0&&0<t||!this._tDur&&!t)&&Ka(this._dp,this,this._start-this._delay)}return(this._tTime!==t||!this._dur&&!e||this._initted&&Math.abs(this._zTime)===X||!t&&!this._initted&&(this.add||this._ptLookup))&&(this._ts||(this._pTime=t),na(this,t,e)),this},qt.time=function time(t,e){return arguments.length?this.totalTime(Math.min(this.totalDuration(),t+Ea(this))%(this._dur+this._rDelay)||(t?this._dur:0),e):this._time},qt.totalProgress=function totalProgress(t,e){return arguments.length?this.totalTime(this.totalDuration()*t,e):this.totalDuration()?Math.min(1,this._tTime/this._tDur):0<this.rawTime()?1:0},qt.progress=function progress(t,e){return arguments.length?this.totalTime(this.duration()*(!this._yoyo||1&this.iteration()?t:1-t)+Ea(this),e):this.duration()?Math.min(1,this._time/this._dur):0<this.rawTime()?1:0},qt.iteration=function iteration(t,e){var r=this.duration()+this._rDelay;return arguments.length?this.totalTime(this._time+(t-1)*r,e):this._repeat?Tt(this._tTime,r)+1:1},qt.timeScale=function timeScale(t,e){if(!arguments.length)return this._rts===-X?0:this._rts;if(this._rts===t)return this;var r=this.parent&&this._ts?Ga(this.parent._time,this):this._tTime;return this._rts=+t||0,this._ts=this._ps||t===-X?0:this._rts,this.totalTime(Ot(-Math.abs(this._delay),this._tDur,r),!1!==e),Ha(this),function _recacheAncestors(t){for(var e=t.parent;e&&e.parent;)e._dirty=1,e.totalDuration(),e=e.parent;return t}(this)},qt.paused=function paused(t){return arguments.length?(this._ps!==t&&((this._ps=t)?(this._pTime=this._tTime||Math.max(-this._delay,this.rawTime()),this._ts=this._act=0):(Ft(),this._ts=this._rts,this.totalTime(this.parent&&!this.parent.smoothChildTiming?this.rawTime():this._tTime||this._pTime,1===this.progress()&&Math.abs(this._zTime)!==X&&(this._tTime-=X)))),this):this._ps},qt.startTime=function startTime(t){if(arguments.length){this._start=t;var e=this.parent||this._dp;return!e||!e._sort&&this.parent||Ka(e,this,t-this._delay),this}return this._start},qt.endTime=function endTime(t){return this._start+(w(t)?this.totalDuration():this.duration())/Math.abs(this._ts||1)},qt.rawTime=function rawTime(t){var e=this.parent||this._dp;return e?t&&(!this._ts||this._repeat&&this._time&&this.totalProgress()<1)?this._tTime%(this._dur+this._rDelay):this._ts?Ga(e.rawTime(t),this):this._tTime:this._tTime},qt.revert=function revert(t){void 0===t&&(t=lt);var e=L;return L=t,(this._initted||this._startAt)&&(this.timeline&&this.timeline.revert(t),this.totalTime(-.01,t.suppressEvents)),"nested"!==this.data&&!1!==t.kill&&this.kill(),L=e,this},qt.globalTime=function globalTime(t){for(var e=this,r=arguments.length?t:e.rawTime();e;)r=e._start+r/(Math.abs(e._ts)||1),e=e._dp;return!this.parent&&this._sat?this._sat.globalTime(t):r},qt.repeat=function repeat(t){return arguments.length?(this._repeat=t===1/0?-2:t,Sa(this)):-2===this._repeat?1/0:this._repeat},qt.repeatDelay=function repeatDelay(t){if(arguments.length){var e=this._time;return this._rDelay=t,Sa(this),e?this.time(e):this}return this._rDelay},qt.yoyo=function yoyo(t){return arguments.length?(this._yoyo=t,this):this._yoyo},qt.seek=function seek(t,e){return this.totalTime(xt(this,t),w(e))},qt.restart=function restart(t,e){return this.play().totalTime(t?-this._delay:0,w(e))},qt.play=function play(t,e){return null!=t&&this.seek(t,e),this.reversed(!1).paused(!1)},qt.reverse=function reverse(t,e){return null!=t&&this.seek(t||this.totalDuration(),e),this.reversed(!0).paused(!1)},qt.pause=function pause(t,e){return null!=t&&this.seek(t,e),this.paused(!0)},qt.resume=function resume(){return this.paused(!1)},qt.reversed=function reversed(t){return arguments.length?(!!t!==this.reversed()&&this.timeScale(-this._rts||(t?-X:0)),this):this._rts<0},qt.invalidate=function invalidate(){return this._initted=this._act=0,this._zTime=-X,this},qt.isActive=function isActive(){var t,e=this.parent||this._dp,r=this._start;return!(e&&!(this._ts&&this._initted&&e.isActive()&&(t=e.rawTime(!0))>=r&&t<this.endTime(!0)-X))},qt.eventCallback=function eventCallback(t,e,r){var i=this.vars;return 1<arguments.length?(e?(i[t]=e,r&&(i[t+"Params"]=r),"onUpdate"===t&&(this._onUpdate=e)):delete i[t],this):i[t]},qt.then=function then(t){var i=this;return new Promise(function(e){function Co(){var t=i.then;i.then=null,s(r)&&(r=r(i))&&(r.then||r===i)&&(i.then=t),e(r),i.then=t}var r=s(t)?t:pa;i._initted&&1===i.totalProgress()&&0<=i._ts||!i._tTime&&i._ts<0?Co():i._prom=Co})},qt.kill=function kill(){tb(this)},Animation);function Animation(t){this.vars=t,this._delay=+t.delay||0,(this._repeat=t.repeat===1/0?-2:t.repeat||0)&&(this._rDelay=t.repeatDelay||0,this._yoyo=!!t.yoyo||!!t.yoyoEase),this._ts=1,Ra(this,+t.duration,1,1),this.data=t.data,l&&(this._ctx=l).data.push(this),c||Rt.wake()}qa(Ut.prototype,{_time:0,_start:0,_end:0,_tTime:0,_tDur:0,_dirty:0,_repeat:0,_yoyo:!1,parent:null,_initted:!1,_rDelay:0,_ts:1,_dp:0,ratio:0,_zTime:-X,_prom:0,_ps:!1,_rts:1});var Xt=function(i){function Timeline(t,e){var r;return void 0===t&&(t={}),(r=i.call(this,t)||this).labels={},r.smoothChildTiming=!!t.smoothChildTiming,r.autoRemoveChildren=!!t.autoRemoveChildren,r._sort=w(t.sortChildren),I&&Ka(t.parent||I,_assertThisInitialized(r),e),t.reversed&&r.reverse(),t.paused&&r.paused(!0),t.scrollTrigger&&La(_assertThisInitialized(r),t.scrollTrigger),r}_inheritsLoose(Timeline,i);var e=Timeline.prototype;return e.to=function to(t,e,r){return Va(0,arguments,this),this},e.from=function from(t,e,r){return Va(1,arguments,this),this},e.fromTo=function fromTo(t,e,r,i){return Va(2,arguments,this),this},e.set=function set(t,e,r){return e.duration=0,e.parent=this,va(e).repeatDelay||(e.repeat=0),e.immediateRender=!!e.immediateRender,new $t(t,e,xt(this,r),1),this},e.call=function call(t,e,r){return Ka(this,$t.delayedCall(0,t,e),r)},e.staggerTo=function staggerTo(t,e,r,i,n,a,s){return r.duration=e,r.stagger=r.stagger||i,r.onComplete=a,r.onCompleteParams=s,r.parent=this,new $t(t,r,xt(this,n)),this},e.staggerFrom=function staggerFrom(t,e,r,i,n,a,s){return r.runBackwards=1,va(r).immediateRender=w(r.immediateRender),this.staggerTo(t,e,r,i,n,a,s)},e.staggerFromTo=function staggerFromTo(t,e,r,i,n,a,s,o){return i.startAt=r,va(i).immediateRender=w(i.immediateRender),this.staggerTo(t,e,i,n,a,s,o)},e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_=this._time,m=this._dirty?this.totalDuration():this._tDur,g=this._dur,v=t<=0?0:ja(t),y=this._zTime<0!=t<0&&(this._initted||!g);if(this!==I&&m<v&&0<=t&&(v=m),v!==this._tTime||r||y){if(_!==this._time&&g&&(v+=this._time-_,t+=this._time-_),i=v,f=this._start,u=!(l=this._ts),y&&(g||(_=this._zTime),!t&&e||(this._zTime=t)),this._repeat){if(c=this._yoyo,o=g+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*o+t,e,r);if(i=ja(v%o),v===m?(s=this._repeat,i=g):((s=~~(v/o))&&s===v/o&&(i=g,s--),g<i&&(i=g)),d=Tt(this._tTime,o),!_&&this._tTime&&d!==s&&this._tTime-d*o-this._dur<=0&&(d=s),c&&1&s&&(i=g-i,p=1),s!==d&&!this._lock){var T=c&&1&d,b=T===(c&&1&s);if(s<d&&(T=!T),_=T?0:v%g?g:v,this._lock=1,this.render(_||(p?0:ja(s*o)),e,!g)._lock=0,this._tTime=v,!e&&this.parent&&Ct(this,"onRepeat"),this.vars.repeatRefresh&&!p&&(this.invalidate()._lock=1),_&&_!==this._time||u!=!this._ts||this.vars.onRepeat&&!this.parent&&!this._act)return this;if(g=this._dur,m=this._tDur,b&&(this._lock=2,_=T?g:-1e-4,this.render(_,!0),this.vars.repeatRefresh&&!p&&this.invalidate()),this._lock=0,!this._ts&&!u)return this;Qb(this,p)}}if(this._hasPause&&!this._forcing&&this._lock<2&&(h=function _findNextPauseTween(t,e,r){var i;if(e<r)for(i=t._first;i&&i._start<=r;){if("isPause"===i.data&&i._start>e)return i;i=i._next}else for(i=t._last;i&&i._start>=r;){if("isPause"===i.data&&i._start<e)return i;i=i._prev}}(this,ja(_),ja(i)))&&(v-=i-(i=h._start)),this._tTime=v,this._time=i,this._act=!l,this._initted||(this._onUpdate=this.vars.onUpdate,this._initted=1,this._zTime=t,_=0),!_&&i&&!e&&!s&&(Ct(this,"onStart"),this._tTime!==v))return this;if(_<=i&&0<=t)for(n=this._first;n;){if(a=n._next,(n._act||i>=n._start)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(i-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(i-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=-X);break}}n=a}else{n=this._last;for(var w=t<0?t:i;n;){if(a=n._prev,(n._act||w<=n._end)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(w-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(w-n._start)*n._ts,e,r||L&&(n._initted||n._startAt)),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=w?-X:X);break}}n=a}}if(h&&!e&&(this.pause(),h.render(_<=i?0:-X)._zTime=_<=i?1:-1,this._ts))return this._start=f,Ha(this),this.render(t,e,r);this._onUpdate&&!e&&Ct(this,"onUpdate",!0),(v===m&&this._tTime>=this.totalDuration()||!v&&_)&&(f!==this._start&&Math.abs(l)===Math.abs(this._ts)||this._lock||(!t&&g||!(v===m&&0<this._ts||!v&&this._ts<0)||za(this,1),e||t<0&&!_||!v&&!_&&m||(Ct(this,v===m&&0<=t?"onComplete":"onReverseComplete",!0),!this._prom||v<m&&0<this.timeScale()||this._prom())))}return this},e.add=function add(e,i){var n=this;if(t(i)||(i=xt(this,i,e)),!(e instanceof Ut)){if(Z(e))return e.forEach(function(t){return n.add(t,i)}),this;if(r(e))return this.addLabel(e,i);if(!s(e))return this;e=$t.delayedCall(0,e)}return this!==e?Ka(this,e,i):this},e.getChildren=function getChildren(t,e,r,i){void 0===t&&(t=!0),void 0===e&&(e=!0),void 0===r&&(r=!0),void 0===i&&(i=-U);for(var n=[],a=this._first;a;)a._start>=i&&(a instanceof $t?e&&n.push(a):(r&&n.push(a),t&&n.push.apply(n,a.getChildren(!0,e,r)))),a=a._next;return n},e.getById=function getById(t){for(var e=this.getChildren(1,1,1),r=e.length;r--;)if(e[r].vars.id===t)return e[r]},e.remove=function remove(t){return r(t)?this.removeLabel(t):s(t)?this.killTweensOf(t):(ya(this,t),t===this._recent&&(this._recent=this._last),Aa(this))},e.totalTime=function totalTime(t,e){return arguments.length?(this._forcing=1,!this._dp&&this._ts&&(this._start=ja(Rt.time-(0<this._ts?t/this._ts:(this.totalDuration()-t)/-this._ts))),i.prototype.totalTime.call(this,t,e),this._forcing=0,this):this._tTime},e.addLabel=function addLabel(t,e){return this.labels[t]=xt(this,e),this},e.removeLabel=function removeLabel(t){return delete this.labels[t],this},e.addPause=function addPause(t,e,r){var i=$t.delayedCall(0,e||T,r);return i.data="isPause",this._hasPause=1,Ka(this,i,xt(this,t))},e.removePause=function removePause(t){var e=this._first;for(t=xt(this,t);e;)e._start===t&&"isPause"===e.data&&za(e),e=e._next},e.killTweensOf=function killTweensOf(t,e,r){for(var i=this.getTweensOf(t,r),n=i.length;n--;)Nt!==i[n]&&i[n].kill(t,e);return this},e.getTweensOf=function getTweensOf(e,r){for(var i,n=[],a=Mt(e),s=this._first,o=t(r);s;)s instanceof $t?la(s._targets,a)&&(o?(!Nt||s._initted&&s._ts)&&s.globalTime(0)<=r&&s.globalTime(s.totalDuration())>r:!r||s.isActive())&&n.push(s):(i=s.getTweensOf(a,r)).length&&n.push.apply(n,i),s=s._next;return n},e.tweenTo=function tweenTo(t,e){e=e||{};var r,i=this,n=xt(i,t),a=e.startAt,s=e.onStart,o=e.onStartParams,u=e.immediateRender,h=$t.to(i,qa({ease:e.ease||"none",lazy:!1,immediateRender:!1,time:n,overwrite:"auto",duration:e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale())||X,onStart:function onStart(){if(i.pause(),!r){var t=e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale());h._dur!==t&&Ra(h,t,0,1).render(h._time,!0,!0),r=1}s&&s.apply(h,o||[])}},e));return u?h.render(0):h},e.tweenFromTo=function tweenFromTo(t,e,r){return this.tweenTo(e,qa({startAt:{time:xt(this,t)}},r))},e.recent=function recent(){return this._recent},e.nextLabel=function nextLabel(t){return void 0===t&&(t=this._time),rb(this,xt(this,t))},e.previousLabel=function previousLabel(t){return void 0===t&&(t=this._time),rb(this,xt(this,t),1)},e.currentLabel=function currentLabel(t){return arguments.length?this.seek(t,!0):this.previousLabel(this._time+X)},e.shiftChildren=function shiftChildren(t,e,r){void 0===r&&(r=0);for(var i,n=this._first,a=this.labels;n;)n._start>=r&&(n._start+=t,n._end+=t),n=n._next;if(e)for(i in a)a[i]>=r&&(a[i]+=t);return Aa(this)},e.invalidate=function invalidate(t){var e=this._first;for(this._lock=0;e;)e.invalidate(t),e=e._next;return i.prototype.invalidate.call(this,t)},e.clear=function clear(t){void 0===t&&(t=!0);for(var e,r=this._first;r;)e=r._next,this.remove(r),r=e;return this._dp&&(this._time=this._tTime=this._pTime=0),t&&(this.labels={}),Aa(this)},e.totalDuration=function totalDuration(t){var e,r,i,n=0,a=this,s=a._last,o=U;if(arguments.length)return a.timeScale((a._repeat<0?a.duration():a.totalDuration())/(a.reversed()?-t:t));if(a._dirty){for(i=a.parent;s;)e=s._prev,s._dirty&&s.totalDuration(),o<(r=s._start)&&a._sort&&s._ts&&!a._lock?(a._lock=1,Ka(a,s,r-s._delay,1)._lock=0):o=r,r<0&&s._ts&&(n-=r,(!i&&!a._dp||i&&i.smoothChildTiming)&&(a._start+=r/a._ts,a._time-=r,a._tTime-=r),a.shiftChildren(-r,!1,-Infinity),o=0),s._end>n&&s._ts&&(n=s._end),s=e;Ra(a,a===I&&a._time>n?a._time:n,1,1),a._dirty=0}return a._tDur},Timeline.updateRoot=function updateRoot(t){if(I._ts&&(na(I,Ga(t,I)),f=Rt.frame),Rt.frame>=mt){mt+=q.autoSleep||120;var e=I._first;if((!e||!e._ts)&&q.autoSleep&&Rt._listeners.length<2){for(;e&&!e._ts;)e=e._next;e||Rt.sleep()}}},Timeline}(Ut);qa(Xt.prototype,{_lock:0,_hasPause:0,_forcing:0});function ac(t,e,i,n,a,o){var u,h,l,f;if(pt[t]&&!1!==(u=new pt[t]).init(a,u.rawVars?e[t]:function _processVars(t,e,i,n,a){if(s(t)&&(t=Kt(t,a,e,i,n)),!v(t)||t.style&&t.nodeType||Z(t)||$(t))return r(t)?Kt(t,a,e,i,n):t;var o,u={};for(o in t)u[o]=Kt(t[o],a,e,i,n);return u}(e[t],n,a,o,i),i,n,o)&&(i._pt=h=new _e(i._pt,a,t,0,1,u.render,u,0,u.priority),i!==d))for(l=i._ptLookup[i._targets.indexOf(a)],f=u._props.length;f--;)l[u._props[f]]=h;return u}function gc(t,r,e,i){var n,a,s=r.ease||i||"power1.inOut";if(Z(r))a=e[t]||(e[t]=[]),r.forEach(function(t,e){return a.push({t:e/(r.length-1)*100,v:t,e:s})});else for(n in r)a=e[n]||(e[n]=[]),"ease"===n||a.push({t:parseFloat(t),v:r[n],e:s})}var Nt,Gt,Wt=function _addPropTween(t,e,i,n,a,o,u,h,l,f){s(n)&&(n=n(a||0,t,o));var d,c=t[e],p="get"!==i?i:s(c)?l?t[e.indexOf("set")||!s(t["get"+e.substr(3)])?e:"get"+e.substr(3)](l):t[e]():c,_=s(c)?l?re:te:Zt;if(r(n)&&(~n.indexOf("random(")&&(n=ob(n)),"="===n.charAt(1)&&(!(d=ka(p,n)+(Ya(p)||0))&&0!==d||(n=d))),!f||p!==n||Gt)return isNaN(p*n)||""===n?(c||e in t||Q(e,n),function _addComplexStringPropTween(t,e,r,i,n,a,s){var o,u,h,l,f,d,c,p,_=new _e(this._pt,t,e,0,1,ue,null,n),m=0,g=0;for(_.b=r,_.e=i,r+="",(c=~(i+="").indexOf("random("))&&(i=ob(i)),a&&(a(p=[r,i],t,e),r=p[0],i=p[1]),u=r.match(it)||[];o=it.exec(i);)l=o[0],f=i.substring(m,o.index),h?h=(h+1)%5:"rgba("===f.substr(-5)&&(h=1),l!==u[g++]&&(d=parseFloat(u[g-1])||0,_._pt={_next:_._pt,p:f||1===g?f:",",s:d,c:"="===l.charAt(1)?ka(d,l)-d:parseFloat(l)-d,m:h&&h<4?Math.round:0},m=it.lastIndex);return _.c=m<i.length?i.substring(m,i.length):"",_.fp=s,(nt.test(i)||c)&&(_.e=0),this._pt=_}.call(this,t,e,p,n,_,h||q.stringFilter,l)):(d=new _e(this._pt,t,e,+p||0,n-(p||0),"boolean"==typeof c?se:ae,0,_),l&&(d.fp=l),u&&d.modifier(u,this,t),this._pt=d)},Qt=function _initTween(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_,m=t.vars,g=m.ease,v=m.startAt,y=m.immediateRender,T=m.lazy,b=m.onUpdate,x=m.runBackwards,O=m.yoyoEase,k=m.keyframes,M=m.autoRevert,P=t._dur,C=t._startAt,A=t._targets,S=t.parent,z=S&&"nested"===S.data?S.vars.targets:A,E="auto"===t._overwrite&&!F,D=t.timeline;if(!D||k&&g||(g="none"),t._ease=jt(g,V.ease),t._yEase=O?Yt(jt(!0===O?g:O,V.ease)):0,O&&t._yoyo&&!t._repeat&&(O=t._yEase,t._yEase=t._ease,t._ease=O),t._from=!D&&!!m.runBackwards,!D||k&&!m.stagger){if(p=(l=A[0]?fa(A[0]).harness:0)&&m[l.prop],i=ua(m,ft),C&&(C._zTime<0&&C.progress(1),e<0&&x&&y&&!M?C.render(-1,!0):C.revert(x&&P?ht:ut),C._lazy=0),v){if(za(t._startAt=$t.set(A,qa({data:"isStart",overwrite:!1,parent:S,immediateRender:!0,lazy:!C&&w(T),startAt:null,delay:0,onUpdate:b&&function(){return Ct(t,"onUpdate")},stagger:0},v))),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L||!y&&!M)&&t._startAt.revert(ht),y&&P&&e<=0&&r<=0)return void(e&&(t._zTime=e))}else if(x&&P&&!C)if(e&&(y=!1),a=qa({overwrite:!1,data:"isFromStart",lazy:y&&!C&&w(T),immediateRender:y,stagger:0,parent:S},i),p&&(a[l.prop]=p),za(t._startAt=$t.set(A,a)),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L?t._startAt.revert(ht):t._startAt.render(-1,!0)),t._zTime=e,y){if(!e)return}else _initTween(t._startAt,X,X);for(t._pt=t._ptCache=0,T=P&&w(T)||T&&!P,n=0;n<A.length;n++){if(h=(o=A[n])._gsap||ea(A)[n]._gsap,t._ptLookup[n]=d={},ct[h.id]&&dt.length&&ma(),c=z===A?n:z.indexOf(o),l&&!1!==(f=new l).init(o,p||i,t,c,z)&&(t._pt=s=new _e(t._pt,o,f.name,0,1,f.render,f,0,f.priority),f._props.forEach(function(t){d[t]=s}),f.priority&&(u=1)),!l||p)for(a in i)pt[a]&&(f=ac(a,i,t,c,o,z))?f.priority&&(u=1):d[a]=s=Wt.call(t,o,a,"get",i[a],c,z,0,m.stringFilter);t._op&&t._op[n]&&t.kill(o,t._op[n]),E&&t._pt&&(Nt=t,I.killTweensOf(o,d,t.globalTime(e)),_=!t.parent,Nt=0),t._pt&&T&&(ct[h.id]=1)}u&&pe(t),t._onInit&&t._onInit(t)}t._onUpdate=b,t._initted=(!t._op||t._pt)&&!_,k&&e<=0&&D.render(U,!0,!0)},Kt=function _parseFuncOrString(t,e,i,n,a){return s(t)?t.call(e,i,n,a):r(t)&&~t.indexOf("random(")?ob(t):t},Jt=vt+"repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",Ht={};ha(Jt+",id,stagger,delay,duration,paused,scrollTrigger",function(t){return Ht[t]=1});var $t=function(D){function Tween(e,r,i,n){var a;"number"==typeof r&&(i.duration=r,r=i,i=null);var s,o,u,h,l,f,d,c,p=(a=D.call(this,n?r:va(r))||this).vars,_=p.duration,m=p.delay,g=p.immediateRender,T=p.stagger,b=p.overwrite,x=p.keyframes,O=p.defaults,k=p.scrollTrigger,M=p.yoyoEase,P=r.parent||I,C=(Z(e)||$(e)?t(e[0]):"length"in r)?[e]:Mt(e);if(a._targets=C.length?ea(C):R("GSAP target "+e+" not found. https://gsap.com",!q.nullTargetWarn)||[],a._ptLookup=[],a._overwrite=b,x||T||y(_)||y(m)){if(r=a.vars,(s=a.timeline=new Xt({data:"nested",defaults:O||{},targets:P&&"nested"===P.data?P.vars.targets:C})).kill(),s.parent=s._dp=_assertThisInitialized(a),s._start=0,T||y(_)||y(m)){if(h=C.length,d=T&&eb(T),v(T))for(l in T)~Jt.indexOf(l)&&((c=c||{})[l]=T[l]);for(o=0;o<h;o++)(u=ua(r,Ht)).stagger=0,M&&(u.yoyoEase=M),c&&yt(u,c),f=C[o],u.duration=+Kt(_,_assertThisInitialized(a),o,f,C),u.delay=(+Kt(m,_assertThisInitialized(a),o,f,C)||0)-a._delay,!T&&1===h&&u.delay&&(a._delay=m=u.delay,a._start+=m,u.delay=0),s.to(f,u,d?d(o,f,C):0),s._ease=Lt.none;s.duration()?_=m=0:a.timeline=0}else if(x){va(qa(s.vars.defaults,{ease:"none"})),s._ease=jt(x.ease||r.ease||"none");var A,S,z,E=0;if(Z(x))x.forEach(function(t){return s.to(C,t,">")}),s.duration();else{for(l in u={},x)"ease"===l||"easeEach"===l||gc(l,x[l],u,x.easeEach);for(l in u)for(A=u[l].sort(function(t,e){return t.t-e.t}),o=E=0;o<A.length;o++)(z={ease:(S=A[o]).e,duration:(S.t-(o?A[o-1].t:0))/100*_})[l]=S.v,s.to(C,z,E),E+=z.duration;s.duration()<_&&s.to({},{duration:_-s.duration()})}}_||a.duration(_=s.duration())}else a.timeline=0;return!0!==b||F||(Nt=_assertThisInitialized(a),I.killTweensOf(C),Nt=0),Ka(P,_assertThisInitialized(a),i),r.reversed&&a.reverse(),r.paused&&a.paused(!0),(g||!_&&!x&&a._start===ja(P._time)&&w(g)&&function _hasNoPausedAncestors(t){return!t||t._ts&&_hasNoPausedAncestors(t.parent)}(_assertThisInitialized(a))&&"nested"!==P.data)&&(a._tTime=-X,a.render(Math.max(0,-m)||0)),k&&La(_assertThisInitialized(a),k),a}_inheritsLoose(Tween,D);var e=Tween.prototype;return e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d=this._time,c=this._tDur,p=this._dur,_=t<0,m=c-X<t&&!_?c:t<X?0:t;if(p){if(m!==this._tTime||!t||r||!this._initted&&this._tTime||this._startAt&&this._zTime<0!=_){if(i=m,l=this.timeline,this._repeat){if(s=p+this._rDelay,this._repeat<-1&&_)return this.totalTime(100*s+t,e,r);if(i=ja(m%s),m===c?(a=this._repeat,i=p):((a=~~(m/s))&&a===ja(m/s)&&(i=p,a--),p<i&&(i=p)),(u=this._yoyo&&1&a)&&(f=this._yEase,i=p-i),o=Tt(this._tTime,s),i===d&&!r&&this._initted&&a===o)return this._tTime=m,this;a!==o&&(l&&this._yEase&&Qb(l,u),this.vars.repeatRefresh&&!u&&!this._lock&&this._time!==s&&this._initted&&(this._lock=r=1,this.render(ja(s*a),!0).invalidate()._lock=0))}if(!this._initted){if(Ma(this,_?t:i,r,e,m))return this._tTime=0,this;if(!(d===this._time||r&&this.vars.repeatRefresh&&a!==o))return this;if(p!==this._dur)return this.render(t,e,r)}if(this._tTime=m,this._time=i,!this._act&&this._ts&&(this._act=1,this._lazy=0),this.ratio=h=(f||this._ease)(i/p),this._from&&(this.ratio=h=1-h),i&&!d&&!e&&!a&&(Ct(this,"onStart"),this._tTime!==m))return this;for(n=this._pt;n;)n.r(h,n.d),n=n._next;l&&l.render(t<0?t:l._dur*l._ease(i/this._dur),e,r)||this._startAt&&(this._zTime=t),this._onUpdate&&!e&&(_&&Ca(this,t,0,r),Ct(this,"onUpdate")),this._repeat&&a!==o&&this.vars.onRepeat&&!e&&this.parent&&Ct(this,"onRepeat"),m!==this._tDur&&m||this._tTime!==m||(_&&!this._onUpdate&&Ca(this,t,0,!0),!t&&p||!(m===this._tDur&&0<this._ts||!m&&this._ts<0)||za(this,1),e||_&&!d||!(m||d||u)||(Ct(this,m===c?"onComplete":"onReverseComplete",!0),!this._prom||m<c&&0<this.timeScale()||this._prom()))}}else!function _renderZeroDurationTween(t,e,r,i){var n,a,s,o=t.ratio,u=e<0||!e&&(!t._start&&function _parentPlayheadIsBeforeStart(t){var e=t.parent;return e&&e._ts&&e._initted&&!e._lock&&(e.rawTime()<0||_parentPlayheadIsBeforeStart(e))}(t)&&(t._initted||!bt(t))||(t._ts<0||t._dp._ts<0)&&!bt(t))?0:1,h=t._rDelay,l=0;if(h&&t._repeat&&(l=Ot(0,t._tDur,e),a=Tt(l,h),t._yoyo&&1&a&&(u=1-u),a!==Tt(t._tTime,h)&&(o=1-u,t.vars.repeatRefresh&&t._initted&&t.invalidate())),u!==o||L||i||t._zTime===X||!e&&t._zTime){if(!t._initted&&Ma(t,e,i,r,l))return;for(s=t._zTime,t._zTime=e||(r?X:0),r=r||e&&!s,t.ratio=u,t._from&&(u=1-u),t._time=0,t._tTime=l,n=t._pt;n;)n.r(u,n.d),n=n._next;e<0&&Ca(t,e,0,!0),t._onUpdate&&!r&&Ct(t,"onUpdate"),l&&t._repeat&&!r&&t.parent&&Ct(t,"onRepeat"),(e>=t._tDur||e<0)&&t.ratio===u&&(u&&za(t,1),r||L||(Ct(t,u?"onComplete":"onReverseComplete",!0),t._prom&&t._prom()))}else t._zTime||(t._zTime=e)}(this,t,e,r);return this},e.targets=function targets(){return this._targets},e.invalidate=function invalidate(t){return t&&this.vars.runBackwards||(this._startAt=0),this._pt=this._op=this._onUpdate=this._lazy=this.ratio=0,this._ptLookup=[],this.timeline&&this.timeline.invalidate(t),D.prototype.invalidate.call(this,t)},e.resetTo=function resetTo(t,e,r,i,n){c||Rt.wake(),this._ts||this.play();var a,s=Math.min(this._dur,(this._dp._time-this._start)*this._ts);return this._initted||Qt(this,s),a=this._ease(s/this._dur),function _updatePropTweens(t,e,r,i,n,a,s,o){var u,h,l,f,d=(t._pt&&t._ptCache||(t._ptCache={}))[e];if(!d)for(d=t._ptCache[e]=[],l=t._ptLookup,f=t._targets.length;f--;){if((u=l[f][e])&&u.d&&u.d._pt)for(u=u.d._pt;u&&u.p!==e&&u.fp!==e;)u=u._next;if(!u)return Gt=1,t.vars[e]="+=0",Qt(t,s),Gt=0,o?R(e+" not eligible for reset"):1;d.push(u)}for(f=d.length;f--;)(u=(h=d[f])._pt||h).s=!i&&0!==i||n?u.s+(i||0)+a*u.c:i,u.c=r-u.s,h.e&&(h.e=ia(r)+Ya(h.e)),h.b&&(h.b=u.s+Ya(h.b))}(this,t,e,r,i,a,s,n)?this.resetTo(t,e,r,i,1):(Ia(this,0),this.parent||xa(this._dp,this,"_first","_last",this._dp._sort?"_start":0),this.render(0))},e.kill=function kill(t,e){if(void 0===e&&(e="all"),!(t||e&&"all"!==e))return this._lazy=this._pt=0,this.parent?tb(this):this;if(this.timeline){var i=this.timeline.totalDuration();return this.timeline.killTweensOf(t,e,Nt&&!0!==Nt.vars.overwrite)._first||tb(this),this.parent&&i!==this.timeline.totalDuration()&&Ra(this,this._dur*this.timeline._tDur/i,0,1),this}var n,a,s,o,u,h,l,f=this._targets,d=t?Mt(t):f,c=this._ptLookup,p=this._pt;if((!e||"all"===e)&&function _arraysMatch(t,e){for(var r=t.length,i=r===e.length;i&&r--&&t[r]===e[r];);return r<0}(f,d))return"all"===e&&(this._pt=0),tb(this);for(n=this._op=this._op||[],"all"!==e&&(r(e)&&(u={},ha(e,function(t){return u[t]=1}),e=u),e=function _addAliasesToVars(t,e){var r,i,n,a,s=t[0]?fa(t[0]).harness:0,o=s&&s.aliases;if(!o)return e;for(i in r=yt({},e),o)if(i in r)for(n=(a=o[i].split(",")).length;n--;)r[a[n]]=r[i];return r}(f,e)),l=f.length;l--;)if(~d.indexOf(f[l]))for(u in a=c[l],"all"===e?(n[l]=e,o=a,s={}):(s=n[l]=n[l]||{},o=e),o)(h=a&&a[u])&&("kill"in h.d&&!0!==h.d.kill(u)||ya(this,h,"_pt"),delete a[u]),"all"!==s&&(s[u]=1);return this._initted&&!this._pt&&p&&tb(this),this},Tween.to=function to(t,e,r){return new Tween(t,e,r)},Tween.from=function from(t,e){return Va(1,arguments)},Tween.delayedCall=function delayedCall(t,e,r,i){return new Tween(e,0,{immediateRender:!1,lazy:!1,overwrite:!1,delay:t,onComplete:e,onReverseComplete:e,onCompleteParams:r,onReverseCompleteParams:r,callbackScope:i})},Tween.fromTo=function fromTo(t,e,r){return Va(2,arguments)},Tween.set=function set(t,e){return e.duration=0,e.repeatDelay||(e.repeat=0),new Tween(t,e)},Tween.killTweensOf=function killTweensOf(t,e,r){return I.killTweensOf(t,e,r)},Tween}(Ut);qa($t.prototype,{_targets:[],_lazy:0,_startAt:0,_op:0,_onInit:0}),ha("staggerTo,staggerFrom,staggerFromTo",function(r){$t[r]=function(){var t=new Xt,e=kt.call(arguments,0);return e.splice("staggerFromTo"===r?5:4,0,0),t[r].apply(t,e)}});function oc(t,e,r){return t.setAttribute(e,r)}function wc(t,e,r,i){i.mSet(t,e,i.m.call(i.tween,r,i.mt),i)}var Zt=function _setterPlain(t,e,r){return t[e]=r},te=function _setterFunc(t,e,r){return t[e](r)},re=function _setterFuncWithParam(t,e,r,i){return t[e](i.fp,r)},ne=function _getSetter(t,e){return s(t[e])?te:u(t[e])&&t.setAttribute?oc:Zt},ae=function _renderPlain(t,e){return e.set(e.t,e.p,Math.round(1e6*(e.s+e.c*t))/1e6,e)},se=function _renderBoolean(t,e){return e.set(e.t,e.p,!!(e.s+e.c*t),e)},ue=function _renderComplexString(t,e){var r=e._pt,i="";if(!t&&e.b)i=e.b;else if(1===t&&e.e)i=e.e;else{for(;r;)i=r.p+(r.m?r.m(r.s+r.c*t):Math.round(1e4*(r.s+r.c*t))/1e4)+i,r=r._next;i+=e.c}e.set(e.t,e.p,i,e)},he=function _renderPropTweens(t,e){for(var r=e._pt;r;)r.r(t,r.d),r=r._next},fe=function _addPluginModifier(t,e,r,i){for(var n,a=this._pt;a;)n=a._next,a.p===i&&a.modifier(t,e,r),a=n},ce=function _killPropTweensOf(t){for(var e,r,i=this._pt;i;)r=i._next,i.p===t&&!i.op||i.op===t?ya(this,i,"_pt"):i.dep||(e=1),i=r;return!e},pe=function _sortPropTweensByPriority(t){for(var e,r,i,n,a=t._pt;a;){for(e=a._next,r=i;r&&r.pr>a.pr;)r=r._next;(a._prev=r?r._prev:n)?a._prev._next=a:i=a,(a._next=r)?r._prev=a:n=a,a=e}t._pt=i},_e=(PropTween.prototype.modifier=function modifier(t,e,r){this.mSet=this.mSet||this.set,this.set=wc,this.m=t,this.mt=r,this.tween=e},PropTween);function PropTween(t,e,r,i,n,a,s,o,u){this.t=e,this.s=i,this.c=n,this.p=r,this.r=a||ae,this.d=s||this,this.set=o||Zt,this.pr=u||0,(this._next=t)&&(t._prev=this)}ha(vt+"parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",function(t){return ft[t]=1}),ot.TweenMax=ot.TweenLite=$t,ot.TimelineLite=ot.TimelineMax=Xt,I=new Xt({sortChildren:!1,defaults:V,autoRemoveChildren:!0,id:"root",smoothChildTiming:!0}),q.stringFilter=Fb;function Ec(t){return(ye[t]||Te).map(function(t){return t()})}function Fc(){var t=Date.now(),o=[];2<t-Oe&&(Ec("matchMediaInit"),ge.forEach(function(t){var e,r,i,n,a=t.queries,s=t.conditions;for(r in a)(e=h.matchMedia(a[r]).matches)&&(i=1),e!==s[r]&&(s[r]=e,n=1);n&&(t.revert(),i&&o.push(t))}),Ec("matchMediaRevert"),o.forEach(function(e){return e.onMatch(e,function(t){return e.add(null,t)})}),Oe=t,Ec("matchMedia"))}var me,ge=[],ye={},Te=[],Oe=0,Me=0,Pe=((me=Context.prototype).add=function add(t,i,n){function Gw(){var t,e=l,r=a.selector;return e&&e!==a&&e.data.push(a),n&&(a.selector=cb(n)),l=a,t=i.apply(a,arguments),s(t)&&a._r.push(t),l=e,a.selector=r,a.isReverted=!1,t}s(t)&&(n=i,i=t,t=s);var a=this;return a.last=Gw,t===s?Gw(a,function(t){return a.add(null,t)}):t?a[t]=Gw:Gw},me.ignore=function ignore(t){var e=l;l=null,t(this),l=e},me.getTweens=function getTweens(){var e=[];return this.data.forEach(function(t){return t instanceof Context?e.push.apply(e,t.getTweens()):t instanceof $t&&!(t.parent&&"nested"===t.parent.data)&&e.push(t)}),e},me.clear=function clear(){this._r.length=this.data.length=0},me.kill=function kill(i,t){var n=this;if(i?function(){for(var t,e=n.getTweens(),r=n.data.length;r--;)"isFlip"===(t=n.data[r]).data&&(t.revert(),t.getChildren(!0,!0,!1).forEach(function(t){return e.splice(e.indexOf(t),1)}));for(e.map(function(t){return{g:t._dur||t._delay||t._sat&&!t._sat.vars.immediateRender?t.globalTime(0):-1/0,t:t}}).sort(function(t,e){return e.g-t.g||-1/0}).forEach(function(t){return t.t.revert(i)}),r=n.data.length;r--;)(t=n.data[r])instanceof Xt?"nested"!==t.data&&(t.scrollTrigger&&t.scrollTrigger.revert(),t.kill()):t instanceof $t||!t.revert||t.revert(i);n._r.forEach(function(t){return t(i,n)}),n.isReverted=!0}():this.data.forEach(function(t){return t.kill&&t.kill()}),this.clear(),t)for(var e=ge.length;e--;)ge[e].id===this.id&&ge.splice(e,1)},me.revert=function revert(t){this.kill(t||{})},Context);function Context(t,e){this.selector=e&&cb(e),this.data=[],this._r=[],this.isReverted=!1,this.id=Me++,t&&this.add(t)}var Ce,Ae=((Ce=MatchMedia.prototype).add=function add(t,e,r){v(t)||(t={matches:t});var i,n,a,s=new Pe(0,r||this.scope),o=s.conditions={};for(n in l&&!s.selector&&(s.selector=l.selector),this.contexts.push(s),e=s.add("onMatch",e),s.queries=t)"all"===n?a=1:(i=h.matchMedia(t[n]))&&(ge.indexOf(s)<0&&ge.push(s),(o[n]=i.matches)&&(a=1),i.addListener?i.addListener(Fc):i.addEventListener("change",Fc));return a&&e(s,function(t){return s.add(null,t)}),this},Ce.revert=function revert(t){this.kill(t||{})},Ce.kill=function kill(e){this.contexts.forEach(function(t){return t.kill(e,!0)})},MatchMedia);function MatchMedia(t){this.contexts=[],this.scope=t,l&&l.data.push(this)}var Se={registerPlugin:function registerPlugin(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];e.forEach(function(t){return wb(t)})},timeline:function timeline(t){return new Xt(t)},getTweensOf:function getTweensOf(t,e){return I.getTweensOf(t,e)},getProperty:function getProperty(i,t,e,n){r(i)&&(i=Mt(i)[0]);var a=fa(i||{}).get,s=e?pa:oa;return"native"===e&&(e=""),i?t?s((pt[t]&&pt[t].get||a)(i,t,e,n)):function(t,e,r){return s((pt[t]&&pt[t].get||a)(i,t,e,r))}:i},quickSetter:function quickSetter(r,e,i){if(1<(r=Mt(r)).length){var n=r.map(function(t){return ze.quickSetter(t,e,i)}),a=n.length;return function(t){for(var e=a;e--;)n[e](t)}}r=r[0]||{};var s=pt[e],o=fa(r),u=o.harness&&(o.harness.aliases||{})[e]||e,h=s?function(t){var e=new s;d._pt=0,e.init(r,i?t+i:t,d,0,[r]),e.render(1,e),d._pt&&he(1,d)}:o.set(r,u);return s?h:function(t){return h(r,u,i?t+i:t,o,1)}},quickTo:function quickTo(t,i,e){function $x(t,e,r){return n.resetTo(i,t,e,r)}var r,n=ze.to(t,yt(((r={})[i]="+=0.1",r.paused=!0,r),e||{}));return $x.tween=n,$x},isTweening:function isTweening(t){return 0<I.getTweensOf(t,!0).length},defaults:function defaults(t){return t&&t.ease&&(t.ease=jt(t.ease,V.ease)),ta(V,t||{})},config:function config(t){return ta(q,t||{})},registerEffect:function registerEffect(t){var i=t.name,n=t.effect,e=t.plugins,a=t.defaults,r=t.extendTimeline;(e||"").split(",").forEach(function(t){return t&&!pt[t]&&!ot[t]&&R(i+" effect requires "+t+" plugin.")}),_t[i]=function(t,e,r){return n(Mt(t),qa(e||{},a),r)},r&&(Xt.prototype[i]=function(t,e,r){return this.add(_t[i](t,v(e)?e:(r=e)&&{},this),r)})},registerEase:function registerEase(t,e){Lt[t]=jt(e)},parseEase:function parseEase(t,e){return arguments.length?jt(t,e):Lt},getById:function getById(t){return I.getById(t)},exportRoot:function exportRoot(t,e){void 0===t&&(t={});var r,i,n=new Xt(t);for(n.smoothChildTiming=w(t.smoothChildTiming),I.remove(n),n._dp=0,n._time=n._tTime=I._time,r=I._first;r;)i=r._next,!e&&!r._dur&&r instanceof $t&&r.vars.onComplete===r._targets[0]||Ka(n,r,r._start-r._delay),r=i;return Ka(I,n,0),n},context:function context(t,e){return t?new Pe(t,e):l},matchMedia:function matchMedia(t){return new Ae(t)},matchMediaRefresh:function matchMediaRefresh(){return ge.forEach(function(t){var e,r,i=t.conditions;for(r in i)i[r]&&(i[r]=!1,e=1);e&&t.revert()})||Fc()},addEventListener:function addEventListener(t,e){var r=ye[t]||(ye[t]=[]);~r.indexOf(e)||r.push(e)},removeEventListener:function removeEventListener(t,e){var r=ye[t],i=r&&r.indexOf(e);0<=i&&r.splice(i,1)},utils:{wrap:function wrap(e,t,r){var i=t-e;return Z(e)?lb(e,wrap(0,e.length),t):Wa(r,function(t){return(i+(t-e)%i)%i+e})},wrapYoyo:function wrapYoyo(e,t,r){var i=t-e,n=2*i;return Z(e)?lb(e,wrapYoyo(0,e.length-1),t):Wa(r,function(t){return e+(i<(t=(n+(t-e)%n)%n||0)?n-t:t)})},distribute:eb,random:hb,snap:gb,normalize:function normalize(t,e,r){return Pt(t,e,0,1,r)},getUnit:Ya,clamp:function clamp(e,r,t){return Wa(t,function(t){return Ot(e,r,t)})},splitColor:Ab,toArray:Mt,selector:cb,mapRange:Pt,pipe:function pipe(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return function(t){return e.reduce(function(t,e){return e(t)},t)}},unitize:function unitize(e,r){return function(t){return e(parseFloat(t))+(r||Ya(t))}},interpolate:function interpolate(e,i,t,n){var a=isNaN(e+i)?0:function(t){return(1-t)*e+t*i};if(!a){var s,o,u,h,l,f=r(e),d={};if(!0===t&&(n=1)&&(t=null),f)e={p:e},i={p:i};else if(Z(e)&&!Z(i)){for(u=[],h=e.length,l=h-2,o=1;o<h;o++)u.push(interpolate(e[o-1],e[o]));h--,a=function func(t){t*=h;var e=Math.min(l,~~t);return u[e](t-e)},t=i}else n||(e=yt(Z(e)?[]:{},e));if(!u){for(s in i)Wt.call(d,e,s,"get",i[s]);a=function func(t){return he(t,d)||(f?e.p:e)}}}return Wa(t,a)},shuffle:db},install:P,effects:_t,ticker:Rt,updateRoot:Xt.updateRoot,plugins:pt,globalTimeline:I,core:{PropTween:_e,globals:S,Tween:$t,Timeline:Xt,Animation:Ut,getCache:fa,_removeLinkedListItem:ya,reverting:function reverting(){return L},context:function context(t){return t&&l&&(l.data.push(t),t._ctx=l),l},suppressOverwrites:function suppressOverwrites(t){return F=t}}};ha("to,from,fromTo,delayedCall,set,killTweensOf",function(t){return Se[t]=$t[t]}),Rt.add(Xt.updateRoot),d=Se.to({},{duration:0});function Jc(t,e){for(var r=t._pt;r&&r.p!==e&&r.op!==e&&r.fp!==e;)r=r._next;return r}function Lc(t,a){return{name:t,rawVars:1,init:function init(t,n,e){e._onInit=function(t){var e,i;if(r(n)&&(e={},ha(n,function(t){return e[t]=1}),n=e),a){for(i in e={},n)e[i]=a(n[i]);n=e}!function _addModifiers(t,e){var r,i,n,a=t._targets;for(r in e)for(i=a.length;i--;)(n=(n=t._ptLookup[i][r])&&n.d)&&(n._pt&&(n=Jc(n,r)),n&&n.modifier&&n.modifier(e[r],t,a[i],r))}(t,n)}}}}var ze=Se.registerPlugin({name:"attr",init:function init(t,e,r,i,n){var a,s,o;for(a in this.tween=r,e)o=t.getAttribute(a)||"",(s=this.add(t,"setAttribute",(o||0)+"",e[a],i,n,0,0,a)).op=a,s.b=o,this._props.push(a)},render:function render(t,e){for(var r=e._pt;r;)L?r.set(r.t,r.p,r.b,r):r.r(t,r.d),r=r._next}},{name:"endArray",init:function init(t,e){for(var r=e.length;r--;)this.add(t,r,t[r]||0,e[r],0,0,0,0,0,1)}},Lc("roundProps",fb),Lc("modifiers"),Lc("snap",gb))||Se;$t.version=Xt.version=ze.version="3.12.5",o=1,x()&&Ft();function vd(t,e){return e.set(e.t,e.p,Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function wd(t,e){return e.set(e.t,e.p,1===t?e.e:Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function xd(t,e){return e.set(e.t,e.p,t?Math.round(1e4*(e.s+e.c*t))/1e4+e.u:e.b,e)}function yd(t,e){var r=e.s+e.c*t;e.set(e.t,e.p,~~(r+(r<0?-.5:.5))+e.u,e)}function zd(t,e){return e.set(e.t,e.p,t?e.e:e.b,e)}function Ad(t,e){return e.set(e.t,e.p,1!==t?e.b:e.e,e)}function Bd(t,e,r){return t.style[e]=r}function Cd(t,e,r){return t.style.setProperty(e,r)}function Dd(t,e,r){return t._gsap[e]=r}function Ed(t,e,r){return t._gsap.scaleX=t._gsap.scaleY=r}function Fd(t,e,r,i,n){var a=t._gsap;a.scaleX=a.scaleY=r,a.renderTransform(n,a)}function Gd(t,e,r,i,n){var a=t._gsap;a[e]=r,a.renderTransform(n,a)}function Jd(t,e){var r=this,i=this.target,n=i.style,a=i._gsap;if(t in ar&&n){if(this.tfm=this.tfm||{},"transform"===t)return dr.transform.split(",").forEach(function(t){return Jd.call(r,t,e)});if(~(t=dr[t]||t).indexOf(",")?t.split(",").forEach(function(t){return r.tfm[t]=yr(i,t)}):this.tfm[t]=a.x?a[t]:yr(i,t),t===pr&&(this.tfm.zOrigin=a.zOrigin),0<=this.props.indexOf(cr))return;a.svg&&(this.svgo=i.getAttribute("data-svg-origin"),this.props.push(pr,e,"")),t=cr}(n||e)&&this.props.push(t,e,n[t])}function Kd(t){t.translate&&(t.removeProperty("translate"),t.removeProperty("scale"),t.removeProperty("rotate"))}function Ld(){var t,e,r=this.props,i=this.target,n=i.style,a=i._gsap;for(t=0;t<r.length;t+=3)r[t+1]?i[r[t]]=r[t+2]:r[t+2]?n[r[t]]=r[t+2]:n.removeProperty("--"===r[t].substr(0,2)?r[t]:r[t].replace(hr,"-$1").toLowerCase());if(this.tfm){for(e in this.tfm)a[e]=this.tfm[e];a.svg&&(a.renderTransform(),i.setAttribute("data-svg-origin",this.svgo||"")),(t=Be())&&t.isStart||n[cr]||(Kd(n),a.zOrigin&&n[pr]&&(n[pr]+=" "+a.zOrigin+"px",a.zOrigin=0,a.renderTransform()),a.uncache=1)}}function Md(t,e){var r={target:t,props:[],revert:Ld,save:Jd};return t._gsap||ze.core.getCache(t),e&&e.split(",").forEach(function(t){return r.save(t)}),r}function Od(t,e){var r=De.createElementNS?De.createElementNS((e||"http://www.w3.org/1999/xhtml").replace(/^https/,"http"),t):De.createElement(t);return r&&r.style?r:De.createElement(t)}function Pd(t,e,r){var i=getComputedStyle(t);return i[e]||i.getPropertyValue(e.replace(hr,"-$1").toLowerCase())||i.getPropertyValue(e)||!r&&Pd(t,mr(e)||e,1)||""}function Sd(){(function _windowExists(){return"undefined"!=typeof window})()&&window.document&&(Ee=window,De=Ee.document,Re=De.documentElement,Le=Od("div")||{style:{}},Od("div"),cr=mr(cr),pr=cr+"Origin",Le.style.cssText="border-width:0;line-height:0;position:absolute;padding:0",Ye=!!mr("perspective"),Be=ze.core.reverting,Fe=1)}function Td(t){var e,r=Od("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),i=this.parentNode,n=this.nextSibling,a=this.style.cssText;if(Re.appendChild(r),r.appendChild(this),this.style.display="block",t)try{e=this.getBBox(),this._gsapBBox=this.getBBox,this.getBBox=Td}catch(t){}else this._gsapBBox&&(e=this._gsapBBox());return i&&(n?i.insertBefore(this,n):i.appendChild(this)),Re.removeChild(r),this.style.cssText=a,e}function Ud(t,e){for(var r=e.length;r--;)if(t.hasAttribute(e[r]))return t.getAttribute(e[r])}function Vd(e){var r;try{r=e.getBBox()}catch(t){r=Td.call(e,!0)}return r&&(r.width||r.height)||e.getBBox===Td||(r=Td.call(e,!0)),!r||r.width||r.x||r.y?r:{x:+Ud(e,["x","cx","x1"])||0,y:+Ud(e,["y","cy","y1"])||0,width:0,height:0}}function Wd(t){return!(!t.getCTM||t.parentNode&&!t.ownerSVGElement||!Vd(t))}function Xd(t,e){if(e){var r,i=t.style;e in ar&&e!==pr&&(e=cr),i.removeProperty?("ms"!==(r=e.substr(0,2))&&"webkit"!==e.substr(0,6)||(e="-"+e),i.removeProperty("--"===r?e:e.replace(hr,"-$1").toLowerCase())):i.removeAttribute(e)}}function Yd(t,e,r,i,n,a){var s=new _e(t._pt,e,r,0,1,a?Ad:zd);return(t._pt=s).b=i,s.e=n,t._props.push(r),s}function _d(t,e,r,i){var n,a,s,o,u=parseFloat(r)||0,h=(r+"").trim().substr((u+"").length)||"px",l=Le.style,f=lr.test(e),d="svg"===t.tagName.toLowerCase(),c=(d?"client":"offset")+(f?"Width":"Height"),p="px"===i,_="%"===i;if(i===h||!u||gr[i]||gr[h])return u;if("px"===h||p||(u=_d(t,e,r,"px")),o=t.getCTM&&Wd(t),(_||"%"===h)&&(ar[e]||~e.indexOf("adius")))return n=o?t.getBBox()[f?"width":"height"]:t[c],ia(_?u/n*100:u/100*n);if(l[f?"width":"height"]=100+(p?h:i),a=~e.indexOf("adius")||"em"===i&&t.appendChild&&!d?t:t.parentNode,o&&(a=(t.ownerSVGElement||{}).parentNode),a&&a!==De&&a.appendChild||(a=De.body),(s=a._gsap)&&_&&s.width&&f&&s.time===Rt.time&&!s.uncache)return ia(u/s.width*100);if(!_||"height"!==e&&"width"!==e)!_&&"%"!==h||vr[Pd(a,"display")]||(l.position=Pd(t,"position")),a===t&&(l.position="static"),a.appendChild(Le),n=Le[c],a.removeChild(Le),l.position="absolute";else{var m=t.style[e];t.style[e]=100+i,n=t[c],m?t.style[e]=m:Xd(t,e)}return f&&_&&((s=fa(a)).time=Rt.time,s.width=a[c]),ia(p?n*u/100:n&&u?100/n*u:0)}function be(t,e,r,i){if(!r||"none"===r){var n=mr(e,t,1),a=n&&Pd(t,n,1);a&&a!==r?(e=n,r=a):"borderColor"===e&&(r=Pd(t,"borderTopColor"))}var s,o,u,h,l,f,d,c,p,_,m,g=new _e(this._pt,t.style,e,0,1,ue),v=0,y=0;if(g.b=r,g.e=i,r+="","auto"===(i+="")&&(f=t.style[e],t.style[e]=i,i=Pd(t,e)||i,f?t.style[e]=f:Xd(t,e)),Fb(s=[r,i]),i=s[1],u=(r=s[0]).match(rt)||[],(i.match(rt)||[]).length){for(;o=rt.exec(i);)d=o[0],p=i.substring(v,o.index),l?l=(l+1)%5:"rgba("!==p.substr(-5)&&"hsla("!==p.substr(-5)||(l=1),d!==(f=u[y++]||"")&&(h=parseFloat(f)||0,m=f.substr((h+"").length),"="===d.charAt(1)&&(d=ka(h,d)+m),c=parseFloat(d),_=d.substr((c+"").length),v=rt.lastIndex-_.length,_||(_=_||q.units[e]||m,v===i.length&&(i+=_,g.e+=_)),m!==_&&(h=_d(t,e,f,_)||0),g._pt={_next:g._pt,p:p||1===y?p:",",s:h,c:c-h,m:l&&l<4||"zIndex"===e?Math.round:0});g.c=v<i.length?i.substring(v,i.length):""}else g.r="display"===e&&"none"===i?Ad:zd;return nt.test(i)&&(g.e=0),this._pt=g}function de(t){var e=t.split(" "),r=e[0],i=e[1]||"50%";return"top"!==r&&"bottom"!==r&&"left"!==i&&"right"!==i||(t=r,r=i,i=t),e[0]=Tr[r]||r,e[1]=Tr[i]||i,e.join(" ")}function ee(t,e){if(e.tween&&e.tween._time===e.tween._dur){var r,i,n,a=e.t,s=a.style,o=e.u,u=a._gsap;if("all"===o||!0===o)s.cssText="",i=1;else for(n=(o=o.split(",")).length;-1<--n;)r=o[n],ar[r]&&(i=1,r="transformOrigin"===r?pr:cr),Xd(a,r);i&&(Xd(a,cr),u&&(u.svg&&a.removeAttribute("transform"),Or(a,1),u.uncache=1,Kd(s)))}}function ie(t){return"matrix(1, 0, 0, 1, 0, 0)"===t||"none"===t||!t}function je(t){var e=Pd(t,cr);return ie(e)?wr:e.substr(7).match(et).map(ia)}function ke(t,e){var r,i,n,a,s=t._gsap||fa(t),o=t.style,u=je(t);return s.svg&&t.getAttribute("transform")?"1,0,0,1,0,0"===(u=[(n=t.transform.baseVal.consolidate().matrix).a,n.b,n.c,n.d,n.e,n.f]).join(",")?wr:u:(u!==wr||t.offsetParent||t===Re||s.svg||(n=o.display,o.display="block",(r=t.parentNode)&&t.offsetParent||(a=1,i=t.nextElementSibling,Re.appendChild(t)),u=je(t),n?o.display=n:Xd(t,"display"),a&&(i?r.insertBefore(t,i):r?r.appendChild(t):Re.removeChild(t))),e&&6<u.length?[u[0],u[1],u[4],u[5],u[12],u[13]]:u)}function le(t,e,r,i,n,a){var s,o,u,h=t._gsap,l=n||ke(t,!0),f=h.xOrigin||0,d=h.yOrigin||0,c=h.xOffset||0,p=h.yOffset||0,_=l[0],m=l[1],g=l[2],v=l[3],y=l[4],T=l[5],b=e.split(" "),w=parseFloat(b[0])||0,x=parseFloat(b[1])||0;r?l!==wr&&(o=_*v-m*g)&&(u=w*(-m/o)+x*(_/o)-(_*T-m*y)/o,w=w*(v/o)+x*(-g/o)+(g*T-v*y)/o,x=u):(w=(s=Vd(t)).x+(~b[0].indexOf("%")?w/100*s.width:w),x=s.y+(~(b[1]||b[0]).indexOf("%")?x/100*s.height:x)),i||!1!==i&&h.smooth?(y=w-f,T=x-d,h.xOffset=c+(y*_+T*g)-y,h.yOffset=p+(y*m+T*v)-T):h.xOffset=h.yOffset=0,h.xOrigin=w,h.yOrigin=x,h.smooth=!!i,h.origin=e,h.originIsAbsolute=!!r,t.style[pr]="0px 0px",a&&(Yd(a,h,"xOrigin",f,w),Yd(a,h,"yOrigin",d,x),Yd(a,h,"xOffset",c,h.xOffset),Yd(a,h,"yOffset",p,h.yOffset)),t.setAttribute("data-svg-origin",w+" "+x)}function oe(t,e,r){var i=Ya(e);return ia(parseFloat(e)+parseFloat(_d(t,"x",r+"px",i)))+i}function ve(t,e,i,n,a){var s,o,u=360,h=r(a),l=parseFloat(a)*(h&&~a.indexOf("rad")?sr:1)-n,f=n+l+"deg";return h&&("short"===(s=a.split("_")[1])&&(l%=u)!==l%180&&(l+=l<0?u:-u),"cw"===s&&l<0?l=(l+36e9)%u-~~(l/u)*u:"ccw"===s&&0<l&&(l=(l-36e9)%u-~~(l/u)*u)),t._pt=o=new _e(t._pt,e,i,n,l,wd),o.e=f,o.u="deg",t._props.push(i),o}function we(t,e){for(var r in e)t[r]=e[r];return t}function xe(t,e,r){var i,n,a,s,o,u,h,l=we({},r._gsap),f=r.style;for(n in l.svg?(a=r.getAttribute("transform"),r.setAttribute("transform",""),f[cr]=e,i=Or(r,1),Xd(r,cr),r.setAttribute("transform",a)):(a=getComputedStyle(r)[cr],f[cr]=e,i=Or(r,1),f[cr]=a),ar)(a=l[n])!==(s=i[n])&&"perspective,force3D,transformOrigin,svgOrigin".indexOf(n)<0&&(o=Ya(a)!==(h=Ya(s))?_d(r,n,a,h):parseFloat(a),u=parseFloat(s),t._pt=new _e(t._pt,i,n,o,u-o,vd),t._pt.u=h||0,t._props.push(n));we(i,l)}var Ee,De,Re,Fe,Le,Ie,Be,Ye,qe=Lt.Power0,Ve=Lt.Power1,Ue=Lt.Power2,Xe=Lt.Power3,Ne=Lt.Power4,Ge=Lt.Linear,We=Lt.Quad,Qe=Lt.Cubic,Ke=Lt.Quart,Je=Lt.Quint,He=Lt.Strong,$e=Lt.Elastic,Ze=Lt.Back,tr=Lt.SteppedEase,er=Lt.Bounce,rr=Lt.Sine,ir=Lt.Expo,nr=Lt.Circ,ar={},sr=180/Math.PI,or=Math.PI/180,ur=Math.atan2,hr=/([A-Z])/g,lr=/(left|right|width|margin|padding|x)/i,fr=/[\s,\(]\S/,dr={autoAlpha:"opacity,visibility",scale:"scaleX,scaleY",alpha:"opacity"},cr="transform",pr=cr+"Origin",_r="O,Moz,ms,Ms,Webkit".split(","),mr=function _checkPropPrefix(t,e,r){var i=(e||Le).style,n=5;if(t in i&&!r)return t;for(t=t.charAt(0).toUpperCase()+t.substr(1);n--&&!(_r[n]+t in i););return n<0?null:(3===n?"ms":0<=n?_r[n]:"")+t},gr={deg:1,rad:1,turn:1},vr={grid:1,flex:1},yr=function _get(t,e,r,i){var n;return Fe||Sd(),e in dr&&"transform"!==e&&~(e=dr[e]).indexOf(",")&&(e=e.split(",")[0]),ar[e]&&"transform"!==e?(n=Or(t,i),n="transformOrigin"!==e?n[e]:n.svg?n.origin:kr(Pd(t,pr))+" "+n.zOrigin+"px"):(n=t.style[e])&&"auto"!==n&&!i&&!~(n+"").indexOf("calc(")||(n=br[e]&&br[e](t,e,r)||Pd(t,e)||ga(t,e)||("opacity"===e?1:0)),r&&!~(n+"").trim().indexOf(" ")?_d(t,e,n,r)+r:n},Tr={top:"0%",bottom:"100%",left:"0%",right:"100%",center:"50%"},br={clearProps:function clearProps(t,e,r,i,n){if("isFromStart"!==n.data){var a=t._pt=new _e(t._pt,e,r,0,0,ee);return a.u=i,a.pr=-10,a.tween=n,t._props.push(r),1}}},wr=[1,0,0,1,0,0],xr={},Or=function _parseTransform(t,e){var r=t._gsap||new Vt(t);if("x"in r&&!e&&!r.uncache)return r;var i,n,a,s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w,x,O,k,M,P,C,A,S,z,E,D,R,F=t.style,L=r.scaleX<0,I="deg",B=getComputedStyle(t),Y=Pd(t,pr)||"0";return i=n=a=u=h=l=f=d=c=0,s=o=1,r.svg=!(!t.getCTM||!Wd(t)),B.translate&&("none"===B.translate&&"none"===B.scale&&"none"===B.rotate||(F[cr]=("none"!==B.translate?"translate3d("+(B.translate+" 0 0").split(" ").slice(0,3).join(", ")+") ":"")+("none"!==B.rotate?"rotate("+B.rotate+") ":"")+("none"!==B.scale?"scale("+B.scale.split(" ").join(",")+") ":"")+("none"!==B[cr]?B[cr]:"")),F.scale=F.rotate=F.translate="none"),m=ke(t,r.svg),r.svg&&(M=r.uncache?(P=t.getBBox(),Y=r.xOrigin-P.x+"px "+(r.yOrigin-P.y)+"px",""):!e&&t.getAttribute("data-svg-origin"),le(t,M||Y,!!M||r.originIsAbsolute,!1!==r.smooth,m)),p=r.xOrigin||0,_=r.yOrigin||0,m!==wr&&(T=m[0],b=m[1],w=m[2],x=m[3],i=O=m[4],n=k=m[5],6===m.length?(s=Math.sqrt(T*T+b*b),o=Math.sqrt(x*x+w*w),u=T||b?ur(b,T)*sr:0,(f=w||x?ur(w,x)*sr+u:0)&&(o*=Math.abs(Math.cos(f*or))),r.svg&&(i-=p-(p*T+_*w),n-=_-(p*b+_*x))):(R=m[6],E=m[7],A=m[8],S=m[9],z=m[10],D=m[11],i=m[12],n=m[13],a=m[14],h=(g=ur(R,z))*sr,g&&(M=O*(v=Math.cos(-g))+A*(y=Math.sin(-g)),P=k*v+S*y,C=R*v+z*y,A=O*-y+A*v,S=k*-y+S*v,z=R*-y+z*v,D=E*-y+D*v,O=M,k=P,R=C),l=(g=ur(-w,z))*sr,g&&(v=Math.cos(-g),D=x*(y=Math.sin(-g))+D*v,T=M=T*v-A*y,b=P=b*v-S*y,w=C=w*v-z*y),u=(g=ur(b,T))*sr,g&&(M=T*(v=Math.cos(g))+b*(y=Math.sin(g)),P=O*v+k*y,b=b*v-T*y,k=k*v-O*y,T=M,O=P),h&&359.9<Math.abs(h)+Math.abs(u)&&(h=u=0,l=180-l),s=ia(Math.sqrt(T*T+b*b+w*w)),o=ia(Math.sqrt(k*k+R*R)),g=ur(O,k),f=2e-4<Math.abs(g)?g*sr:0,c=D?1/(D<0?-D:D):0),r.svg&&(M=t.getAttribute("transform"),r.forceCSS=t.setAttribute("transform","")||!ie(Pd(t,cr)),M&&t.setAttribute("transform",M))),90<Math.abs(f)&&Math.abs(f)<270&&(L?(s*=-1,f+=u<=0?180:-180,u+=u<=0?180:-180):(o*=-1,f+=f<=0?180:-180)),e=e||r.uncache,r.x=i-((r.xPercent=i&&(!e&&r.xPercent||(Math.round(t.offsetWidth/2)===Math.round(-i)?-50:0)))?t.offsetWidth*r.xPercent/100:0)+"px",r.y=n-((r.yPercent=n&&(!e&&r.yPercent||(Math.round(t.offsetHeight/2)===Math.round(-n)?-50:0)))?t.offsetHeight*r.yPercent/100:0)+"px",r.z=a+"px",r.scaleX=ia(s),r.scaleY=ia(o),r.rotation=ia(u)+I,r.rotationX=ia(h)+I,r.rotationY=ia(l)+I,r.skewX=f+I,r.skewY=d+I,r.transformPerspective=c+"px",(r.zOrigin=parseFloat(Y.split(" ")[2])||!e&&r.zOrigin||0)&&(F[pr]=kr(Y)),r.xOffset=r.yOffset=0,r.force3D=q.force3D,r.renderTransform=r.svg?zr:Ye?Sr:Mr,r.uncache=0,r},kr=function _firstTwoOnly(t){return(t=t.split(" "))[0]+" "+t[1]},Mr=function _renderNon3DTransforms(t,e){e.z="0px",e.rotationY=e.rotationX="0deg",e.force3D=0,Sr(t,e)},Pr="0deg",Cr="0px",Ar=") ",Sr=function _renderCSSTransforms(t,e){var r=e||this,i=r.xPercent,n=r.yPercent,a=r.x,s=r.y,o=r.z,u=r.rotation,h=r.rotationY,l=r.rotationX,f=r.skewX,d=r.skewY,c=r.scaleX,p=r.scaleY,_=r.transformPerspective,m=r.force3D,g=r.target,v=r.zOrigin,y="",T="auto"===m&&t&&1!==t||!0===m;if(v&&(l!==Pr||h!==Pr)){var b,w=parseFloat(h)*or,x=Math.sin(w),O=Math.cos(w);w=parseFloat(l)*or,b=Math.cos(w),a=oe(g,a,x*b*-v),s=oe(g,s,-Math.sin(w)*-v),o=oe(g,o,O*b*-v+v)}_!==Cr&&(y+="perspective("+_+Ar),(i||n)&&(y+="translate("+i+"%, "+n+"%) "),!T&&a===Cr&&s===Cr&&o===Cr||(y+=o!==Cr||T?"translate3d("+a+", "+s+", "+o+") ":"translate("+a+", "+s+Ar),u!==Pr&&(y+="rotate("+u+Ar),h!==Pr&&(y+="rotateY("+h+Ar),l!==Pr&&(y+="rotateX("+l+Ar),f===Pr&&d===Pr||(y+="skew("+f+", "+d+Ar),1===c&&1===p||(y+="scale("+c+", "+p+Ar),g.style[cr]=y||"translate(0, 0)"},zr=function _renderSVGTransforms(t,e){var r,i,n,a,s,o=e||this,u=o.xPercent,h=o.yPercent,l=o.x,f=o.y,d=o.rotation,c=o.skewX,p=o.skewY,_=o.scaleX,m=o.scaleY,g=o.target,v=o.xOrigin,y=o.yOrigin,T=o.xOffset,b=o.yOffset,w=o.forceCSS,x=parseFloat(l),O=parseFloat(f);d=parseFloat(d),c=parseFloat(c),(p=parseFloat(p))&&(c+=p=parseFloat(p),d+=p),d||c?(d*=or,c*=or,r=Math.cos(d)*_,i=Math.sin(d)*_,n=Math.sin(d-c)*-m,a=Math.cos(d-c)*m,c&&(p*=or,s=Math.tan(c-p),n*=s=Math.sqrt(1+s*s),a*=s,p&&(s=Math.tan(p),r*=s=Math.sqrt(1+s*s),i*=s)),r=ia(r),i=ia(i),n=ia(n),a=ia(a)):(r=_,a=m,i=n=0),(x&&!~(l+"").indexOf("px")||O&&!~(f+"").indexOf("px"))&&(x=_d(g,"x",l,"px"),O=_d(g,"y",f,"px")),(v||y||T||b)&&(x=ia(x+v-(v*r+y*n)+T),O=ia(O+y-(v*i+y*a)+b)),(u||h)&&(s=g.getBBox(),x=ia(x+u/100*s.width),O=ia(O+h/100*s.height)),s="matrix("+r+","+i+","+n+","+a+","+x+","+O+")",g.setAttribute("transform",s),w&&(g.style[cr]=s)};ha("padding,margin,Width,Radius",function(e,r){var t="Right",i="Bottom",n="Left",o=(r<3?["Top",t,i,n]:["Top"+n,"Top"+t,i+t,i+n]).map(function(t){return r<2?e+t:"border"+t+e});br[1<r?"border"+e:e]=function(e,t,r,i,n){var a,s;if(arguments.length<4)return a=o.map(function(t){return yr(e,t,r)}),5===(s=a.join(" ")).split(a[0]).length?a[0]:s;a=(i+"").split(" "),s={},o.forEach(function(t,e){return s[t]=a[e]=a[e]||a[(e-1)/2|0]}),e.init(t,s,n)}});var Er,Dr,Rr,Fr={name:"css",register:Sd,targetTest:function targetTest(t){return t.style&&t.nodeType},init:function init(t,e,i,n,a){var s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w=this._props,x=t.style,O=i.vars.startAt;for(d in Fe||Sd(),this.styles=this.styles||Md(t),b=this.styles.props,this.tween=i,e)if("autoRound"!==d&&(o=e[d],!pt[d]||!ac(d,e,i,n,t,a)))if(l=typeof o,f=br[d],"function"===l&&(l=typeof(o=o.call(i,n,t,a))),"string"===l&&~o.indexOf("random(")&&(o=ob(o)),f)f(this,t,d,o,i)&&(T=1);else if("--"===d.substr(0,2))s=(getComputedStyle(t).getPropertyValue(d)+"").trim(),o+="",Et.lastIndex=0,Et.test(s)||(c=Ya(s),p=Ya(o)),p?c!==p&&(s=_d(t,d,s,p)+p):c&&(o+=c),this.add(x,"setProperty",s,o,n,a,0,0,d),w.push(d),b.push(d,0,x[d]);else if("undefined"!==l){if(O&&d in O?(s="function"==typeof O[d]?O[d].call(i,n,t,a):O[d],r(s)&&~s.indexOf("random(")&&(s=ob(s)),Ya(s+"")||"auto"===s||(s+=q.units[d]||Ya(yr(t,d))||""),"="===(s+"").charAt(1)&&(s=yr(t,d))):s=yr(t,d),h=parseFloat(s),(_="string"===l&&"="===o.charAt(1)&&o.substr(0,2))&&(o=o.substr(2)),u=parseFloat(o),d in dr&&("autoAlpha"===d&&(1===h&&"hidden"===yr(t,"visibility")&&u&&(h=0),b.push("visibility",0,x.visibility),Yd(this,x,"visibility",h?"inherit":"hidden",u?"inherit":"hidden",!u)),"scale"!==d&&"transform"!==d&&~(d=dr[d]).indexOf(",")&&(d=d.split(",")[0])),m=d in ar)if(this.styles.save(d),g||((v=t._gsap).renderTransform&&!e.parseTransform||Or(t,e.parseTransform),y=!1!==e.smoothOrigin&&v.smooth,(g=this._pt=new _e(this._pt,x,cr,0,1,v.renderTransform,v,0,-1)).dep=1),"scale"===d)this._pt=new _e(this._pt,v,"scaleY",v.scaleY,(_?ka(v.scaleY,_+u):u)-v.scaleY||0,vd),this._pt.u=0,w.push("scaleY",d),d+="X";else{if("transformOrigin"===d){b.push(pr,0,x[pr]),o=de(o),v.svg?le(t,o,0,y,0,this):((p=parseFloat(o.split(" ")[2])||0)!==v.zOrigin&&Yd(this,v,"zOrigin",v.zOrigin,p),Yd(this,x,d,kr(s),kr(o)));continue}if("svgOrigin"===d){le(t,o,1,y,0,this);continue}if(d in xr){ve(this,v,d,h,_?ka(h,_+o):o);continue}if("smoothOrigin"===d){Yd(this,v,"smooth",v.smooth,o);continue}if("force3D"===d){v[d]=o;continue}if("transform"===d){xe(this,o,t);continue}}else d in x||(d=mr(d)||d);if(m||(u||0===u)&&(h||0===h)&&!fr.test(o)&&d in x)u=u||0,(c=(s+"").substr((h+"").length))!==(p=Ya(o)||(d in q.units?q.units[d]:c))&&(h=_d(t,d,s,p)),this._pt=new _e(this._pt,m?v:x,d,h,(_?ka(h,_+u):u)-h,m||"px"!==p&&"zIndex"!==d||!1===e.autoRound?vd:yd),this._pt.u=p||0,c!==p&&"%"!==p&&(this._pt.b=s,this._pt.r=xd);else if(d in x)be.call(this,t,d,s,_?_+o:o);else if(d in t)this.add(t,d,s||t[d],_?_+o:o,n,a);else if("parseTransform"!==d){Q(d,o);continue}m||(d in x?b.push(d,0,x[d]):b.push(d,1,s||t[d])),w.push(d)}T&&pe(this)},render:function render(t,e){if(e.tween._time||!Be())for(var r=e._pt;r;)r.r(t,r.d),r=r._next;else e.styles.revert()},get:yr,aliases:dr,getSetter:function getSetter(t,e,r){var i=dr[e];return i&&i.indexOf(",")<0&&(e=i),e in ar&&e!==pr&&(t._gsap.x||yr(t,"x"))?r&&Ie===r?"scale"===e?Ed:Dd:(Ie=r||{})&&("scale"===e?Fd:Gd):t.style&&!u(t.style[e])?Bd:~e.indexOf("-")?Cd:ne(t,e)},core:{_removeProperty:Xd,_getMatrix:ke}};ze.utils.checkPrefix=mr,ze.core.getStyleSaver=Md,Rr=ha((Er="x,y,z,scale,scaleX,scaleY,xPercent,yPercent")+","+(Dr="rotation,rotationX,rotationY,skewX,skewY")+",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",function(t){ar[t]=1}),ha(Dr,function(t){q.units[t]="deg",xr[t]=1}),dr[Rr[13]]=Er+","+Dr,ha("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",function(t){var e=t.split(":");dr[e[1]]=Rr[e[0]]}),ha("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",function(t){q.units[t]="px"}),ze.registerPlugin(Fr);var Lr=ze.registerPlugin(Fr)||ze,Ir=Lr.core.Tween;e.Back=Ze,e.Bounce=er,e.CSSPlugin=Fr,e.Circ=nr,e.Cubic=Qe,e.Elastic=$e,e.Expo=ir,e.Linear=Ge,e.Power0=qe,e.Power1=Ve,e.Power2=Ue,e.Power3=Xe,e.Power4=Ne,e.Quad=We,e.Quart=Ke,e.Quint=Je,e.Sine=rr,e.SteppedEase=tr,e.Strong=He,e.TimelineLite=Xt,e.TimelineMax=Xt,e.TweenLite=$t,e.TweenMax=Ir,e.default=Lr,e.gsap=Lr;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});
  
  
  /* ScrollTrigger */
  /*!
   * ScrollTrigger 3.12.5
   * https://gsap.com
   * 
   * @license Copyright 2024, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license or for Club GSAP members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
   */
  
  !function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e=e||self).window=e.window||{})}(this,function(e){"use strict";function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function r(){return Ce||"undefined"!=typeof window&&(Ce=window.gsap)&&Ce.registerPlugin&&Ce}function z(e,t){return~Le.indexOf(e)&&Le[Le.indexOf(e)+1][t]}function A(e){return!!~t.indexOf(e)}function B(e,t,r,n,o){return e.addEventListener(t,r,{passive:!1!==n,capture:!!o})}function C(e,t,r,n){return e.removeEventListener(t,r,!!n)}function F(){return De&&De.isPressed||Ie.cache++}function G(r,n){function dd(e){if(e||0===e){o&&(Se.history.scrollRestoration="manual");var t=De&&De.isPressed;e=dd.v=Math.round(e)||(De&&De.iOS?1:0),r(e),dd.cacheID=Ie.cache,t&&i("ss",e)}else(n||Ie.cache!==dd.cacheID||i("ref"))&&(dd.cacheID=Ie.cache,dd.v=r());return dd.v+dd.offset}return dd.offset=0,r&&dd}function J(e,t){return(t&&t._ctx&&t._ctx.selector||Ce.utils.toArray)(e)[0]||("string"==typeof e&&!1!==Ce.config().nullTargetWarn?console.warn("Element not found:",e):null)}function K(t,e){var r=e.s,n=e.sc;A(t)&&(t=ke.scrollingElement||Pe);var o=Ie.indexOf(t),i=n===Fe.sc?1:2;~o||(o=Ie.push(t)-1),Ie[o+i]||B(t,"scroll",F);var a=Ie[o+i],s=a||(Ie[o+i]=G(z(t,r),!0)||(A(t)?n:G(function(e){return arguments.length?t[r]=e:t[r]})));return s.target=t,a||(s.smooth="smooth"===Ce.getProperty(t,"scrollBehavior")),s}function L(e,t,o){function Cd(e,t){var r=ze();t||n<r-s?(a=i,i=e,l=s,s=r):o?i+=e:i=a+(e-a)/(r-l)*(s-l)}var i=e,a=e,s=ze(),l=s,n=t||50,c=Math.max(500,3*n);return{update:Cd,reset:function reset(){a=i=o?0:i,l=s=0},getVelocity:function getVelocity(e){var t=l,r=a,n=ze();return!e&&0!==e||e===i||Cd(e),s===l||c<n-l?0:(i+(o?r:-r))/((o?n:s)-t)*1e3}}}function M(e,t){return t&&!e._gsapAllow&&e.preventDefault(),e.changedTouches?e.changedTouches[0]:e}function N(e){var t=Math.max.apply(Math,e),r=Math.min.apply(Math,e);return Math.abs(t)>=Math.abs(r)?t:r}function O(){(Ae=Ce.core.globals().ScrollTrigger)&&Ae.core&&function _integrate(){var e=Ae.core,r=e.bridge||{},t=e._scrollers,n=e._proxies;t.push.apply(t,Ie),n.push.apply(n,Le),Ie=t,Le=n,i=function _bridge(e,t){return r[e](t)}}()}function P(e){return Ce=e||r(),!Te&&Ce&&"undefined"!=typeof document&&document.body&&(Se=window,Pe=(ke=document).documentElement,Me=ke.body,t=[Se,ke,Pe,Me],Ce.utils.clamp,Be=Ce.core.context||function(){},Oe="onpointerenter"in Me?"pointer":"mouse",Ee=k.isTouch=Se.matchMedia&&Se.matchMedia("(hover: none), (pointer: coarse)").matches?1:"ontouchstart"in Se||0<navigator.maxTouchPoints||0<navigator.msMaxTouchPoints?2:0,Re=k.eventTypes=("ontouchstart"in Pe?"touchstart,touchmove,touchcancel,touchend":"onpointerdown"in Pe?"pointerdown,pointermove,pointercancel,pointerup":"mousedown,mousemove,mouseup,mouseup").split(","),setTimeout(function(){return o=0},500),O(),Te=1),Te}var Ce,Te,Se,ke,Pe,Me,Ee,Oe,Ae,t,De,Re,Be,o=1,qe=[],Ie=[],Le=[],ze=Date.now,i=function _bridge(e,t){return t},n="scrollLeft",a="scrollTop",Ye={s:n,p:"left",p2:"Left",os:"right",os2:"Right",d:"width",d2:"Width",a:"x",sc:G(function(e){return arguments.length?Se.scrollTo(e,Fe.sc()):Se.pageXOffset||ke[n]||Pe[n]||Me[n]||0})},Fe={s:a,p:"top",p2:"Top",os:"bottom",os2:"Bottom",d:"height",d2:"Height",a:"y",op:Ye,sc:G(function(e){return arguments.length?Se.scrollTo(Ye.sc(),e):Se.pageYOffset||ke[a]||Pe[a]||Me[a]||0})};Ye.op=Fe,Ie.cache=0;var k=(Observer.prototype.init=function init(e){Te||P(Ce)||console.warn("Please gsap.registerPlugin(Observer)"),Ae||O();var o=e.tolerance,a=e.dragMinimum,t=e.type,i=e.target,r=e.lineHeight,n=e.debounce,s=e.preventDefault,l=e.onStop,c=e.onStopDelay,u=e.ignore,f=e.wheelSpeed,d=e.event,p=e.onDragStart,g=e.onDragEnd,h=e.onDrag,v=e.onPress,b=e.onRelease,m=e.onRight,y=e.onLeft,x=e.onUp,w=e.onDown,_=e.onChangeX,T=e.onChangeY,S=e.onChange,k=e.onToggleX,E=e.onToggleY,D=e.onHover,R=e.onHoverEnd,q=e.onMove,I=e.ignoreCheck,z=e.isNormalizer,Y=e.onGestureStart,H=e.onGestureEnd,X=e.onWheel,W=e.onEnable,V=e.onDisable,U=e.onClick,j=e.scrollSpeed,G=e.capture,Q=e.allowClicks,Z=e.lockAxis,$=e.onLockAxis;function cf(){return xe=ze()}function df(e,t){return(se.event=e)&&u&&~u.indexOf(e.target)||t&&he&&"touch"!==e.pointerType||I&&I(e,t)}function ff(){var e=se.deltaX=N(me),t=se.deltaY=N(ye),r=Math.abs(e)>=o,n=Math.abs(t)>=o;S&&(r||n)&&S(se,e,t,me,ye),r&&(m&&0<se.deltaX&&m(se),y&&se.deltaX<0&&y(se),_&&_(se),k&&se.deltaX<0!=le<0&&k(se),le=se.deltaX,me[0]=me[1]=me[2]=0),n&&(w&&0<se.deltaY&&w(se),x&&se.deltaY<0&&x(se),T&&T(se),E&&se.deltaY<0!=ce<0&&E(se),ce=se.deltaY,ye[0]=ye[1]=ye[2]=0),(ne||re)&&(q&&q(se),re&&(h(se),re=!1),ne=!1),ie&&!(ie=!1)&&$&&$(se),oe&&(X(se),oe=!1),ee=0}function gf(e,t,r){me[r]+=e,ye[r]+=t,se._vx.update(e),se._vy.update(t),n?ee=ee||requestAnimationFrame(ff):ff()}function hf(e,t){Z&&!ae&&(se.axis=ae=Math.abs(e)>Math.abs(t)?"x":"y",ie=!0),"y"!==ae&&(me[2]+=e,se._vx.update(e,!0)),"x"!==ae&&(ye[2]+=t,se._vy.update(t,!0)),n?ee=ee||requestAnimationFrame(ff):ff()}function jf(e){if(!df(e,1)){var t=(e=M(e,s)).clientX,r=e.clientY,n=t-se.x,o=r-se.y,i=se.isDragging;se.x=t,se.y=r,(i||Math.abs(se.startX-t)>=a||Math.abs(se.startY-r)>=a)&&(h&&(re=!0),i||(se.isDragging=!0),hf(n,o),i||p&&p(se))}}function mf(e){return e.touches&&1<e.touches.length&&(se.isGesturing=!0)&&Y(e,se.isDragging)}function nf(){return(se.isGesturing=!1)||H(se)}function of(e){if(!df(e)){var t=fe(),r=de();gf((t-pe)*j,(r-ge)*j,1),pe=t,ge=r,l&&te.restart(!0)}}function pf(e){if(!df(e)){e=M(e,s),X&&(oe=!0);var t=(1===e.deltaMode?r:2===e.deltaMode?Se.innerHeight:1)*f;gf(e.deltaX*t,e.deltaY*t,0),l&&!z&&te.restart(!0)}}function qf(e){if(!df(e)){var t=e.clientX,r=e.clientY,n=t-se.x,o=r-se.y;se.x=t,se.y=r,ne=!0,l&&te.restart(!0),(n||o)&&hf(n,o)}}function rf(e){se.event=e,D(se)}function sf(e){se.event=e,R(se)}function tf(e){return df(e)||M(e,s)&&U(se)}this.target=i=J(i)||Pe,this.vars=e,u=u&&Ce.utils.toArray(u),o=o||1e-9,a=a||0,f=f||1,j=j||1,t=t||"wheel,touch,pointer",n=!1!==n,r=r||parseFloat(Se.getComputedStyle(Me).lineHeight)||22;var ee,te,re,ne,oe,ie,ae,se=this,le=0,ce=0,ue=e.passive||!s,fe=K(i,Ye),de=K(i,Fe),pe=fe(),ge=de(),he=~t.indexOf("touch")&&!~t.indexOf("pointer")&&"pointerdown"===Re[0],ve=A(i),be=i.ownerDocument||ke,me=[0,0,0],ye=[0,0,0],xe=0,we=se.onPress=function(e){df(e,1)||e&&e.button||(se.axis=ae=null,te.pause(),se.isPressed=!0,e=M(e),le=ce=0,se.startX=se.x=e.clientX,se.startY=se.y=e.clientY,se._vx.reset(),se._vy.reset(),B(z?i:be,Re[1],jf,ue,!0),se.deltaX=se.deltaY=0,v&&v(se))},_e=se.onRelease=function(t){if(!df(t,1)){C(z?i:be,Re[1],jf,!0);var e=!isNaN(se.y-se.startY),r=se.isDragging,n=r&&(3<Math.abs(se.x-se.startX)||3<Math.abs(se.y-se.startY)),o=M(t);!n&&e&&(se._vx.reset(),se._vy.reset(),s&&Q&&Ce.delayedCall(.08,function(){if(300<ze()-xe&&!t.defaultPrevented)if(t.target.click)t.target.click();else if(be.createEvent){var e=be.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,Se,1,o.screenX,o.screenY,o.clientX,o.clientY,!1,!1,!1,!1,0,null),t.target.dispatchEvent(e)}})),se.isDragging=se.isGesturing=se.isPressed=!1,l&&r&&!z&&te.restart(!0),g&&r&&g(se),b&&b(se,n)}};te=se._dc=Ce.delayedCall(c||.25,function onStopFunc(){se._vx.reset(),se._vy.reset(),te.pause(),l&&l(se)}).pause(),se.deltaX=se.deltaY=0,se._vx=L(0,50,!0),se._vy=L(0,50,!0),se.scrollX=fe,se.scrollY=de,se.isDragging=se.isGesturing=se.isPressed=!1,Be(this),se.enable=function(e){return se.isEnabled||(B(ve?be:i,"scroll",F),0<=t.indexOf("scroll")&&B(ve?be:i,"scroll",of,ue,G),0<=t.indexOf("wheel")&&B(i,"wheel",pf,ue,G),(0<=t.indexOf("touch")&&Ee||0<=t.indexOf("pointer"))&&(B(i,Re[0],we,ue,G),B(be,Re[2],_e),B(be,Re[3],_e),Q&&B(i,"click",cf,!0,!0),U&&B(i,"click",tf),Y&&B(be,"gesturestart",mf),H&&B(be,"gestureend",nf),D&&B(i,Oe+"enter",rf),R&&B(i,Oe+"leave",sf),q&&B(i,Oe+"move",qf)),se.isEnabled=!0,e&&e.type&&we(e),W&&W(se)),se},se.disable=function(){se.isEnabled&&(qe.filter(function(e){return e!==se&&A(e.target)}).length||C(ve?be:i,"scroll",F),se.isPressed&&(se._vx.reset(),se._vy.reset(),C(z?i:be,Re[1],jf,!0)),C(ve?be:i,"scroll",of,G),C(i,"wheel",pf,G),C(i,Re[0],we,G),C(be,Re[2],_e),C(be,Re[3],_e),C(i,"click",cf,!0),C(i,"click",tf),C(be,"gesturestart",mf),C(be,"gestureend",nf),C(i,Oe+"enter",rf),C(i,Oe+"leave",sf),C(i,Oe+"move",qf),se.isEnabled=se.isPressed=se.isDragging=!1,V&&V(se))},se.kill=se.revert=function(){se.disable();var e=qe.indexOf(se);0<=e&&qe.splice(e,1),De===se&&(De=0)},qe.push(se),z&&A(i)&&(De=se),se.enable(d)},function _createClass(e,t,r){return t&&_defineProperties(e.prototype,t),r&&_defineProperties(e,r),e}(Observer,[{key:"velocityX",get:function get(){return this._vx.getVelocity()}},{key:"velocityY",get:function get(){return this._vy.getVelocity()}}]),Observer);function Observer(e){this.init(e)}k.version="3.12.5",k.create=function(e){return new k(e)},k.register=P,k.getAll=function(){return qe.slice()},k.getById=function(t){return qe.filter(function(e){return e.vars.id===t})[0]},r()&&Ce.registerPlugin(k);function Ca(e,t,r){var n=ct(e)&&("clamp("===e.substr(0,6)||-1<e.indexOf("max"));return(r["_"+t+"Clamp"]=n)?e.substr(6,e.length-7):e}function Da(e,t){return!t||ct(e)&&"clamp("===e.substr(0,6)?e:"clamp("+e+")"}function Fa(){return Ge=1}function Ga(){return Ge=0}function Ha(e){return e}function Ia(e){return Math.round(1e5*e)/1e5||0}function Ja(){return"undefined"!=typeof window}function Ka(){return He||Ja()&&(He=window.gsap)&&He.registerPlugin&&He}function La(e){return!!~l.indexOf(e)}function Ma(e){return("Height"===e?T:Ne["inner"+e])||Je["client"+e]||We["client"+e]}function Na(e){return z(e,"getBoundingClientRect")||(La(e)?function(){return Ot.width=Ne.innerWidth,Ot.height=T,Ot}:function(){return wt(e)})}function Qa(e,t){var r=t.s,n=t.d2,o=t.d,i=t.a;return Math.max(0,(r="scroll"+n)&&(i=z(e,r))?i()-Na(e)()[o]:La(e)?(Je[r]||We[r])-Ma(n):e[r]-e["offset"+n])}function Ra(e,t){for(var r=0;r<g.length;r+=3)t&&!~t.indexOf(g[r+1])||e(g[r],g[r+1],g[r+2])}function Ta(e){return"function"==typeof e}function Ua(e){return"number"==typeof e}function Va(e){return"object"==typeof e}function Wa(e,t,r){return e&&e.progress(t?0:1)&&r&&e.pause()}function Xa(e,t){if(e.enabled){var r=e._ctx?e._ctx.add(function(){return t(e)}):t(e);r&&r.totalTime&&(e.callbackAnimation=r)}}function mb(e){return Ne.getComputedStyle(e)}function ob(e,t){for(var r in t)r in e||(e[r]=t[r]);return e}function qb(e,t){var r=t.d2;return e["offset"+r]||e["client"+r]||0}function rb(e){var t,r=[],n=e.labels,o=e.duration();for(t in n)r.push(n[t]/o);return r}function tb(o){var i=He.utils.snap(o),a=Array.isArray(o)&&o.slice(0).sort(function(e,t){return e-t});return a?function(e,t,r){var n;if(void 0===r&&(r=.001),!t)return i(e);if(0<t){for(e-=r,n=0;n<a.length;n++)if(a[n]>=e)return a[n];return a[n-1]}for(n=a.length,e+=r;n--;)if(a[n]<=e)return a[n];return a[0]}:function(e,t,r){void 0===r&&(r=.001);var n=i(e);return!t||Math.abs(n-e)<r||n-e<0==t<0?n:i(t<0?e-o:e+o)}}function vb(t,r,e,n){return e.split(",").forEach(function(e){return t(r,e,n)})}function wb(e,t,r,n,o){return e.addEventListener(t,r,{passive:!n,capture:!!o})}function xb(e,t,r,n){return e.removeEventListener(t,r,!!n)}function yb(e,t,r){(r=r&&r.wheelHandler)&&(e(t,"wheel",r),e(t,"touchmove",r))}function Cb(e,t){if(ct(e)){var r=e.indexOf("="),n=~r?(e.charAt(r-1)+1)*parseFloat(e.substr(r+1)):0;~r&&(e.indexOf("%")>r&&(n*=t/100),e=e.substr(0,r-1)),e=n+(e in H?H[e]*t:~e.indexOf("%")?parseFloat(e)*t/100:parseFloat(e)||0)}return e}function Db(e,t,r,n,o,i,a,s){var l=o.startColor,c=o.endColor,u=o.fontSize,f=o.indent,d=o.fontWeight,p=Xe.createElement("div"),g=La(r)||"fixed"===z(r,"pinType"),h=-1!==e.indexOf("scroller"),v=g?We:r,b=-1!==e.indexOf("start"),m=b?l:c,y="border-color:"+m+";font-size:"+u+";color:"+m+";font-weight:"+d+";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";return y+="position:"+((h||s)&&g?"fixed;":"absolute;"),!h&&!s&&g||(y+=(n===Fe?q:I)+":"+(i+parseFloat(f))+"px;"),a&&(y+="box-sizing:border-box;text-align:left;width:"+a.offsetWidth+"px;"),p._isStart=b,p.setAttribute("class","gsap-marker-"+e+(t?" marker-"+t:"")),p.style.cssText=y,p.innerText=t||0===t?e+"-"+t:e,v.children[0]?v.insertBefore(p,v.children[0]):v.appendChild(p),p._offset=p["offset"+n.op.d2],X(p,0,n,b),p}function Ib(){return 34<at()-st&&(D=D||requestAnimationFrame(Z))}function Jb(){v&&v.isPressed&&!(v.startX>We.clientWidth)||(Ie.cache++,v?D=D||requestAnimationFrame(Z):Z(),st||U("scrollStart"),st=at())}function Kb(){y=Ne.innerWidth,m=Ne.innerHeight}function Lb(){Ie.cache++,je||h||Xe.fullscreenElement||Xe.webkitFullscreenElement||b&&y===Ne.innerWidth&&!(Math.abs(Ne.innerHeight-m)>.25*Ne.innerHeight)||c.restart(!0)}function Ob(){return xb(ne,"scrollEnd",Ob)||Pt(!0)}function Rb(e){for(var t=0;t<j.length;t+=5)(!e||j[t+4]&&j[t+4].query===e)&&(j[t].style.cssText=j[t+1],j[t].getBBox&&j[t].setAttribute("transform",j[t+2]||""),j[t+3].uncache=1)}function Sb(e,t){var r;for(Qe=0;Qe<Tt.length;Qe++)!(r=Tt[Qe])||t&&r._ctx!==t||(e?r.kill(1):r.revert(!0,!0));S=!0,t&&Rb(t),t||U("revert")}function Tb(e,t){Ie.cache++,!t&&rt||Ie.forEach(function(e){return Ta(e)&&e.cacheID++&&(e.rec=0)}),ct(e)&&(Ne.history.scrollRestoration=w=e)}function Yb(){We.appendChild(_),T=!v&&_.offsetHeight||Ne.innerHeight,We.removeChild(_)}function Zb(t){return Ve(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(e){return e.style.display=t?"none":"block"})}function gc(e,t,r,n){if(!e._gsap.swappedIn){for(var o,i=$.length,a=t.style,s=e.style;i--;)a[o=$[i]]=r[o];a.position="absolute"===r.position?"absolute":"relative","inline"===r.display&&(a.display="inline-block"),s[I]=s[q]="auto",a.flexBasis=r.flexBasis||"auto",a.overflow="visible",a.boxSizing="border-box",a[ft]=qb(e,Ye)+xt,a[dt]=qb(e,Fe)+xt,a[bt]=s[mt]=s.top=s.left="0",Et(n),s[ft]=s.maxWidth=r[ft],s[dt]=s.maxHeight=r[dt],s[bt]=r[bt],e.parentNode!==t&&(e.parentNode.insertBefore(t,e),t.appendChild(e)),e._gsap.swappedIn=!0}}function jc(e){for(var t=ee.length,r=e.style,n=[],o=0;o<t;o++)n.push(ee[o],r[ee[o]]);return n.t=e,n}function mc(e,t,r,n,o,i,a,s,l,c,u,f,d,p){Ta(e)&&(e=e(s)),ct(e)&&"max"===e.substr(0,3)&&(e=f+("="===e.charAt(4)?Cb("0"+e.substr(3),r):0));var g,h,v,b=d?d.time():0;if(d&&d.seek(0),isNaN(e)||(e=+e),Ua(e))d&&(e=He.utils.mapRange(d.scrollTrigger.start,d.scrollTrigger.end,0,f,e)),a&&X(a,r,n,!0);else{Ta(t)&&(t=t(s));var m,y,x,w,_=(e||"0").split(" ");v=J(t,s)||We,(m=wt(v)||{})&&(m.left||m.top)||"none"!==mb(v).display||(w=v.style.display,v.style.display="block",m=wt(v),w?v.style.display=w:v.style.removeProperty("display")),y=Cb(_[0],m[n.d]),x=Cb(_[1]||"0",r),e=m[n.p]-l[n.p]-c+y+o-x,a&&X(a,x,n,r-x<20||a._isStart&&20<x),r-=r-x}if(p&&(s[p]=e||-.001,e<0&&(e=0)),i){var C=e+r,T=i._isStart;g="scroll"+n.d2,X(i,C,n,T&&20<C||!T&&(u?Math.max(We[g],Je[g]):i.parentNode[g])<=C+1),u&&(l=wt(a),u&&(i.style[n.op.p]=l[n.op.p]-n.op.m-i._offset+xt))}return d&&v&&(g=wt(v),d.seek(f),h=wt(v),d._caScrollDist=g[n.p]-h[n.p],e=e/d._caScrollDist*f),d&&d.seek(b),d?e:Math.round(e)}function oc(e,t,r,n){if(e.parentNode!==t){var o,i,a=e.style;if(t===We){for(o in e._stOrig=a.cssText,i=mb(e))+o||re.test(o)||!i[o]||"string"!=typeof a[o]||"0"===o||(a[o]=i[o]);a.top=r,a.left=n}else a.cssText=e._stOrig;He.core.getCache(e).uncache=1,t.appendChild(e)}}function pc(r,e,n){var o=e,i=o;return function(e){var t=Math.round(r());return t!==o&&t!==i&&3<Math.abs(t-o)&&3<Math.abs(t-i)&&(e=t,n&&n()),i=o,o=e}}function qc(e,t,r){var n={};n[t.p]="+="+r,He.set(e,n)}function rc(c,e){function Ck(e,t,r,n,o){var i=Ck.tween,a=t.onComplete,s={};r=r||u();var l=pc(u,r,function(){i.kill(),Ck.tween=0});return o=n&&o||0,n=n||e-r,i&&i.kill(),t[f]=e,t.inherit=!1,(t.modifiers=s)[f]=function(){return l(r+n*i.ratio+o*i.ratio*i.ratio)},t.onUpdate=function(){Ie.cache++,Ck.tween&&Z()},t.onComplete=function(){Ck.tween=0,a&&a.call(i)},i=Ck.tween=He.to(c,t)}var u=K(c,e),f="_scroll"+e.p2;return(c[f]=u).wheelHandler=function(){return Ck.tween&&Ck.tween.kill()&&(Ck.tween=0)},wb(c,"wheel",u.wheelHandler),ne.isTouch&&wb(c,"touchmove",u.wheelHandler),Ck}var He,s,Ne,Xe,Je,We,l,c,Ve,Ue,Ke,u,je,Ge,f,Qe,d,p,g,Ze,$e,h,v,b,m,y,E,x,w,_,T,S,et,tt,D,rt,nt,ot,it=1,at=Date.now,R=at(),st=0,lt=0,ct=function _isString(e){return"string"==typeof e},ut=Math.abs,q="right",I="bottom",ft="width",dt="height",pt="Right",gt="Left",ht="Top",vt="Bottom",bt="padding",mt="margin",yt="Width",Y="Height",xt="px",wt=function _getBounds(e,t){var r=t&&"matrix(1, 0, 0, 1, 0, 0)"!==mb(e)[f]&&He.to(e,{x:0,y:0,xPercent:0,yPercent:0,rotation:0,rotationX:0,rotationY:0,scale:1,skewX:0,skewY:0}).progress(1),n=e.getBoundingClientRect();return r&&r.progress(0).kill(),n},_t={startColor:"green",endColor:"red",indent:0,fontSize:"16px",fontWeight:"normal"},Ct={toggleActions:"play",anticipatePin:0},H={top:0,left:0,center:.5,bottom:1,right:1},X=function _positionMarker(e,t,r,n){var o={display:"block"},i=r[n?"os2":"p2"],a=r[n?"p2":"os2"];e._isFlipped=n,o[r.a+"Percent"]=n?-100:0,o[r.a]=n?"1px":0,o["border"+i+yt]=1,o["border"+a+yt]=0,o[r.p]=t+"px",He.set(e,o)},Tt=[],St={},W={},V=[],U=function _dispatch(e){return W[e]&&W[e].map(function(e){return e()})||V},j=[],kt=0,Pt=function _refreshAll(e,t){if(!st||e||S){Yb(),rt=ne.isRefreshing=!0,Ie.forEach(function(e){return Ta(e)&&++e.cacheID&&(e.rec=e())});var r=U("refreshInit");Ze&&ne.sort(),t||Sb(),Ie.forEach(function(e){Ta(e)&&(e.smooth&&(e.target.style.scrollBehavior="auto"),e(0))}),Tt.slice(0).forEach(function(e){return e.refresh()}),S=!1,Tt.forEach(function(e){if(e._subPinOffset&&e.pin){var t=e.vars.horizontal?"offsetWidth":"offsetHeight",r=e.pin[t];e.revert(!0,1),e.adjustPinSpacing(e.pin[t]-r),e.refresh()}}),et=1,Zb(!0),Tt.forEach(function(e){var t=Qa(e.scroller,e._dir),r="max"===e.vars.end||e._endClamp&&e.end>t,n=e._startClamp&&e.start>=t;(r||n)&&e.setPositions(n?t-1:e.start,r?Math.max(n?t:e.start+1,t):e.end,!0)}),Zb(!1),et=0,r.forEach(function(e){return e&&e.render&&e.render(-1)}),Ie.forEach(function(e){Ta(e)&&(e.smooth&&requestAnimationFrame(function(){return e.target.style.scrollBehavior="smooth"}),e.rec&&e(e.rec))}),Tb(w,1),c.pause(),kt++,Z(rt=2),Tt.forEach(function(e){return Ta(e.vars.onRefresh)&&e.vars.onRefresh(e)}),rt=ne.isRefreshing=!1,U("refresh")}else wb(ne,"scrollEnd",Ob)},Q=0,Mt=1,Z=function _updateAll(e){if(2===e||!rt&&!S){ne.isUpdating=!0,ot&&ot.update(0);var t=Tt.length,r=at(),n=50<=r-R,o=t&&Tt[0].scroll();if(Mt=o<Q?-1:1,rt||(Q=o),n&&(st&&!Ge&&200<r-st&&(st=0,U("scrollEnd")),Ke=R,R=r),Mt<0){for(Qe=t;0<Qe--;)Tt[Qe]&&Tt[Qe].update(0,n);Mt=1}else for(Qe=0;Qe<t;Qe++)Tt[Qe]&&Tt[Qe].update(0,n);ne.isUpdating=!1}D=0},$=["left","top",I,q,mt+vt,mt+pt,mt+ht,mt+gt,"display","flexShrink","float","zIndex","gridColumnStart","gridColumnEnd","gridRowStart","gridRowEnd","gridArea","justifySelf","alignSelf","placeSelf","order"],ee=$.concat([ft,dt,"boxSizing","max"+yt,"max"+Y,"position",mt,bt,bt+ht,bt+pt,bt+vt,bt+gt]),te=/([A-Z])/g,Et=function _setState(e){if(e){var t,r,n=e.t.style,o=e.length,i=0;for((e.t._gsap||He.core.getCache(e.t)).uncache=1;i<o;i+=2)r=e[i+1],t=e[i],r?n[t]=r:n[t]&&n.removeProperty(t.replace(te,"-$1").toLowerCase())}},Ot={left:0,top:0},re=/(webkit|moz|length|cssText|inset)/i,ne=(ScrollTrigger.prototype.init=function init(E,O){if(this.progress=this.start=0,this.vars&&this.kill(!0,!0),lt){var A,n,p,D,R,B,q,I,L,Y,F,e,H,N,X,W,V,U,t,j,b,G,Q,m,Z,y,$,x,r,w,_,ee,o,g,te,re,ne,C,i,T=(E=ob(ct(E)||Ua(E)||E.nodeType?{trigger:E}:E,Ct)).onUpdate,S=E.toggleClass,a=E.id,k=E.onToggle,oe=E.onRefresh,P=E.scrub,ie=E.trigger,ae=E.pin,se=E.pinSpacing,le=E.invalidateOnRefresh,M=E.anticipatePin,s=E.onScrubComplete,h=E.onSnapComplete,ce=E.once,ue=E.snap,fe=E.pinReparent,l=E.pinSpacer,de=E.containerAnimation,pe=E.fastScrollEnd,ge=E.preventOverlaps,he=E.horizontal||E.containerAnimation&&!1!==E.horizontal?Ye:Fe,ve=!P&&0!==P,be=J(E.scroller||Ne),c=He.core.getCache(be),me=La(be),ye="fixed"===("pinType"in E?E.pinType:z(be,"pinType")||me&&"fixed"),xe=[E.onEnter,E.onLeave,E.onEnterBack,E.onLeaveBack],we=ve&&E.toggleActions.split(" "),_e="markers"in E?E.markers:Ct.markers,Ce=me?0:parseFloat(mb(be)["border"+he.p2+yt])||0,Te=this,Se=E.onRefreshInit&&function(){return E.onRefreshInit(Te)},ke=function _getSizeFunc(e,t,r){var n=r.d,o=r.d2,i=r.a;return(i=z(e,"getBoundingClientRect"))?function(){return i()[n]}:function(){return(t?Ma(o):e["client"+o])||0}}(be,me,he),Pe=function _getOffsetsFunc(e,t){return!t||~Le.indexOf(e)?Na(e):function(){return Ot}}(be,me),Me=0,Ee=0,Oe=0,Ae=K(be,he);if(Te._startClamp=Te._endClamp=!1,Te._dir=he,M*=45,Te.scroller=be,Te.scroll=de?de.time.bind(de):Ae,D=Ae(),Te.vars=E,O=O||E.animation,"refreshPriority"in E&&(Ze=1,-9999===E.refreshPriority&&(ot=Te)),c.tweenScroll=c.tweenScroll||{top:rc(be,Fe),left:rc(be,Ye)},Te.tweenTo=A=c.tweenScroll[he.p],Te.scrubDuration=function(e){(o=Ua(e)&&e)?ee?ee.duration(e):ee=He.to(O,{ease:"expo",totalProgress:"+=0",inherit:!1,duration:o,paused:!0,onComplete:function onComplete(){return s&&s(Te)}}):(ee&&ee.progress(1).kill(),ee=0)},O&&(O.vars.lazy=!1,O._initted&&!Te.isReverted||!1!==O.vars.immediateRender&&!1!==E.immediateRender&&O.duration()&&O.render(0,!0,!0),Te.animation=O.pause(),(O.scrollTrigger=Te).scrubDuration(P),w=0,a=a||O.vars.id),ue&&(Va(ue)&&!ue.push||(ue={snapTo:ue}),"scrollBehavior"in We.style&&He.set(me?[We,Je]:be,{scrollBehavior:"auto"}),Ie.forEach(function(e){return Ta(e)&&e.target===(me?Xe.scrollingElement||Je:be)&&(e.smooth=!1)}),p=Ta(ue.snapTo)?ue.snapTo:"labels"===ue.snapTo?function _getClosestLabel(t){return function(e){return He.utils.snap(rb(t),e)}}(O):"labelsDirectional"===ue.snapTo?function _getLabelAtDirection(r){return function(e,t){return tb(rb(r))(e,t.direction)}}(O):!1!==ue.directional?function(e,t){return tb(ue.snapTo)(e,at()-Ee<500?0:t.direction)}:He.utils.snap(ue.snapTo),g=ue.duration||{min:.1,max:2},g=Va(g)?Ue(g.min,g.max):Ue(g,g),te=He.delayedCall(ue.delay||o/2||.1,function(){var e=Ae(),t=at()-Ee<500,r=A.tween;if(!(t||Math.abs(Te.getVelocity())<10)||r||Ge||Me===e)Te.isActive&&Me!==e&&te.restart(!0);else{var n,o,i=(e-B)/N,a=O&&!ve?O.totalProgress():i,s=t?0:(a-_)/(at()-Ke)*1e3||0,l=He.utils.clamp(-i,1-i,ut(s/2)*s/.185),c=i+(!1===ue.inertia?0:l),u=ue.onStart,f=ue.onInterrupt,d=ue.onComplete;if(n=p(c,Te),Ua(n)||(n=c),o=Math.round(B+n*N),e<=q&&B<=e&&o!==e){if(r&&!r._initted&&r.data<=ut(o-e))return;!1===ue.inertia&&(l=n-i),A(o,{duration:g(ut(.185*Math.max(ut(c-a),ut(n-a))/s/.05||0)),ease:ue.ease||"power3",data:ut(o-e),onInterrupt:function onInterrupt(){return te.restart(!0)&&f&&f(Te)},onComplete:function onComplete(){Te.update(),Me=Ae(),O&&(ee?ee.resetTo("totalProgress",n,O._tTime/O._tDur):O.progress(n)),w=_=O&&!ve?O.totalProgress():Te.progress,h&&h(Te),d&&d(Te)}},e,l*N,o-e-l*N),u&&u(Te,A.tween)}}}).pause()),a&&(St[a]=Te),i=(i=(ie=Te.trigger=J(ie||!0!==ae&&ae))&&ie._gsap&&ie._gsap.stRevert)&&i(Te),ae=!0===ae?ie:J(ae),ct(S)&&(S={targets:ie,className:S}),ae&&(!1===se||se===mt||(se=!(!se&&ae.parentNode&&ae.parentNode.style&&"flex"===mb(ae.parentNode).display)&&bt),Te.pin=ae,(n=He.core.getCache(ae)).spacer?X=n.pinState:(l&&((l=J(l))&&!l.nodeType&&(l=l.current||l.nativeElement),n.spacerIsNative=!!l,l&&(n.spacerState=jc(l))),n.spacer=U=l||Xe.createElement("div"),U.classList.add("pin-spacer"),a&&U.classList.add("pin-spacer-"+a),n.pinState=X=jc(ae)),!1!==E.force3D&&He.set(ae,{force3D:!0}),Te.spacer=U=n.spacer,r=mb(ae),m=r[se+he.os2],j=He.getProperty(ae),b=He.quickSetter(ae,he.a,xt),gc(ae,U,r),V=jc(ae)),_e){e=Va(_e)?ob(_e,_t):_t,Y=Db("scroller-start",a,be,he,e,0),F=Db("scroller-end",a,be,he,e,0,Y),t=Y["offset"+he.op.d2];var u=J(z(be,"content")||be);I=this.markerStart=Db("start",a,u,he,e,t,0,de),L=this.markerEnd=Db("end",a,u,he,e,t,0,de),de&&(C=He.quickSetter([I,L],he.a,xt)),ye||Le.length&&!0===z(be,"fixedMarkers")||(function _makePositionable(e){var t=mb(e).position;e.style.position="absolute"===t||"fixed"===t?t:"relative"}(me?We:be),He.set([Y,F],{force3D:!0}),y=He.quickSetter(Y,he.a,xt),x=He.quickSetter(F,he.a,xt))}if(de){var f=de.vars.onUpdate,d=de.vars.onUpdateParams;de.eventCallback("onUpdate",function(){Te.update(0,0,1),f&&f.apply(de,d||[])})}if(Te.previous=function(){return Tt[Tt.indexOf(Te)-1]},Te.next=function(){return Tt[Tt.indexOf(Te)+1]},Te.revert=function(e,t){if(!t)return Te.kill(!0);var r=!1!==e||!Te.enabled,n=je;r!==Te.isReverted&&(r&&(re=Math.max(Ae(),Te.scroll.rec||0),Oe=Te.progress,ne=O&&O.progress()),I&&[I,L,Y,F].forEach(function(e){return e.style.display=r?"none":"block"}),r&&(je=Te).update(r),!ae||fe&&Te.isActive||(r?function _swapPinOut(e,t,r){Et(r);var n=e._gsap;if(n.spacerIsNative)Et(n.spacerState);else if(e._gsap.swappedIn){var o=t.parentNode;o&&(o.insertBefore(e,t),o.removeChild(t))}e._gsap.swappedIn=!1}(ae,U,X):gc(ae,U,mb(ae),Z)),r||Te.update(r),je=n,Te.isReverted=r)},Te.refresh=function(e,t,r,n){if(!je&&Te.enabled||t)if(ae&&e&&st)wb(ScrollTrigger,"scrollEnd",Ob);else{!rt&&Se&&Se(Te),je=Te,A.tween&&!r&&(A.tween.kill(),A.tween=0),ee&&ee.pause(),le&&O&&O.revert({kill:!1}).invalidate(),Te.isReverted||Te.revert(!0,!0),Te._subPinOffset=!1;var o,i,a,s,l,c,u,f,d,p,g,h,v,b=ke(),m=Pe(),y=de?de.duration():Qa(be,he),x=N<=.01,w=0,_=n||0,C=Va(r)?r.end:E.end,T=E.endTrigger||ie,S=Va(r)?r.start:E.start||(0!==E.start&&ie?ae?"0 0":"0 100%":0),k=Te.pinnedContainer=E.pinnedContainer&&J(E.pinnedContainer,Te),P=ie&&Math.max(0,Tt.indexOf(Te))||0,M=P;for(_e&&Va(r)&&(h=He.getProperty(Y,he.p),v=He.getProperty(F,he.p));M--;)(c=Tt[M]).end||c.refresh(0,1)||(je=Te),!(u=c.pin)||u!==ie&&u!==ae&&u!==k||c.isReverted||((p=p||[]).unshift(c),c.revert(!0,!0)),c!==Tt[M]&&(P--,M--);for(Ta(S)&&(S=S(Te)),S=Ca(S,"start",Te),B=mc(S,ie,b,he,Ae(),I,Y,Te,m,Ce,ye,y,de,Te._startClamp&&"_startClamp")||(ae?-.001:0),Ta(C)&&(C=C(Te)),ct(C)&&!C.indexOf("+=")&&(~C.indexOf(" ")?C=(ct(S)?S.split(" ")[0]:"")+C:(w=Cb(C.substr(2),b),C=ct(S)?S:(de?He.utils.mapRange(0,de.duration(),de.scrollTrigger.start,de.scrollTrigger.end,B):B)+w,T=ie)),C=Ca(C,"end",Te),q=Math.max(B,mc(C||(T?"100% 0":y),T,b,he,Ae()+w,L,F,Te,m,Ce,ye,y,de,Te._endClamp&&"_endClamp"))||-.001,w=0,M=P;M--;)(u=(c=Tt[M]).pin)&&c.start-c._pinPush<=B&&!de&&0<c.end&&(o=c.end-(Te._startClamp?Math.max(0,c.start):c.start),(u===ie&&c.start-c._pinPush<B||u===k)&&isNaN(S)&&(w+=o*(1-c.progress)),u===ae&&(_+=o));if(B+=w,q+=w,Te._startClamp&&(Te._startClamp+=w),Te._endClamp&&!rt&&(Te._endClamp=q||-.001,q=Math.min(q,Qa(be,he))),N=q-B||(B-=.01)&&.001,x&&(Oe=He.utils.clamp(0,1,He.utils.normalize(B,q,re))),Te._pinPush=_,I&&w&&((o={})[he.a]="+="+w,k&&(o[he.p]="-="+Ae()),He.set([I,L],o)),!ae||et&&Te.end>=Qa(be,he)){if(ie&&Ae()&&!de)for(i=ie.parentNode;i&&i!==We;)i._pinOffset&&(B-=i._pinOffset,q-=i._pinOffset),i=i.parentNode}else o=mb(ae),s=he===Fe,a=Ae(),G=parseFloat(j(he.a))+_,!y&&1<q&&(g={style:g=(me?Xe.scrollingElement||Je:be).style,value:g["overflow"+he.a.toUpperCase()]},me&&"scroll"!==mb(We)["overflow"+he.a.toUpperCase()]&&(g.style["overflow"+he.a.toUpperCase()]="scroll")),gc(ae,U,o),V=jc(ae),i=wt(ae,!0),f=ye&&K(be,s?Ye:Fe)(),se?((Z=[se+he.os2,N+_+xt]).t=U,(M=se===bt?qb(ae,he)+N+_:0)&&(Z.push(he.d,M+xt),"auto"!==U.style.flexBasis&&(U.style.flexBasis=M+xt)),Et(Z),k&&Tt.forEach(function(e){e.pin===k&&!1!==e.vars.pinSpacing&&(e._subPinOffset=!0)}),ye&&Ae(re)):(M=qb(ae,he))&&"auto"!==U.style.flexBasis&&(U.style.flexBasis=M+xt),ye&&((l={top:i.top+(s?a-B:f)+xt,left:i.left+(s?f:a-B)+xt,boxSizing:"border-box",position:"fixed"})[ft]=l.maxWidth=Math.ceil(i.width)+xt,l[dt]=l.maxHeight=Math.ceil(i.height)+xt,l[mt]=l[mt+ht]=l[mt+pt]=l[mt+vt]=l[mt+gt]="0",l[bt]=o[bt],l[bt+ht]=o[bt+ht],l[bt+pt]=o[bt+pt],l[bt+vt]=o[bt+vt],l[bt+gt]=o[bt+gt],W=function _copyState(e,t,r){for(var n,o=[],i=e.length,a=r?8:0;a<i;a+=2)n=e[a],o.push(n,n in t?t[n]:e[a+1]);return o.t=e.t,o}(X,l,fe),rt&&Ae(0)),O?(d=O._initted,$e(1),O.render(O.duration(),!0,!0),Q=j(he.a)-G+N+_,$=1<Math.abs(N-Q),ye&&$&&W.splice(W.length-2,2),O.render(0,!0,!0),d||O.invalidate(!0),O.parent||O.totalTime(O.totalTime()),$e(0)):Q=N,g&&(g.value?g.style["overflow"+he.a.toUpperCase()]=g.value:g.style.removeProperty("overflow-"+he.a));p&&p.forEach(function(e){return e.revert(!1,!0)}),Te.start=B,Te.end=q,D=R=rt?re:Ae(),de||rt||(D<re&&Ae(re),Te.scroll.rec=0),Te.revert(!1,!0),Ee=at(),te&&(Me=-1,te.restart(!0)),je=0,O&&ve&&(O._initted||ne)&&O.progress()!==ne&&O.progress(ne||0,!0).render(O.time(),!0,!0),(x||Oe!==Te.progress||de||le)&&(O&&!ve&&O.totalProgress(de&&B<-.001&&!Oe?He.utils.normalize(B,q,0):Oe,!0),Te.progress=x||(D-B)/N===Oe?0:Oe),ae&&se&&(U._pinOffset=Math.round(Te.progress*Q)),ee&&ee.invalidate(),isNaN(h)||(h-=He.getProperty(Y,he.p),v-=He.getProperty(F,he.p),qc(Y,he,h),qc(I,he,h-(n||0)),qc(F,he,v),qc(L,he,v-(n||0))),x&&!rt&&Te.update(),!oe||rt||H||(H=!0,oe(Te),H=!1)}},Te.getVelocity=function(){return(Ae()-R)/(at()-Ke)*1e3||0},Te.endAnimation=function(){Wa(Te.callbackAnimation),O&&(ee?ee.progress(1):O.paused()?ve||Wa(O,Te.direction<0,1):Wa(O,O.reversed()))},Te.labelToScroll=function(e){return O&&O.labels&&(B||Te.refresh()||B)+O.labels[e]/O.duration()*N||0},Te.getTrailing=function(t){var e=Tt.indexOf(Te),r=0<Te.direction?Tt.slice(0,e).reverse():Tt.slice(e+1);return(ct(t)?r.filter(function(e){return e.vars.preventOverlaps===t}):r).filter(function(e){return 0<Te.direction?e.end<=B:e.start>=q})},Te.update=function(e,t,r){if(!de||r||e){var n,o,i,a,s,l,c,u=!0===rt?re:Te.scroll(),f=e?0:(u-B)/N,d=f<0?0:1<f?1:f||0,p=Te.progress;if(t&&(R=D,D=de?Ae():u,ue&&(_=w,w=O&&!ve?O.totalProgress():d)),M&&ae&&!je&&!it&&st&&(!d&&B<u+(u-R)/(at()-Ke)*M?d=1e-4:1===d&&q>u+(u-R)/(at()-Ke)*M&&(d=.9999)),d!==p&&Te.enabled){if(a=(s=(n=Te.isActive=!!d&&d<1)!=(!!p&&p<1))||!!d!=!!p,Te.direction=p<d?1:-1,Te.progress=d,a&&!je&&(o=d&&!p?0:1===d?1:1===p?2:3,ve&&(i=!s&&"none"!==we[o+1]&&we[o+1]||we[o],c=O&&("complete"===i||"reset"===i||i in O))),ge&&(s||c)&&(c||P||!O)&&(Ta(ge)?ge(Te):Te.getTrailing(ge).forEach(function(e){return e.endAnimation()})),ve||(!ee||je||it?O&&O.totalProgress(d,!(!je||!Ee&&!e)):(ee._dp._time-ee._start!==ee._time&&ee.render(ee._dp._time-ee._start),ee.resetTo?ee.resetTo("totalProgress",d,O._tTime/O._tDur):(ee.vars.totalProgress=d,ee.invalidate().restart()))),ae)if(e&&se&&(U.style[se+he.os2]=m),ye){if(a){if(l=!e&&p<d&&u<q+1&&u+1>=Qa(be,he),fe)if(e||!n&&!l)oc(ae,U);else{var g=wt(ae,!0),h=u-B;oc(ae,We,g.top+(he===Fe?h:0)+xt,g.left+(he===Fe?0:h)+xt)}Et(n||l?W:V),$&&d<1&&n||b(G+(1!==d||l?0:Q))}}else b(Ia(G+Q*d));!ue||A.tween||je||it||te.restart(!0),S&&(s||ce&&d&&(d<1||!tt))&&Ve(S.targets).forEach(function(e){return e.classList[n||ce?"add":"remove"](S.className)}),!T||ve||e||T(Te),a&&!je?(ve&&(c&&("complete"===i?O.pause().totalProgress(1):"reset"===i?O.restart(!0).pause():"restart"===i?O.restart(!0):O[i]()),T&&T(Te)),!s&&tt||(k&&s&&Xa(Te,k),xe[o]&&Xa(Te,xe[o]),ce&&(1===d?Te.kill(!1,1):xe[o]=0),s||xe[o=1===d?1:3]&&Xa(Te,xe[o])),pe&&!n&&Math.abs(Te.getVelocity())>(Ua(pe)?pe:2500)&&(Wa(Te.callbackAnimation),ee?ee.progress(1):Wa(O,"reverse"===i?1:!d,1))):ve&&T&&!je&&T(Te)}if(x){var v=de?u/de.duration()*(de._caScrollDist||0):u;y(v+(Y._isFlipped?1:0)),x(v)}C&&C(-u/de.duration()*(de._caScrollDist||0))}},Te.enable=function(e,t){Te.enabled||(Te.enabled=!0,wb(be,"resize",Lb),me||wb(be,"scroll",Jb),Se&&wb(ScrollTrigger,"refreshInit",Se),!1!==e&&(Te.progress=Oe=0,D=R=Me=Ae()),!1!==t&&Te.refresh())},Te.getTween=function(e){return e&&A?A.tween:ee},Te.setPositions=function(e,t,r,n){if(de){var o=de.scrollTrigger,i=de.duration(),a=o.end-o.start;e=o.start+a*e/i,t=o.start+a*t/i}Te.refresh(!1,!1,{start:Da(e,r&&!!Te._startClamp),end:Da(t,r&&!!Te._endClamp)},n),Te.update()},Te.adjustPinSpacing=function(e){if(Z&&e){var t=Z.indexOf(he.d)+1;Z[t]=parseFloat(Z[t])+e+xt,Z[1]=parseFloat(Z[1])+e+xt,Et(Z)}},Te.disable=function(e,t){if(Te.enabled&&(!1!==e&&Te.revert(!0,!0),Te.enabled=Te.isActive=!1,t||ee&&ee.pause(),re=0,n&&(n.uncache=1),Se&&xb(ScrollTrigger,"refreshInit",Se),te&&(te.pause(),A.tween&&A.tween.kill()&&(A.tween=0)),!me)){for(var r=Tt.length;r--;)if(Tt[r].scroller===be&&Tt[r]!==Te)return;xb(be,"resize",Lb),me||xb(be,"scroll",Jb)}},Te.kill=function(e,t){Te.disable(e,t),ee&&!t&&ee.kill(),a&&delete St[a];var r=Tt.indexOf(Te);0<=r&&Tt.splice(r,1),r===Qe&&0<Mt&&Qe--,r=0,Tt.forEach(function(e){return e.scroller===Te.scroller&&(r=1)}),r||rt||(Te.scroll.rec=0),O&&(O.scrollTrigger=null,e&&O.revert({kill:!1}),t||O.kill()),I&&[I,L,Y,F].forEach(function(e){return e.parentNode&&e.parentNode.removeChild(e)}),ot===Te&&(ot=0),ae&&(n&&(n.uncache=1),r=0,Tt.forEach(function(e){return e.pin===ae&&r++}),r||(n.spacer=0)),E.onKill&&E.onKill(Te)},Tt.push(Te),Te.enable(!1,!1),i&&i(Te),O&&O.add&&!N){var v=Te.update;Te.update=function(){Te.update=v,B||q||Te.refresh()},He.delayedCall(.01,Te.update),N=.01,B=q=0}else Te.refresh();ae&&function _queueRefreshAll(){if(nt!==kt){var e=nt=kt;requestAnimationFrame(function(){return e===kt&&Pt(!0)})}}()}else this.update=this.refresh=this.kill=Ha},ScrollTrigger.register=function register(e){return s||(He=e||Ka(),Ja()&&window.document&&ScrollTrigger.enable(),s=lt),s},ScrollTrigger.defaults=function defaults(e){if(e)for(var t in e)Ct[t]=e[t];return Ct},ScrollTrigger.disable=function disable(t,r){lt=0,Tt.forEach(function(e){return e[r?"kill":"disable"](t)}),xb(Ne,"wheel",Jb),xb(Xe,"scroll",Jb),clearInterval(u),xb(Xe,"touchcancel",Ha),xb(We,"touchstart",Ha),vb(xb,Xe,"pointerdown,touchstart,mousedown",Fa),vb(xb,Xe,"pointerup,touchend,mouseup",Ga),c.kill(),Ra(xb);for(var e=0;e<Ie.length;e+=3)yb(xb,Ie[e],Ie[e+1]),yb(xb,Ie[e],Ie[e+2])},ScrollTrigger.enable=function enable(){if(Ne=window,Xe=document,Je=Xe.documentElement,We=Xe.body,He&&(Ve=He.utils.toArray,Ue=He.utils.clamp,x=He.core.context||Ha,$e=He.core.suppressOverwrites||Ha,w=Ne.history.scrollRestoration||"auto",Q=Ne.pageYOffset,He.core.globals("ScrollTrigger",ScrollTrigger),We)){lt=1,(_=document.createElement("div")).style.height="100vh",_.style.position="absolute",Yb(),function _rafBugFix(){return lt&&requestAnimationFrame(_rafBugFix)}(),k.register(He),ScrollTrigger.isTouch=k.isTouch,E=k.isTouch&&/(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent),b=1===k.isTouch,wb(Ne,"wheel",Jb),l=[Ne,Xe,Je,We],He.matchMedia?(ScrollTrigger.matchMedia=function(e){var t,r=He.matchMedia();for(t in e)r.add(t,e[t]);return r},He.addEventListener("matchMediaInit",function(){return Sb()}),He.addEventListener("matchMediaRevert",function(){return Rb()}),He.addEventListener("matchMedia",function(){Pt(0,1),U("matchMedia")}),He.matchMedia("(orientation: portrait)",function(){return Kb(),Kb})):console.warn("Requires GSAP 3.11.0 or later"),Kb(),wb(Xe,"scroll",Jb);var e,t,r=We.style,n=r.borderTopStyle,o=He.core.Animation.prototype;for(o.revert||Object.defineProperty(o,"revert",{value:function value(){return this.time(-.01,!0)}}),r.borderTopStyle="solid",e=wt(We),Fe.m=Math.round(e.top+Fe.sc())||0,Ye.m=Math.round(e.left+Ye.sc())||0,n?r.borderTopStyle=n:r.removeProperty("border-top-style"),u=setInterval(Ib,250),He.delayedCall(.5,function(){return it=0}),wb(Xe,"touchcancel",Ha),wb(We,"touchstart",Ha),vb(wb,Xe,"pointerdown,touchstart,mousedown",Fa),vb(wb,Xe,"pointerup,touchend,mouseup",Ga),f=He.utils.checkPrefix("transform"),ee.push(f),s=at(),c=He.delayedCall(.2,Pt).pause(),g=[Xe,"visibilitychange",function(){var e=Ne.innerWidth,t=Ne.innerHeight;Xe.hidden?(d=e,p=t):d===e&&p===t||Lb()},Xe,"DOMContentLoaded",Pt,Ne,"load",Pt,Ne,"resize",Lb],Ra(wb),Tt.forEach(function(e){return e.enable(0,1)}),t=0;t<Ie.length;t+=3)yb(xb,Ie[t],Ie[t+1]),yb(xb,Ie[t],Ie[t+2])}},ScrollTrigger.config=function config(e){"limitCallbacks"in e&&(tt=!!e.limitCallbacks);var t=e.syncInterval;t&&clearInterval(u)||(u=t)&&setInterval(Ib,t),"ignoreMobileResize"in e&&(b=1===ScrollTrigger.isTouch&&e.ignoreMobileResize),"autoRefreshEvents"in e&&(Ra(xb)||Ra(wb,e.autoRefreshEvents||"none"),h=-1===(e.autoRefreshEvents+"").indexOf("resize"))},ScrollTrigger.scrollerProxy=function scrollerProxy(e,t){var r=J(e),n=Ie.indexOf(r),o=La(r);~n&&Ie.splice(n,o?6:2),t&&(o?Le.unshift(Ne,t,We,t,Je,t):Le.unshift(r,t))},ScrollTrigger.clearMatchMedia=function clearMatchMedia(t){Tt.forEach(function(e){return e._ctx&&e._ctx.query===t&&e._ctx.kill(!0,!0)})},ScrollTrigger.isInViewport=function isInViewport(e,t,r){var n=(ct(e)?J(e):e).getBoundingClientRect(),o=n[r?ft:dt]*t||0;return r?0<n.right-o&&n.left+o<Ne.innerWidth:0<n.bottom-o&&n.top+o<Ne.innerHeight},ScrollTrigger.positionInViewport=function positionInViewport(e,t,r){ct(e)&&(e=J(e));var n=e.getBoundingClientRect(),o=n[r?ft:dt],i=null==t?o/2:t in H?H[t]*o:~t.indexOf("%")?parseFloat(t)*o/100:parseFloat(t)||0;return r?(n.left+i)/Ne.innerWidth:(n.top+i)/Ne.innerHeight},ScrollTrigger.killAll=function killAll(e){if(Tt.slice(0).forEach(function(e){return"ScrollSmoother"!==e.vars.id&&e.kill()}),!0!==e){var t=W.killAll||[];W={},t.forEach(function(e){return e()})}},ScrollTrigger);function ScrollTrigger(e,t){s||ScrollTrigger.register(He)||console.warn("Please gsap.registerPlugin(ScrollTrigger)"),x(this),this.init(e,t)}ne.version="3.12.5",ne.saveStyles=function(e){return e?Ve(e).forEach(function(e){if(e&&e.style){var t=j.indexOf(e);0<=t&&j.splice(t,5),j.push(e,e.style.cssText,e.getBBox&&e.getAttribute("transform"),He.core.getCache(e),x())}}):j},ne.revert=function(e,t){return Sb(!e,t)},ne.create=function(e,t){return new ne(e,t)},ne.refresh=function(e){return e?Lb():(s||ne.register())&&Pt(!0)},ne.update=function(e){return++Ie.cache&&Z(!0===e?2:0)},ne.clearScrollMemory=Tb,ne.maxScroll=function(e,t){return Qa(e,t?Ye:Fe)},ne.getScrollFunc=function(e,t){return K(J(e),t?Ye:Fe)},ne.getById=function(e){return St[e]},ne.getAll=function(){return Tt.filter(function(e){return"ScrollSmoother"!==e.vars.id})},ne.isScrolling=function(){return!!st},ne.snapDirectional=tb,ne.addEventListener=function(e,t){var r=W[e]||(W[e]=[]);~r.indexOf(t)||r.push(t)},ne.removeEventListener=function(e,t){var r=W[e],n=r&&r.indexOf(t);0<=n&&r.splice(n,1)},ne.batch=function(e,t){function Cp(e,t){var r=[],n=[],o=He.delayedCall(i,function(){t(r,n),r=[],n=[]}).pause();return function(e){r.length||o.restart(!0),r.push(e.trigger),n.push(e),a<=r.length&&o.progress(1)}}var r,n=[],o={},i=t.interval||.016,a=t.batchMax||1e9;for(r in t)o[r]="on"===r.substr(0,2)&&Ta(t[r])&&"onRefreshInit"!==r?Cp(0,t[r]):t[r];return Ta(a)&&(a=a(),wb(ne,"refresh",function(){return a=t.batchMax()})),Ve(e).forEach(function(e){var t={};for(r in o)t[r]=o[r];t.trigger=e,n.push(ne.create(t))}),n};function tc(e,t,r,n){return n<t?e(n):t<0&&e(0),n<r?(n-t)/(r-t):r<0?t/(t-r):1}function uc(e,t){!0===t?e.style.removeProperty("touch-action"):e.style.touchAction=!0===t?"auto":t?"pan-"+t+(k.isTouch?" pinch-zoom":""):"none",e===Je&&uc(We,t)}function wc(e){var t,r=e.event,n=e.target,o=e.axis,i=(r.changedTouches?r.changedTouches[0]:r).target,a=i._gsap||He.core.getCache(i),s=at();if(!a._isScrollT||2e3<s-a._isScrollT){for(;i&&i!==We&&(i.scrollHeight<=i.clientHeight&&i.scrollWidth<=i.clientWidth||!ie[(t=mb(i)).overflowY]&&!ie[t.overflowX]);)i=i.parentNode;a._isScroll=i&&i!==n&&!La(i)&&(ie[(t=mb(i)).overflowY]||ie[t.overflowX]),a._isScrollT=s}!a._isScroll&&"x"!==o||(r.stopPropagation(),r._gsapAllow=!0)}function xc(e,t,r,n){return k.create({target:e,capture:!0,debounce:!1,lockAxis:!0,type:t,onWheel:n=n&&wc,onPress:n,onDrag:n,onScroll:n,onEnable:function onEnable(){return r&&wb(Xe,k.eventTypes[0],se,!1,!0)},onDisable:function onDisable(){return xb(Xe,k.eventTypes[0],se,!0)}})}function Bc(e){function zq(){return o=!1}function Cq(){i=Qa(p,Fe),S=Ue(E?1:0,i),f&&(T=Ue(0,Qa(p,Ye))),l=kt}function Dq(){v._gsap.y=Ia(parseFloat(v._gsap.y)+b.offset)+"px",v.style.transform="matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, "+parseFloat(v._gsap.y)+", 0, 1)",b.offset=b.cacheID=0}function Jq(){Cq(),a.isActive()&&a.vars.scrollY>i&&(b()>i?a.progress(1)&&b(i):a.resetTo("scrollY",i))}Va(e)||(e={}),e.preventDefault=e.isNormalizer=e.allowClicks=!0,e.type||(e.type="wheel,touch"),e.debounce=!!e.debounce,e.id=e.id||"normalizer";var n,i,l,o,a,c,u,s,f=e.normalizeScrollX,t=e.momentum,r=e.allowNestedScroll,d=e.onRelease,p=J(e.target)||Je,g=He.core.globals().ScrollSmoother,h=g&&g.get(),v=E&&(e.content&&J(e.content)||h&&!1!==e.content&&!h.smooth()&&h.content()),b=K(p,Fe),m=K(p,Ye),y=1,x=(k.isTouch&&Ne.visualViewport?Ne.visualViewport.scale*Ne.visualViewport.width:Ne.outerWidth)/Ne.innerWidth,w=0,_=Ta(t)?function(){return t(n)}:function(){return t||2.8},C=xc(p,e.type,!0,r),T=Ha,S=Ha;return v&&He.set(v,{y:"+=0"}),e.ignoreCheck=function(e){return E&&"touchmove"===e.type&&function ignoreDrag(){if(o){requestAnimationFrame(zq);var e=Ia(n.deltaY/2),t=S(b.v-e);if(v&&t!==b.v+b.offset){b.offset=t-b.v;var r=Ia((parseFloat(v&&v._gsap.y)||0)-b.offset);v.style.transform="matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, "+r+", 0, 1)",v._gsap.y=r+"px",b.cacheID=Ie.cache,Z()}return!0}b.offset&&Dq(),o=!0}()||1.05<y&&"touchstart"!==e.type||n.isGesturing||e.touches&&1<e.touches.length},e.onPress=function(){o=!1;var e=y;y=Ia((Ne.visualViewport&&Ne.visualViewport.scale||1)/x),a.pause(),e!==y&&uc(p,1.01<y||!f&&"x"),c=m(),u=b(),Cq(),l=kt},e.onRelease=e.onGestureStart=function(e,t){if(b.offset&&Dq(),t){Ie.cache++;var r,n,o=_();f&&(n=(r=m())+.05*o*-e.velocityX/.227,o*=tc(m,r,n,Qa(p,Ye)),a.vars.scrollX=T(n)),n=(r=b())+.05*o*-e.velocityY/.227,o*=tc(b,r,n,Qa(p,Fe)),a.vars.scrollY=S(n),a.invalidate().duration(o).play(.01),(E&&a.vars.scrollY>=i||i-1<=r)&&He.to({},{onUpdate:Jq,duration:o})}else s.restart(!0);d&&d(e)},e.onWheel=function(){a._ts&&a.pause(),1e3<at()-w&&(l=0,w=at())},e.onChange=function(e,t,r,n,o){if(kt!==l&&Cq(),t&&f&&m(T(n[2]===t?c+(e.startX-e.x):m()+t-n[1])),r){b.offset&&Dq();var i=o[2]===r,a=i?u+e.startY-e.y:b()+r-o[1],s=S(a);i&&a!==s&&(u+=s-a),b(s)}(r||t)&&Z()},e.onEnable=function(){uc(p,!f&&"x"),ne.addEventListener("refresh",Jq),wb(Ne,"resize",Jq),b.smooth&&(b.target.style.scrollBehavior="auto",b.smooth=m.smooth=!1),C.enable()},e.onDisable=function(){uc(p,!0),xb(Ne,"resize",Jq),ne.removeEventListener("refresh",Jq),C.kill()},e.lockAxis=!1!==e.lockAxis,((n=new k(e)).iOS=E)&&!b()&&b(1),E&&He.ticker.add(Ha),s=n._dc,a=He.to(n,{ease:"power4",paused:!0,inherit:!1,scrollX:f?"+=0.1":"+=0",scrollY:"+=0.1",modifiers:{scrollY:pc(b,b(),function(){return a.pause()})},onUpdate:Z,onComplete:s.vars.onComplete}),n}var oe,ie={auto:1,scroll:1},ae=/(input|label|select|textarea)/i,se=function _captureInputs(e){var t=ae.test(e.target.tagName);(t||oe)&&(e._gsapAllow=!0,oe=t)};ne.sort=function(e){return Tt.sort(e||function(e,t){return-1e6*(e.vars.refreshPriority||0)+e.start-(t.start+-1e6*(t.vars.refreshPriority||0))})},ne.observe=function(e){return new k(e)},ne.normalizeScroll=function(e){if(void 0===e)return v;if(!0===e&&v)return v.enable();if(!1===e)return v&&v.kill(),void(v=e);var t=e instanceof k?e:Bc(e);return v&&v.target===t.target&&v.kill(),La(t.target)&&(v=t),t},ne.core={_getVelocityProp:L,_inputObserver:xc,_scrollers:Ie,_proxies:Le,bridge:{ss:function ss(){st||U("scrollStart"),st=at()},ref:function ref(){return je}}},Ka()&&He.registerPlugin(ne),e.ScrollTrigger=ne,e.default=ne;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});
  
  
  /* locomotive-scroll */
  !function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t||self).LocomotiveScroll=e()}(this,function(){function t(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,s=Array(e);i<e;i++)s[i]=t[i];return s}function e(e,i){var s="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(s)return(s=s.call(e)).next.bind(s);if(Array.isArray(e)||(s=function(e,i){if(e){if("string"==typeof e)return t(e,i);var s={}.toString.call(e).slice(8,-1);return"Object"===s&&e.constructor&&(s=e.constructor.name),"Map"===s||"Set"===s?Array.from(e):"Arguments"===s||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s)?t(e,i):void 0}}(e))||i&&e&&"number"==typeof e.length){s&&(e=s);var n=0;return function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function i(){return i=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var s in i)({}).hasOwnProperty.call(i,s)&&(t[s]=i[s])}return t},i.apply(null,arguments)}function s(t,e,i){return Math.max(t,Math.min(e,i))}var n=class{isRunning=!1;value=0;from=0;to=0;currentTime=0;lerp;duration;easing;onUpdate;advance(t){if(!this.isRunning)return;let e=!1;if(this.duration&&this.easing){this.currentTime+=t;const i=s(0,this.currentTime/this.duration,1);e=i>=1;const n=e?1:this.easing(i);this.value=this.from+(this.to-this.from)*n}else this.lerp?(this.value=function(t,e,i,s){return function(t,e,i){return(1-i)*t+i*e}(t,e,1-Math.exp(-i*s))}(this.value,this.to,60*this.lerp,t),Math.round(this.value)===this.to&&(this.value=this.to,e=!0)):(this.value=this.to,e=!0);e&&this.stop(),this.onUpdate?.(this.value,e)}stop(){this.isRunning=!1}fromTo(t,e,{lerp:i,duration:s,easing:n,onStart:o,onUpdate:r}){this.from=this.value=t,this.to=e,this.lerp=i,this.duration=s,this.easing=n,this.currentTime=0,this.isRunning=!0,o?.(),this.onUpdate=r}},o=class{constructor(t,e,{autoResize:i=!0,debounce:s=250}={}){this.wrapper=t,this.content=e,i&&(this.debouncedResize=function(t,e){let i;return function(...s){let n=this;clearTimeout(i),i=setTimeout(()=>{i=void 0,t.apply(n,s)},e)}}(this.resize,s),this.wrapper instanceof Window?window.addEventListener("resize",this.debouncedResize,!1):(this.wrapperResizeObserver=new ResizeObserver(this.debouncedResize),this.wrapperResizeObserver.observe(this.wrapper)),this.contentResizeObserver=new ResizeObserver(this.debouncedResize),this.contentResizeObserver.observe(this.content)),this.resize()}width=0;height=0;scrollHeight=0;scrollWidth=0;debouncedResize;wrapperResizeObserver;contentResizeObserver;destroy(){this.wrapperResizeObserver?.disconnect(),this.contentResizeObserver?.disconnect(),this.wrapper===window&&this.debouncedResize&&window.removeEventListener("resize",this.debouncedResize,!1)}resize=()=>{this.onWrapperResize(),this.onContentResize()};onWrapperResize=()=>{this.wrapper instanceof Window?(this.width=window.innerWidth,this.height=window.innerHeight):(this.width=this.wrapper.clientWidth,this.height=this.wrapper.clientHeight)};onContentResize=()=>{this.wrapper instanceof Window?(this.scrollHeight=this.content.scrollHeight,this.scrollWidth=this.content.scrollWidth):(this.scrollHeight=this.wrapper.scrollHeight,this.scrollWidth=this.wrapper.scrollWidth)};get limit(){return{x:this.scrollWidth-this.width,y:this.scrollHeight-this.height}}},r=class{events={};emit(t,...e){let i=this.events[t]||[];for(let t=0,s=i.length;t<s;t++)i[t]?.(...e)}on(t,e){return this.events[t]?.push(e)||(this.events[t]=[e]),()=>{this.events[t]=this.events[t]?.filter(t=>e!==t)}}off(t,e){this.events[t]=this.events[t]?.filter(t=>e!==t)}destroy(){this.events={}}},l=100/6,a={passive:!1},h=class{constructor(t,e={wheelMultiplier:1,touchMultiplier:1}){this.element=t,this.options=e,window.addEventListener("resize",this.onWindowResize,!1),this.onWindowResize(),this.element.addEventListener("wheel",this.onWheel,a),this.element.addEventListener("touchstart",this.onTouchStart,a),this.element.addEventListener("touchmove",this.onTouchMove,a),this.element.addEventListener("touchend",this.onTouchEnd,a)}touchStart={x:0,y:0};lastDelta={x:0,y:0};window={width:0,height:0};emitter=new r;on(t,e){return this.emitter.on(t,e)}destroy(){this.emitter.destroy(),window.removeEventListener("resize",this.onWindowResize,!1),this.element.removeEventListener("wheel",this.onWheel,a),this.element.removeEventListener("touchstart",this.onTouchStart,a),this.element.removeEventListener("touchmove",this.onTouchMove,a),this.element.removeEventListener("touchend",this.onTouchEnd,a)}onTouchStart=t=>{const{clientX:e,clientY:i}=t.targetTouches?t.targetTouches[0]:t;this.touchStart.x=e,this.touchStart.y=i,this.lastDelta={x:0,y:0},this.emitter.emit("scroll",{deltaX:0,deltaY:0,event:t})};onTouchMove=t=>{const{clientX:e,clientY:i}=t.targetTouches?t.targetTouches[0]:t,s=-(e-this.touchStart.x)*this.options.touchMultiplier,n=-(i-this.touchStart.y)*this.options.touchMultiplier;this.touchStart.x=e,this.touchStart.y=i,this.lastDelta={x:s,y:n},this.emitter.emit("scroll",{deltaX:s,deltaY:n,event:t})};onTouchEnd=t=>{this.emitter.emit("scroll",{deltaX:this.lastDelta.x,deltaY:this.lastDelta.y,event:t})};onWheel=t=>{let{deltaX:e,deltaY:i,deltaMode:s}=t;e*=1===s?l:2===s?this.window.width:1,i*=1===s?l:2===s?this.window.height:1,e*=this.options.wheelMultiplier,i*=this.options.wheelMultiplier,this.emitter.emit("scroll",{deltaX:e,deltaY:i,event:t})};onWindowResize=()=>{this.window={width:window.innerWidth,height:window.innerHeight}}},c=t=>Math.min(1,1.001-Math.pow(2,-10*t)),u=class{_isScrolling=!1;_isStopped=!1;_isLocked=!1;_preventNextNativeScrollEvent=!1;_resetVelocityTimeout=null;_rafId=null;isTouching;time=0;userData={};lastVelocity=0;velocity=0;direction=0;options;targetScroll;animatedScroll;animate=new n;emitter=new r;dimensions;virtualScroll;constructor({wrapper:t=window,content:e=document.documentElement,eventsTarget:i=t,smoothWheel:s=!0,syncTouch:n=!1,syncTouchLerp:r=.075,touchInertiaExponent:l=1.7,duration:a,easing:u,lerp:d=.1,infinite:p=!1,orientation:v="vertical",gestureOrientation:m=("horizontal"===v?"both":"vertical"),touchMultiplier:f=1,wheelMultiplier:g=1,autoResize:S=!0,prevent:w,virtualScroll:b,overscroll:E=!0,autoRaf:y=!1,anchors:I=!1,autoToggle:R=!1,allowNestedScroll:_=!1,__experimental__naiveDimensions:T=!1,naiveDimensions:O=T,stopInertiaOnNavigate:z=!1}={}){window.lenisVersion="1.3.17",t&&t!==document.documentElement||(t=window),"number"==typeof a&&"function"!=typeof u?u=c:"function"==typeof u&&"number"!=typeof a&&(a=1),this.options={wrapper:t,content:e,eventsTarget:i,smoothWheel:s,syncTouch:n,syncTouchLerp:r,touchInertiaExponent:l,duration:a,easing:u,lerp:d,infinite:p,gestureOrientation:m,orientation:v,touchMultiplier:f,wheelMultiplier:g,autoResize:S,prevent:w,virtualScroll:b,overscroll:E,autoRaf:y,anchors:I,autoToggle:R,allowNestedScroll:_,naiveDimensions:O,stopInertiaOnNavigate:z},this.dimensions=new o(t,e,{autoResize:S}),this.updateClassName(),this.targetScroll=this.animatedScroll=this.actualScroll,this.options.wrapper.addEventListener("scroll",this.onNativeScroll,!1),this.options.wrapper.addEventListener("scrollend",this.onScrollEnd,{capture:!0}),(this.options.anchors||this.options.stopInertiaOnNavigate)&&this.options.wrapper.addEventListener("click",this.onClick,!1),this.options.wrapper.addEventListener("pointerdown",this.onPointerDown,!1),this.virtualScroll=new h(i,{touchMultiplier:f,wheelMultiplier:g}),this.virtualScroll.on("scroll",this.onVirtualScroll),this.options.autoToggle&&(this.checkOverflow(),this.rootElement.addEventListener("transitionend",this.onTransitionEnd,{passive:!0})),this.options.autoRaf&&(this._rafId=requestAnimationFrame(this.raf))}destroy(){this.emitter.destroy(),this.options.wrapper.removeEventListener("scroll",this.onNativeScroll,!1),this.options.wrapper.removeEventListener("scrollend",this.onScrollEnd,{capture:!0}),this.options.wrapper.removeEventListener("pointerdown",this.onPointerDown,!1),(this.options.anchors||this.options.stopInertiaOnNavigate)&&this.options.wrapper.removeEventListener("click",this.onClick,!1),this.virtualScroll.destroy(),this.dimensions.destroy(),this.cleanUpClassName(),this._rafId&&cancelAnimationFrame(this._rafId)}on(t,e){return this.emitter.on(t,e)}off(t,e){return this.emitter.off(t,e)}onScrollEnd=t=>{t instanceof CustomEvent||"smooth"!==this.isScrolling&&!1!==this.isScrolling||t.stopPropagation()};dispatchScrollendEvent=()=>{this.options.wrapper.dispatchEvent(new CustomEvent("scrollend",{bubbles:this.options.wrapper===window,detail:{lenisScrollEnd:!0}}))};get overflow(){const t=this.isHorizontal?"overflow-x":"overflow-y";return getComputedStyle(this.rootElement)[t]}checkOverflow(){["hidden","clip"].includes(this.overflow)?this.internalStop():this.internalStart()}onTransitionEnd=t=>{t.propertyName.includes("overflow")&&this.checkOverflow()};setScroll(t){this.options.wrapper.scrollTo(this.isHorizontal?{left:t,behavior:"instant"}:{top:t,behavior:"instant"})}onClick=t=>{const e=t.composedPath().filter(t=>t instanceof HTMLAnchorElement&&t.getAttribute("href"));if(this.options.anchors){const t=e.find(t=>t.getAttribute("href")?.includes("#"));if(t){const e=t.getAttribute("href");if(e){const t="object"==typeof this.options.anchors&&this.options.anchors?this.options.anchors:void 0,i=`#${e.split("#")[1]}`;this.scrollTo(i,t)}}}this.options.stopInertiaOnNavigate&&e.find(t=>t.host===window.location.host)&&this.reset()};onPointerDown=t=>{1===t.button&&this.reset()};onVirtualScroll=t=>{if("function"==typeof this.options.virtualScroll&&!1===this.options.virtualScroll(t))return;const{deltaX:e,deltaY:i,event:s}=t;if(this.emitter.emit("virtual-scroll",{deltaX:e,deltaY:i,event:s}),s.ctrlKey)return;if(s.lenisStopPropagation)return;const n=s.type.includes("touch"),o=s.type.includes("wheel");this.isTouching="touchstart"===s.type||"touchmove"===s.type;const r=0===e&&0===i;if(this.options.syncTouch&&n&&"touchstart"===s.type&&r&&!this.isStopped&&!this.isLocked)return void this.reset();if(r||"vertical"===this.options.gestureOrientation&&0===i||"horizontal"===this.options.gestureOrientation&&0===e)return;let l=s.composedPath();l=l.slice(0,l.indexOf(this.rootElement));const a=this.options.prevent;if(l.find(t=>t instanceof HTMLElement&&("function"==typeof a&&a?.(t)||t.hasAttribute?.("data-lenis-prevent")||n&&t.hasAttribute?.("data-lenis-prevent-touch")||o&&t.hasAttribute?.("data-lenis-prevent-wheel")||this.options.allowNestedScroll&&this.checkNestedScroll(t,{deltaX:e,deltaY:i}))))return;if(this.isStopped||this.isLocked)return void(s.cancelable&&s.preventDefault());if(!(this.options.syncTouch&&n||this.options.smoothWheel&&o))return this.isScrolling="native",this.animate.stop(),void(s.lenisStopPropagation=!0);let h=i;"both"===this.options.gestureOrientation?h=Math.abs(i)>Math.abs(e)?i:e:"horizontal"===this.options.gestureOrientation&&(h=e),(!this.options.overscroll||this.options.infinite||this.options.wrapper!==window&&this.limit>0&&(this.animatedScroll>0&&this.animatedScroll<this.limit||0===this.animatedScroll&&i>0||this.animatedScroll===this.limit&&i<0))&&(s.lenisStopPropagation=!0),s.cancelable&&s.preventDefault();const c=n&&this.options.syncTouch,u=n&&"touchend"===s.type;u&&(h=Math.sign(this.velocity)*Math.pow(Math.abs(this.velocity),this.options.touchInertiaExponent)),this.scrollTo(this.targetScroll+h,{programmatic:!1,...c?{lerp:u?this.options.syncTouchLerp:1}:{lerp:this.options.lerp,duration:this.options.duration,easing:this.options.easing}})};resize(){this.dimensions.resize(),this.animatedScroll=this.targetScroll=this.actualScroll,this.emit()}emit(){this.emitter.emit("scroll",this)}onNativeScroll=()=>{if(null!==this._resetVelocityTimeout&&(clearTimeout(this._resetVelocityTimeout),this._resetVelocityTimeout=null),this._preventNextNativeScrollEvent)this._preventNextNativeScrollEvent=!1;else if(!1===this.isScrolling||"native"===this.isScrolling){const t=this.animatedScroll;this.animatedScroll=this.targetScroll=this.actualScroll,this.lastVelocity=this.velocity,this.velocity=this.animatedScroll-t,this.direction=Math.sign(this.animatedScroll-t),this.isStopped||(this.isScrolling="native"),this.emit(),0!==this.velocity&&(this._resetVelocityTimeout=setTimeout(()=>{this.lastVelocity=this.velocity,this.velocity=0,this.isScrolling=!1,this.emit()},400))}};reset(){this.isLocked=!1,this.isScrolling=!1,this.animatedScroll=this.targetScroll=this.actualScroll,this.lastVelocity=this.velocity=0,this.animate.stop()}start(){this.isStopped&&(this.options.autoToggle?this.rootElement.style.removeProperty("overflow"):this.internalStart())}internalStart(){this.isStopped&&(this.reset(),this.isStopped=!1,this.emit())}stop(){this.isStopped||(this.options.autoToggle?this.rootElement.style.setProperty("overflow","clip"):this.internalStop())}internalStop(){this.isStopped||(this.reset(),this.isStopped=!0,this.emit())}raf=t=>{const e=t-(this.time||t);this.time=t,this.animate.advance(.001*e),this.options.autoRaf&&(this._rafId=requestAnimationFrame(this.raf))};scrollTo(t,{offset:e=0,immediate:i=!1,lock:n=!1,programmatic:o=!0,lerp:r=(o?this.options.lerp:void 0),duration:l=(o?this.options.duration:void 0),easing:a=(o?this.options.easing:void 0),onStart:h,onComplete:u,force:d=!1,userData:p}={}){if(!this.isStopped&&!this.isLocked||d){if("string"==typeof t&&["top","left","start","#"].includes(t))t=0;else if("string"==typeof t&&["bottom","right","end"].includes(t))t=this.limit;else{let i;if("string"==typeof t?(i=document.querySelector(t),i||("#top"===t?t=0:console.warn("Lenis: Target not found",t))):t instanceof HTMLElement&&t?.nodeType&&(i=t),i){if(this.options.wrapper!==window){const t=this.rootElement.getBoundingClientRect();e-=this.isHorizontal?t.left:t.top}const s=i.getBoundingClientRect();t=(this.isHorizontal?s.left:s.top)+this.animatedScroll}}if("number"==typeof t){if(t+=e,t=Math.round(t),this.options.infinite){if(o){this.targetScroll=this.animatedScroll=this.scroll;const e=t-this.animatedScroll;e>this.limit/2?t-=this.limit:e<-this.limit/2&&(t+=this.limit)}}else t=s(0,t,this.limit);if(t===this.targetScroll)return h?.(this),void u?.(this);if(this.userData=p??{},i)return this.animatedScroll=this.targetScroll=t,this.setScroll(this.scroll),this.reset(),this.preventNextNativeScrollEvent(),this.emit(),u?.(this),this.userData={},void requestAnimationFrame(()=>{this.dispatchScrollendEvent()});o||(this.targetScroll=t),"number"==typeof l&&"function"!=typeof a?a=c:"function"==typeof a&&"number"!=typeof l&&(l=1),this.animate.fromTo(this.animatedScroll,t,{duration:l,easing:a,lerp:r,onStart:()=>{n&&(this.isLocked=!0),this.isScrolling="smooth",h?.(this)},onUpdate:(t,e)=>{this.isScrolling="smooth",this.lastVelocity=this.velocity,this.velocity=t-this.animatedScroll,this.direction=Math.sign(this.velocity),this.animatedScroll=t,this.setScroll(this.scroll),o&&(this.targetScroll=t),e||this.emit(),e&&(this.reset(),this.emit(),u?.(this),this.userData={},requestAnimationFrame(()=>{this.dispatchScrollendEvent()}),this.preventNextNativeScrollEvent())}})}}}preventNextNativeScrollEvent(){this._preventNextNativeScrollEvent=!0,requestAnimationFrame(()=>{this._preventNextNativeScrollEvent=!1})}checkNestedScroll(t,{deltaX:e,deltaY:i}){const s=Date.now(),n=t._lenis??={};let o,r,l,a,h,c,u,d;const p=this.options.gestureOrientation;if(s-(n.time??0)>2e3){n.time=Date.now();const e=window.getComputedStyle(t);n.computedStyle=e;const i=e.overflowY;if(o=["auto","overlay","scroll"].includes(e.overflowX),r=["auto","overlay","scroll"].includes(i),n.hasOverflowX=o,n.hasOverflowY=r,!o&&!r)return!1;if("vertical"===p&&!r)return!1;if("horizontal"===p&&!o)return!1;h=t.scrollWidth,c=t.scrollHeight,u=t.clientWidth,d=t.clientHeight,l=h>u,a=c>d,n.isScrollableX=l,n.isScrollableY=a,n.scrollWidth=h,n.scrollHeight=c,n.clientWidth=u,n.clientHeight=d}else l=n.isScrollableX,a=n.isScrollableY,o=n.hasOverflowX,r=n.hasOverflowY,h=n.scrollWidth,c=n.scrollHeight,u=n.clientWidth,d=n.clientHeight;if(!o&&!r||!l&&!a)return!1;if(!("vertical"!==p||r&&a))return!1;if(!("horizontal"!==p||o&&l))return!1;let v,m,f,g,S,w;if("horizontal"===p?v="x":"vertical"===p?v="y":(0!==e&&o&&l&&(v="x"),0!==i&&r&&a&&(v="y")),!v)return!1;if("x"===v)m=t.scrollLeft,f=h-u,g=e,S=o,w=l;else{if("y"!==v)return!1;m=t.scrollTop,f=c-d,g=i,S=r,w=a}return(g>0?m<f:m>0)&&S&&w}get rootElement(){return this.options.wrapper===window?document.documentElement:this.options.wrapper}get limit(){return this.options.naiveDimensions?this.isHorizontal?this.rootElement.scrollWidth-this.rootElement.clientWidth:this.rootElement.scrollHeight-this.rootElement.clientHeight:this.dimensions.limit[this.isHorizontal?"x":"y"]}get isHorizontal(){return"horizontal"===this.options.orientation}get actualScroll(){const t=this.options.wrapper;return this.isHorizontal?t.scrollX??t.scrollLeft:t.scrollY??t.scrollTop}get scroll(){return this.options.infinite?(this.animatedScroll%(t=this.limit)+t)%t:this.animatedScroll;var t}get progress(){return 0===this.limit?1:this.scroll/this.limit}get isScrolling(){return this._isScrolling}set isScrolling(t){this._isScrolling!==t&&(this._isScrolling=t,this.updateClassName())}get isStopped(){return this._isStopped}set isStopped(t){this._isStopped!==t&&(this._isStopped=t,this.updateClassName())}get isLocked(){return this._isLocked}set isLocked(t){this._isLocked!==t&&(this._isLocked=t,this.updateClassName())}get isSmooth(){return"smooth"===this.isScrolling}get className(){let t="lenis";return this.options.autoToggle&&(t+=" lenis-autoToggle"),this.isStopped&&(t+=" lenis-stopped"),this.isLocked&&(t+=" lenis-locked"),this.isScrolling&&(t+=" lenis-scrolling"),"smooth"===this.isScrolling&&(t+=" lenis-smooth"),t}updateClassName(){this.cleanUpClassName(),this.rootElement.className=`${this.rootElement.className} ${this.className}`.trim()}cleanUpClassName(){this.rootElement.className=this.rootElement.className.replace(/lenis(-\w+)?/g,"").trim()}},d=/*#__PURE__*/function(){function t(t){var e=t.scrollElements,i=t.rootMargin,s=void 0===i?"-1px -1px -1px -1px":i,n=t.root,o=void 0===n?null:n,r=t.IORaf;this.scrollElements=void 0,this.rootMargin=void 0,this.root=void 0,this.IORaf=void 0,this.observer=void 0,this.scrollElements=e,this.rootMargin=s,this.root=o,this.IORaf=r,this._init()}var i=t.prototype;return i._init=function(){var t=this;this.observer=new IntersectionObserver(function(e){e.forEach(function(e){var i=t.scrollElements.find(function(t){return t.$el===e.target});e.isIntersecting?(i&&(i.isAlreadyIntersected=!0),t._setInview(e)):i&&i.isAlreadyIntersected&&t._setOutOfView(e)})},{root:this.root,rootMargin:this.rootMargin});for(var i,s=e(this.scrollElements);!(i=s()).done;)this.observe(i.value.$el)},i.destroy=function(){this.observer.disconnect()},i.observe=function(t){t&&this.observer.observe(t)},i.unobserve=function(t){t&&this.observer.unobserve(t)},i._setInview=function(t){var e=this.scrollElements.find(function(e){return e.$el===t.target});this.IORaf&&(null==e||e.setInteractivityOn()),!this.IORaf&&(null==e||e.setInview())},i._setOutOfView=function(t){var e=this.scrollElements.find(function(e){return e.$el===t.target});this.IORaf&&(null==e||e.setInteractivityOff()),!this.IORaf&&(null==e||e.setOutOfView()),null!=e&&e.attributes.scrollRepeat||this.IORaf||this.unobserve(t.target)},t}();function p(t,e,i,s,n){return i+((n-t)/(e-t)*(s-i)||0)}function v(t,e){return t.reduce(function(t,i){return Math.abs(i-e)<Math.abs(t-e)?i:t})}var m="--progress",f=/*#__PURE__*/function(){function t(t){var e,i,s,n,o,r=this,l=t.$el,a=t.id,h=t.subscribeElementUpdateFn,c=t.unsubscribeElementUpdateFn,u=t.needRaf,d=t.scrollOrientation,p=t.lenisInstance;this.$el=void 0,this.id=void 0,this.needRaf=void 0,this.attributes=void 0,this.scrollOrientation=void 0,this.isAlreadyIntersected=void 0,this.intersection=void 0,this.metrics=void 0,this.currentScroll=void 0,this.translateValue=void 0,this.progress=void 0,this.lastProgress=void 0,this.isInview=void 0,this.isInteractive=void 0,this.isInFold=void 0,this.isFirstResize=void 0,this.subscribeElementUpdateFn=void 0,this.unsubscribeElementUpdateFn=void 0,this.lenisInstance=void 0,this.getWindowSize=void 0,this.getMetricsStart=void 0,this.getMetricsSize=void 0,this.startPositionHandlers={start:function(t,e,i){return t-e+i},middle:function(t,e,i,s){return t-e+i+.5*s},end:function(t,e,i,s){return t-e+i+s},fold:function(){return 0}},this.endPositionHandlers={start:function(t,e){return t-e},middle:function(t,e,i){return t-e+.5*i},end:function(t,e,i){return t-e+i}},this.$el=l,this.id=a,this.needRaf=u,this.scrollOrientation=d,this.lenisInstance=p,this.subscribeElementUpdateFn=h,this.unsubscribeElementUpdateFn=c,this.attributes={scrollClass:null!=(e=this.$el.dataset.scrollClass)?e:"is-inview",scrollOffset:null!=(i=this.$el.dataset.scrollOffset)?i:"0,0",scrollPosition:null!=(s=this.$el.dataset.scrollPosition)?s:"start,end",scrollCssProgress:void 0!==this.$el.dataset.scrollCssProgress,scrollEventProgress:null!=(n=this.$el.dataset.scrollEventProgress)?n:null,scrollSpeed:void 0!==this.$el.dataset.scrollSpeed?parseFloat(this.$el.dataset.scrollSpeed):null,scrollRepeat:void 0!==this.$el.dataset.scrollRepeat,scrollCall:null!=(o=this.$el.dataset.scrollCall)?o:null,scrollIgnoreFold:void 0!==this.$el.dataset.scrollIgnoreFold,scrollEnableTouchSpeed:void 0!==this.$el.dataset.scrollEnableTouchSpeed},this.intersection={start:0,end:0},this.metrics={offsetStart:0,offsetEnd:0,bcr:{}},this.currentScroll=this.lenisInstance.scroll,this.translateValue=0,this.progress=0,this.lastProgress=null,this.isInview=!1,this.isInteractive=!1,this.isAlreadyIntersected=!1,this.isInFold=!1,this.isFirstResize=!0,this.getWindowSize="vertical"===this.scrollOrientation?function(){return r.lenisInstance.dimensions.height}:function(){return r.lenisInstance.dimensions.width},this.getMetricsStart="vertical"===this.scrollOrientation?function(t){return t.top}:function(t){return t.left},this.getMetricsSize="vertical"===this.scrollOrientation?function(t){return t.height}:function(t){return t.width},this._init()}var e=t.prototype;return e._init=function(){this.needRaf&&this._resize()},e.onResize=function(t){this.currentScroll=t.currentScroll,this._resize()},e.onRender=function(t){var e=t.currentScroll,i=t.smooth,s=this.getWindowSize();if(this.currentScroll=e,this._computeProgress(),this.attributes.scrollSpeed&&!isNaN(this.attributes.scrollSpeed))if(this.attributes.scrollEnableTouchSpeed||i){if(this.isInFold){var n=Math.max(0,this.progress);this.translateValue=n*s*this.attributes.scrollSpeed*-1}else{var o=p(0,1,-1,1,this.progress);this.translateValue=o*s*this.attributes.scrollSpeed*-1}this.$el.style.transform="vertical"===this.scrollOrientation?"translate3d(0, "+this.translateValue+"px, 0)":"translate3d("+this.translateValue+"px, 0, 0)"}else this.translateValue&&(this.$el.style.transform="translate3d(0, 0, 0)"),this.translateValue=0},e.setInview=function(){if(!this.isInview){this.isInview=!0,this.$el.classList.add(this.attributes.scrollClass);var t=this._getScrollCallFrom();this.attributes.scrollCall&&this._dispatchCall("enter",t)}},e.setOutOfView=function(){if(this.isInview&&this.attributes.scrollRepeat){this.isInview=!1,this.$el.classList.remove(this.attributes.scrollClass);var t=this._getScrollCallFrom();this.attributes.scrollCall&&this._dispatchCall("leave",t)}},e.setInteractivityOn=function(){this.isInteractive||(this.isInteractive=!0,this.subscribeElementUpdateFn(this))},e.setInteractivityOff=function(){this.isInteractive&&(this.isInteractive=!1,this.unsubscribeElementUpdateFn(this),null!==this.lastProgress&&this._computeProgress(v([0,1],this.lastProgress)))},e._resize=function(){this.metrics.bcr=this.$el.getBoundingClientRect(),this._computeMetrics(),this._computeIntersection(),this.isFirstResize&&(this.isFirstResize=!1,this.isInFold&&this.setInview())},e._computeMetrics=function(){var t=this.getWindowSize(),e=this.getMetricsStart(this.metrics.bcr),i=this.getMetricsSize(this.metrics.bcr);this.metrics.offsetStart=this.currentScroll+e-this.translateValue,this.metrics.offsetEnd=this.metrics.offsetStart+i,this.isInFold=this.metrics.offsetStart<t&&!this.attributes.scrollIgnoreFold},e._computeIntersection=function(){var t,e,i,s,n,o,r,l,a=this.getWindowSize(),h=this.getMetricsSize(this.metrics.bcr),c=this.attributes.scrollOffset.split(","),u=null!=(t=null==(e=c[0])?void 0:e.trim())?t:"0",d=null!=(i=null==(s=c[1])?void 0:s.trim())?i:"0",p=this.attributes.scrollPosition.split(","),v=null!=(n=null==(o=p[0])?void 0:o.trim())?n:"start",m=null!=(r=null==(l=p[1])?void 0:l.trim())?r:"end",f=u.includes("%")?a*parseInt(u.replace("%","").trim())*.01:parseInt(u),g=d.includes("%")?a*parseInt(d.replace("%","").trim())*.01:parseInt(d);this.isInFold&&(v="fold");var S=this.startPositionHandlers[v];this.intersection.start=S?S(this.metrics.offsetStart,a,f,h):this.metrics.offsetStart-a+f;var w=this.endPositionHandlers[m];if(this.intersection.end=w?w(this.metrics.offsetStart,g,h):this.metrics.offsetStart-g+h,this.intersection.end<=this.intersection.start)switch(m){case"start":default:this.intersection.end=this.intersection.start+1;break;case"middle":this.intersection.end=this.intersection.start+.5*h;break;case"end":this.intersection.end=this.intersection.start+h}},e._computeProgress=function(t){var e,i=null!=t?t:(e=p(this.intersection.start,this.intersection.end,0,1,this.currentScroll))<0?0:e>1?1:e;this.progress=i,i!==this.lastProgress&&(this.lastProgress=i,this.attributes.scrollCssProgress&&this._setCssProgress(i),this.attributes.scrollEventProgress&&this._setCustomEventProgress(i),i>0&&i<1&&this.setInview(),0===i&&this.setOutOfView(),1===i&&this.setOutOfView())},e._setCssProgress=function(t){void 0===t&&(t=0),this.$el.style.setProperty(m,t.toString())},e._setCustomEventProgress=function(t){void 0===t&&(t=0);var e=this.attributes.scrollEventProgress;if(e){var i=new CustomEvent(e,{detail:{target:this.$el,progress:t}});window.dispatchEvent(i)}},e._getScrollCallFrom=function(){var t=v([this.intersection.start,this.intersection.end],this.currentScroll);return this.intersection.start===t?"start":"end"},e.destroy=function(){this.attributes.scrollCssProgress&&this.$el.style.removeProperty(m),this.attributes.scrollSpeed&&this.$el.style.removeProperty("transform"),this.isInview&&this.attributes.scrollClass&&this.$el.classList.remove(this.attributes.scrollClass)},e._dispatchCall=function(t,e){var i=this.attributes.scrollCall;if(i){var s=new CustomEvent(i,{detail:{target:this.$el,way:t,from:e}});window.dispatchEvent(s)}},t}(),g=["scrollOffset","scrollPosition","scrollCssProgress","scrollEventProgress","scrollSpeed"],S=/*#__PURE__*/function(){function t(t){var e=t.$el,i=t.triggerRootMargin,s=t.rafRootMargin,n=t.scrollOrientation,o=t.lenisInstance;this.$scrollContainer=void 0,this.triggerRootMargin=void 0,this.rafRootMargin=void 0,this.scrollElements=void 0,this.triggeredScrollElements=void 0,this.RAFScrollElements=void 0,this.scrollElementsToUpdate=void 0,this.IOTriggerInstance=void 0,this.IORafInstance=void 0,this.scrollOrientation=void 0,this.lenisInstance=void 0,e?(this.$scrollContainer=e,this.lenisInstance=o,this.scrollOrientation=n,this.triggerRootMargin=null!=i?i:"-1px -1px -1px -1px",this.rafRootMargin=null!=s?s:"100% 100% 100% 100%",this.scrollElements=[],this.triggeredScrollElements=[],this.RAFScrollElements=[],this.scrollElementsToUpdate=[],this._init()):console.error("Please provide a DOM Element as scrollContainer")}var i=t.prototype;return i._init=function(){var t=this.$scrollContainer.querySelectorAll("[data-scroll]"),e=this.toElementArray(t);this._subscribeScrollElements(e);var i=this.lenisInstance.options.wrapper===window?null:this.lenisInstance.options.wrapper;this.IOTriggerInstance=new d({scrollElements:[].concat(this.triggeredScrollElements),root:i,rootMargin:this.triggerRootMargin,IORaf:!1}),this.IORafInstance=new d({scrollElements:[].concat(this.RAFScrollElements),root:i,rootMargin:this.rafRootMargin,IORaf:!0})},i.destroy=function(){this.IOTriggerInstance.destroy(),this.IORafInstance.destroy(),this._unsubscribeAllScrollElements()},i.onResize=function(t){for(var i,s=t.currentScroll,n=e(this.RAFScrollElements);!(i=n()).done;)i.value.onResize({currentScroll:s})},i.onRender=function(t){for(var i,s=t.currentScroll,n=t.smooth,o=e(this.scrollElementsToUpdate);!(i=o()).done;)i.value.onRender({currentScroll:s,smooth:n})},i.removeScrollElements=function(t){var e=this,i=t.querySelectorAll("[data-scroll]");if(i.length){for(var s=new Set(Array.from(i)),n=0;n<this.triggeredScrollElements.length;n++){var o=this.triggeredScrollElements[n];s.has(o.$el)&&(this.IOTriggerInstance.unobserve(o.$el),this.triggeredScrollElements.splice(n,1))}for(var r=0;r<this.RAFScrollElements.length;r++){var l=this.RAFScrollElements[r];s.has(l.$el)&&(this.IORafInstance.unobserve(l.$el),this.RAFScrollElements.splice(r,1))}i.forEach(function(t){var i=e.scrollElementsToUpdate.find(function(e){return e.$el===t}),s=e.scrollElements.find(function(e){return e.$el===t});i&&e._unsubscribeElementUpdate(i),s&&(e.scrollElements=e.scrollElements.filter(function(t){return t.id!=s.id}))})}},i.addScrollElements=function(t){var e=t.querySelectorAll("[data-scroll]"),i=[];this.scrollElements.forEach(function(t){i.push(t.id)});var s=Math.max.apply(Math,i.concat([0]))+1,n=this.toElementArray(e);this._subscribeScrollElements(n,s,!0)},i._subscribeScrollElements=function(t,e,i){void 0===e&&(e=0),void 0===i&&(i=!1);for(var s=0;s<t.length;s++){var n=t[s],o=this._checkRafNeeded(n),r=new f({$el:n,id:e+s,scrollOrientation:this.scrollOrientation,lenisInstance:this.lenisInstance,subscribeElementUpdateFn:this._subscribeElementUpdate.bind(this),unsubscribeElementUpdateFn:this._unsubscribeElementUpdate.bind(this),needRaf:o});this.scrollElements.push(r),o?(this.RAFScrollElements.push(r),i&&(this.IORafInstance.scrollElements.push(r),this.IORafInstance.observe(r.$el))):(this.triggeredScrollElements.push(r),i&&(this.IOTriggerInstance.scrollElements.push(r),this.IOTriggerInstance.observe(r.$el)))}},i._unsubscribeAllScrollElements=function(){for(var t,i=e(this.scrollElements);!(t=i()).done;)t.value.destroy();this.scrollElements=[],this.RAFScrollElements=[],this.triggeredScrollElements=[],this.scrollElementsToUpdate=[]},i._subscribeElementUpdate=function(t){this.scrollElementsToUpdate.push(t)},i._unsubscribeElementUpdate=function(t){this.scrollElementsToUpdate=this.scrollElementsToUpdate.filter(function(e){return e.id!=t.id})},i.toElementArray=function(t){return Array.from(t)},i._checkRafNeeded=function(t){var i=[].concat(g),s=function(t){i=i.filter(function(e){return e!==t})};if(t.dataset.scrollOffset){if("0,0"!==t.dataset.scrollOffset.split(",").map(function(t){return t.replace("%","").trim()}).join(","))return!0;s("scrollOffset")}else s("scrollOffset");if(t.dataset.scrollPosition){if("top,bottom"!==t.dataset.scrollPosition.trim())return!0;s("scrollPosition")}else s("scrollPosition");if(t.dataset.scrollSpeed&&!isNaN(parseFloat(t.dataset.scrollSpeed)))return!0;s("scrollSpeed");for(var n,o=e(i);!(n=o()).done;)if(n.value in t.dataset)return!0;return!1},t}();/*#__PURE__*/
  return function(){function t(t){var e=void 0===t?{}:t,i=e.lenisOptions,s=void 0===i?{}:i,n=e.triggerRootMargin,o=e.rafRootMargin,r=e.autoStart,l=void 0===r||r,a=e.scrollCallback,h=void 0===a?function(){}:a,c=e.initCustomTicker,u=e.destroyCustomTicker;this.rafPlaying=void 0,this.lenisInstance=null,this.coreInstance=null,this.lenisOptions=void 0,this.triggerRootMargin=void 0,this.rafRootMargin=void 0,this.rafInstance=void 0,this.autoStart=void 0,this.isTouchDevice=void 0,this.initCustomTicker=void 0,this.destroyCustomTicker=void 0,this._onRenderBind=void 0,this._onResizeBind=void 0,this._onScrollToBind=void 0,this._originalOnContentResize=void 0,this._originalOnWrapperResize=void 0,window.locomotiveScrollVersion="5.0.0",Object.assign(this,{lenisOptions:s,triggerRootMargin:n,rafRootMargin:o,autoStart:l,scrollCallback:h,initCustomTicker:c,destroyCustomTicker:u}),this._onRenderBind=this._onRender.bind(this),this._onScrollToBind=this._onScrollTo.bind(this),this._onResizeBind=this._onResize.bind(this),this.rafPlaying=!1,this.isTouchDevice="ontouchstart"in window||navigator.maxTouchPoints>0,this._init()}var e=t.prototype;return e._init=function(){var t=this;this.lenisInstance=new u(i({},this.lenisOptions)),this.scrollCallback&&this.lenisInstance.on("scroll",this.scrollCallback),document.documentElement.setAttribute("data-scroll-orientation",this.lenisInstance.options.orientation),requestAnimationFrame(function(){t.coreInstance=new S({$el:t.lenisInstance.rootElement,triggerRootMargin:t.triggerRootMargin,rafRootMargin:t.rafRootMargin,scrollOrientation:t.lenisInstance.options.orientation,lenisInstance:t.lenisInstance}),t._bindEvents(),t.initCustomTicker&&!t.destroyCustomTicker?console.warn("initCustomTicker callback is declared, but destroyCustomTicker is not. Please pay attention. It could cause trouble."):!t.initCustomTicker&&t.destroyCustomTicker&&console.warn("destroyCustomTicker callback is declared, but initCustomTicker is not. Please pay attention. It could cause trouble."),t.autoStart&&t.start()})},e.destroy=function(){var t,e=this;this.stop(),this._unbindEvents(),null==(t=this.lenisInstance)||t.destroy(),requestAnimationFrame(function(){var t;null==(t=e.coreInstance)||t.destroy()})},e._bindEvents=function(){var t=this;this._bindScrollToEvents(),this.lenisInstance&&(this._originalOnContentResize=this.lenisInstance.dimensions.onContentResize.bind(this.lenisInstance.dimensions),this._originalOnWrapperResize=this.lenisInstance.dimensions.onWrapperResize.bind(this.lenisInstance.dimensions),this.lenisInstance.dimensions.onContentResize=function(){null==t._originalOnContentResize||t._originalOnContentResize(),t._onResizeBind()},this.lenisInstance.dimensions.onWrapperResize=function(){null==t._originalOnWrapperResize||t._originalOnWrapperResize(),t._onResizeBind()})},e._unbindEvents=function(){this._unbindScrollToEvents(),this.lenisInstance&&(this._originalOnContentResize&&(this.lenisInstance.dimensions.onContentResize=this._originalOnContentResize),this._originalOnWrapperResize&&(this.lenisInstance.dimensions.onWrapperResize=this._originalOnWrapperResize))},e._bindScrollToEvents=function(t){var e,i=this,s=t||(null==(e=this.lenisInstance)?void 0:e.rootElement),n=null==s?void 0:s.querySelectorAll("[data-scroll-to]");(null==n?void 0:n.length)&&n.forEach(function(t){t.addEventListener("click",i._onScrollToBind,!1)})},e._unbindScrollToEvents=function(t){var e,i=this,s=t||(null==(e=this.lenisInstance)?void 0:e.rootElement),n=null==s?void 0:s.querySelectorAll("[data-scroll-to]");(null==n?void 0:n.length)&&n.forEach(function(t){t.removeEventListener("click",i._onScrollToBind,!1)})},e._onResize=function(){var t,e,i;null==(t=this.coreInstance)||t.onResize({currentScroll:null!=(e=null==(i=this.lenisInstance)?void 0:i.scroll)?e:0,smooth:!this.isTouchDevice})},e._onRender=function(){var t,e,i,s;null==(t=this.lenisInstance)||t.raf(Date.now()),null==(e=this.coreInstance)||e.onRender({currentScroll:null!=(i=null==(s=this.lenisInstance)?void 0:s.scroll)?i:0,smooth:!this.isTouchDevice})},e._onScrollTo=function(t){var e,i;t.preventDefault();var s=null!=(e=t.currentTarget)?e:null;if(s){var n=s.getAttribute("data-scroll-to-href")||s.getAttribute("href"),o=s.getAttribute("data-scroll-to-offset")||0,r=s.getAttribute("data-scroll-to-duration")||(null==(i=this.lenisInstance)?void 0:i.options.duration);n&&this.scrollTo(n,{offset:"string"==typeof o?parseInt(o):o,duration:"string"==typeof r?parseInt(r):r})}},e.start=function(){var t;this.rafPlaying||(null==(t=this.lenisInstance)||t.start(),this.rafPlaying=!0,this.initCustomTicker?this.initCustomTicker(this._onRenderBind):this._raf())},e.stop=function(){var t;this.rafPlaying&&(null==(t=this.lenisInstance)||t.stop(),this.rafPlaying=!1,this.destroyCustomTicker?this.destroyCustomTicker(this._onRenderBind):this.rafInstance&&cancelAnimationFrame(this.rafInstance))},e.removeScrollElements=function(t){var e;t?(this._unbindScrollToEvents(t),null==(e=this.coreInstance)||e.removeScrollElements(t)):console.error("Please provide a DOM Element as $oldContainer")},e.addScrollElements=function(t){var e,i=this;t?(null==(e=this.coreInstance)||e.addScrollElements(t),requestAnimationFrame(function(){i._bindScrollToEvents(t)})):console.error("Please provide a DOM Element as $newContainer")},e.resize=function(){this._onResizeBind()},e.scrollTo=function(t,e){var i;null==(i=this.lenisInstance)||i.scrollTo(t,{offset:null==e?void 0:e.offset,lerp:null==e?void 0:e.lerp,duration:null==e?void 0:e.duration,immediate:null==e?void 0:e.immediate,lock:null==e?void 0:e.lock,force:null==e?void 0:e.force,easing:null==e?void 0:e.easing,onComplete:null==e?void 0:e.onComplete})},e._raf=function(){var t=this;this._onRenderBind(),this.rafInstance=requestAnimationFrame(function(){return t._raf()})},t}()});
  
  /* stewardship report */
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof initPage === 'function') initPage();
  });
  
  function initPage() {
  
        function ffScrollY() {
          try {
            if (
              typeof window.ScrollSmoother === "function" &&
              typeof window.ScrollSmoother.get === "function"
            ) {
              const ss = window.ScrollSmoother.get();
              if (ss && typeof ss.scrollTop === "function") {
                return ss.scrollTop();
              }
            }
          } catch (_) {}
          return window.scrollY || document.documentElement.scrollTop || 0;
        }
  
        function ffScrollLayoutRefresh() {
          try {
            if (window.__ffLocoScroll) window.__ffLocoScroll.resize();
          } catch (_) {}
          try {
            if (window.ScrollTrigger) window.ScrollTrigger.refresh();
          } catch (_) {}
        }
  
        function initSplitTextReveal() {
          if (typeof Splitting === "undefined") return;
  
          const targets = document.querySelectorAll("[data-split-reveal]");
          targets.forEach((el) => {
            Splitting({ target: el, by: "lines" });
            el.setAttribute("data-scroll", "");
          });
          /* Locomotive Core is created in a rAF after initSmoothScroll; split runs on
             ff:components-loaded — refresh so IO / metrics see post-split DOM. */
          requestAnimationFrame(() => {
            try {
              ffScrollLayoutRefresh();
            } catch (_) {}
            requestAnimationFrame(() => {
              try {
                ffScrollLayoutRefresh();
              } catch (_) {}
            });
          });
        }
  
        document.addEventListener("ff:components-loaded", initSplitTextReveal);
  
        (function initSmoothScroll() {
          if (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ) {
            return;
          }
          if (window.__ffLocoScroll) return;
          if (typeof LocomotiveScroll === "undefined") return;
          try {
            const lenisOutExpo = (t) =>
              Math.min(1, 1.001 - Math.pow(2, -10 * t));
            window.__ffLocoScroll = new LocomotiveScroll({
              lenisOptions: {
                smoothWheel: true,
                /* Wheel / trackpad: exponential damping (Lenis default-style lerp) */
                lerp: 0.1,
                /* In-page #anchors (nav pills, skip links): time-based ease */
                anchors: {
                  duration: 1.15,
                  easing: lenisOutExpo,
                  offset: 0,
                },
              },
            });
          } catch (err) {
            console.warn("LocomotiveScroll init failed:", err);
            return;
          }
          (function () {
            const _ffInitWidth = window.innerWidth;
            const _ffInitHeight = window.innerHeight;
            let _ffResizeTimer = null;
            window.addEventListener(
              "resize",
              () => {
                clearTimeout(_ffResizeTimer);
                _ffResizeTimer = setTimeout(() => {
                  const widthDelta = Math.abs(window.innerWidth - _ffInitWidth);
                  const heightDelta = Math.abs(window.innerHeight - _ffInitHeight);
                  // If viewport changed significantly (>80px in either dimension), reload
                  // so GSAP ScrollTrigger re-initialises cleanly from scratch.
                  if (widthDelta > 80 || heightDelta > 80) {
                    try {
                      if (window.history && window.history.scrollRestoration) {
                        window.history.scrollRestoration = "manual";
                      }
                      window.scrollTo(0, 0);
                    } catch (_) {}
                    window.location.reload();
                    return;
                  }
                  try {
                    ffScrollLayoutRefresh();
                  } catch (_) {}
                }, 400);
              },
              { passive: true }
            );
          })();
          window.addEventListener(
            "load",
            () => {
              try {
                ffScrollLayoutRefresh();
              } catch (_) {}
            },
            { once: true, passive: true }
          );
          requestAnimationFrame(() => {
            try {
              ffScrollLayoutRefresh();
            } catch (_) {}
          });
        })();
  
        (function initTopNavScrollHide() {
          const dock = document.querySelector(".top-nav-dock");
          if (!dock) return;
  
          let lastY = ffScrollY();
          const deltaThreshold = 8;
          const topAlwaysShowPx = 80;
          const scrollUpSustainMs = 2000;
          const scrollUpGapMs = 200;
  
          let upStreakStartTs = 0;
          let lastUpScrollTs = 0;
          let idleAfterUpTimer = 0;
  
          function clearIdleTimer() {
            if (idleAfterUpTimer) {
              clearTimeout(idleAfterUpTimer);
              idleAfterUpTimer = 0;
            }
          }
  
          function scheduleIdleAfterUp() {
            clearIdleTimer();
            idleAfterUpTimer = setTimeout(() => {
              idleAfterUpTimer = 0;
              const now = Date.now();
              if (lastUpScrollTs > 0 && now - lastUpScrollTs >= scrollUpGapMs) {
                lastUpScrollTs = 0;
                upStreakStartTs = 0;
                setHidden(false);
              }
            }, scrollUpGapMs + 30);
          }
  
          function setHidden(hidden) {
            dock.classList.toggle("top-nav-dock--hidden", hidden);
            if (hidden) {
              dock.setAttribute("inert", "");
              dock.setAttribute("aria-hidden", "true");
            } else {
              dock.removeAttribute("inert");
              dock.removeAttribute("aria-hidden");
            }
          }
  
          function isInsidePressureMapSection() {
            const section = document.getElementById("overall-pressure-map");
            if (!section) return false;
            const rect = section.getBoundingClientRect();
            return rect.top <= 0 && rect.bottom >= 0;
          }

          function onScrollNavDock() {
            if (isInsidePressureMapSection()) {
              clearIdleTimer();
              upStreakStartTs = 0;
              lastUpScrollTs = 0;
              setHidden(true);
              lastY = ffScrollY();
              return;
            }

            if (window.matchMedia("(max-width: 640px)").matches) {
              clearIdleTimer();
              upStreakStartTs = 0;
              lastUpScrollTs = 0;
              setHidden(false);
              return;
            }
  
            if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
              clearIdleTimer();
              upStreakStartTs = 0;
              lastUpScrollTs = 0;
              setHidden(false);
              return;
            }
  
            const y = ffScrollY();
            const delta = y - lastY;
            lastY = y;
            const now = Date.now();
  
            if (y <= topAlwaysShowPx) {
              clearIdleTimer();
              upStreakStartTs = 0;
              lastUpScrollTs = 0;
              setHidden(false);
              return;
            }
  
            if (delta > deltaThreshold) {
              clearIdleTimer();
              upStreakStartTs = 0;
              lastUpScrollTs = 0;
              setHidden(true);
              return;
            }
  
            if (delta < -deltaThreshold) {
              if (lastUpScrollTs === 0 || now - lastUpScrollTs > scrollUpGapMs) {
                upStreakStartTs = now;
              }
              lastUpScrollTs = now;
  
              if (now - upStreakStartTs >= scrollUpSustainMs) {
                setHidden(true);
              } else {
                setHidden(false);
              }
              scheduleIdleAfterUp();
              return;
            }
  
            scheduleIdleAfterUp();
          }
  
          window.addEventListener("scroll", onScrollNavDock, { passive: true });
          onScrollNavDock();
        })();
  
        (function initMobileReportNav() {
          const menuBtn = document.querySelector(".top-nav-dock__menu-btn");
          const overlay = document.querySelector(".top-nav-dock__mobile-overlay");
          const mobileNav = document.querySelector(".top-nav-dock__mobile-nav");
          if (!menuBtn || !overlay || !mobileNav) return;
  
          const mobileLogoSlot = document.querySelector(
            ".top-nav-dock__mobile-logo-slot"
          );
          const desktopLogo = document.querySelector(
            ".top-bar .top-nav-dock__logo"
          );
          if (mobileLogoSlot && desktopLogo && !mobileLogoSlot.dataset.mounted) {
            const mobileLogo = desktopLogo.cloneNode(true);
            mobileLogo.classList.add("top-nav-dock__logo--mobile-menu");
            mobileLogo.classList.remove("top-nav-dock__logo--collapsed");
            mobileLogo.removeAttribute("aria-hidden");
            mobileLogoSlot.replaceWith(mobileLogo);
          }
  
          const mobileMq = window.matchMedia("(max-width: 640px)");
  
          function isMobileNav() {
            return mobileMq.matches;
          }
  
          function openMenu() {
            if (!isMobileNav()) return;
            overlay.classList.add("top-nav-dock__mobile-overlay--open");
            menuBtn.setAttribute("aria-expanded", "true");
            overlay.setAttribute("aria-hidden", "false");
            document.body.style.overflow = "hidden";
          }
  
          function closeMenu() {
            overlay.classList.remove("top-nav-dock__mobile-overlay--open");
            menuBtn.setAttribute("aria-expanded", "false");
            overlay.setAttribute("aria-hidden", "true");
            document.body.style.overflow = "";
          }
  
          menuBtn.addEventListener("click", () => {
            if (overlay.classList.contains("top-nav-dock__mobile-overlay--open")) {
              closeMenu();
            } else {
              openMenu();
            }
          });
  
          overlay.querySelectorAll("[data-mobile-nav-dismiss]").forEach((el) => {
            el.addEventListener("click", closeMenu);
          });
  
          mobileNav.addEventListener("click", (e) => {
            const pill = e.target.closest("a.nav-pill");
            if (pill && isMobileNav()) closeMenu();
          });
  
          document.addEventListener("keydown", (e) => {
            if (
              e.key === "Escape" &&
              overlay.classList.contains("top-nav-dock__mobile-overlay--open")
            ) {
              closeMenu();
              menuBtn.focus();
            }
          });
  
          mobileMq.addEventListener("change", () => {
            if (!isMobileNav()) closeMenu();
          });
        })();
  
        function updateReportNavActive() {
          const pills = Array.from(
            document.querySelectorAll(".top-nav-dock a.nav-pill, .top-nav-dock__mobile-nav a.nav-pill")
          );
          if (!pills.length) return;
          const linePx = 96;
          let activeHref = pills[0].getAttribute("href") || "#hero";
          for (let i = 0; i < pills.length; i++) {
            const href = pills[i].getAttribute("href");
            if (!href || href.charAt(0) !== "#") continue;
            const el = document.getElementById(href.slice(1));
            if (!el) continue;
            if (el.getBoundingClientRect().top <= linePx) activeHref = href;
          }
          for (let i = 0; i < pills.length; i++) {
            const pill = pills[i];
            const on = pill.getAttribute("href") === activeHref;
            pill.classList.toggle("nav-pill--active", on);
            if (on) pill.setAttribute("aria-current", "page");
            else pill.removeAttribute("aria-current");
          }
  
          const logo = document.querySelector(".top-bar .top-nav-dock__logo");
          if (logo) {
            const desktop =
              typeof window.matchMedia === "function" &&
              window.matchMedia("(min-width: 641px)").matches;
            if (!desktop) {
              logo.classList.remove("top-nav-dock__logo--collapsed");
              logo.removeAttribute("aria-hidden");
            } else {
              const collapsed = activeHref !== "#hero";
              logo.classList.toggle("top-nav-dock__logo--collapsed", collapsed);
              if (collapsed) logo.setAttribute("aria-hidden", "true");
              else logo.removeAttribute("aria-hidden");
            }
          }
        }
  
        function initPercentageBars() {
          const sections = document.querySelectorAll("#funding-allocation, #what-pressure-season");
  
          sections.forEach((section) => {
            const cards = section.querySelectorAll(".funding-card");
  
            const values = Array.from(cards)
              .map((card) => parseFloat(card.dataset.percent))
              .filter((value) => Number.isFinite(value));
  
            const max = Math.max(...values, 0);
  
            cards.forEach((card) => {
              const value = parseFloat(card.dataset.percent);
              if (!Number.isFinite(value) || max <= 0) return;
  
              const chart = card.querySelector(".funding-allocation-card__chart");
              const percentEl = card.querySelector(".funding-allocation-card__pct");
  
              const chartHeight = chart ? chart.offsetHeight : 0;
              if (chartHeight <= 0) return;
  
              const percentHeight = percentEl ? percentEl.offsetHeight : 0;
              const minHeight = percentHeight + 40;
  
              const calculatedHeight = (value / max) * chartHeight;
              const finalHeight = Math.min(Math.max(calculatedHeight, minHeight), chartHeight);
  
              card.style.setProperty("--bar-height", finalHeight + "px");
            });
          });
        }
  
        document.addEventListener("ff:components-loaded", initPercentageBars);
        window.addEventListener("resize", initPercentageBars);
  
        const fundingSection = document.getElementById("funding-allocation");
        let fundingBarsMotionGen = 0;
  
        function updateFundingCards() {
          if (!fundingSection) return;
          if (window.innerWidth <= 640) return;
  
          const rect = fundingSection.getBoundingClientRect();
  
          // Trigger when section top reaches viewport top
          // (section is fully stuck/visible)
          if (rect.top <= 0 && !fundingSection.dataset.animated) {
            fundingSection.dataset.animated = "true";
            animateFundingBars();
          }
  
          // Reset only when section is completely out of view.
          if (rect.bottom < 0 || rect.top > window.innerHeight) {
            if (fundingSection.dataset.animated) {
              fundingBarsMotionGen++;
              fundingSection.dataset.animated = "";
              resetFundingBars();
            }
          }
        }
  
        function animateFundingBars() {
          if (!fundingSection) return;
          if (window.innerWidth <= 640) return;
  
          const motionGen = fundingBarsMotionGen;
  
          if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            fundingSection.classList.remove("funding-allocation--bars-collapsed");
            initPercentageBars();
            return;
          }
  
          if (typeof initPercentageBars === "function") {
            initPercentageBars();
          }
  
          const bars = fundingSection.querySelectorAll(".funding-allocation-card__chart-fill");
  
          bars.forEach((bar) => {
            const card = bar.closest(".funding-card");
            if (!card) return;
            const target = card.style.getPropertyValue("--bar-height").trim();
            if (target) bar.dataset.targetHeight = target;
          });
  
          bars.forEach((bar) => {
            bar.style.transition = "none";
            bar.style.height = "0px";
            bar.style.minHeight = "0";
          });
  
          fundingSection.classList.remove("funding-allocation--bars-collapsed");
  
          requestAnimationFrame(() => {
            if (motionGen !== fundingBarsMotionGen) return;
  
            bars.forEach((bar, i) => {
              const target = bar.dataset.targetHeight;
              if (!target) return;
              setTimeout(() => {
                if (motionGen !== fundingBarsMotionGen) return;
                bar.style.transition = "height 0.8s cubic-bezier(0.16, 1, 0.3, 1)";
                bar.style.height = target;
              }, i * 80);
            });
  
            const staggerMs = 80;
            const durationMs = 800;
            const cleanupDelay = (bars.length - 1) * staggerMs + durationMs + 50;
            setTimeout(() => {
              if (motionGen !== fundingBarsMotionGen) return;
              bars.forEach((bar) => {
                bar.style.transition = "";
                bar.style.height = "";
                bar.style.minHeight = "";
              });
            }, cleanupDelay);
          });
        }
  
        function resetFundingBars() {
          if (!fundingSection) return;
          if (window.innerWidth <= 640) {
            fundingSection.classList.remove("funding-allocation--bars-collapsed");
            return;
          }
          fundingSection.classList.add("funding-allocation--bars-collapsed");
          fundingSection.querySelectorAll(".funding-allocation-card__chart-fill").forEach((bar) => {
            bar.style.transition = "none";
            bar.style.height = "";
            bar.style.minHeight = "";
            delete bar.dataset.targetHeight;
          });
        }
  
        function syncFundingAllocationMobileLayout() {
          if (!fundingSection) return;
          const mobile = window.innerWidth <= 640;
          const heading = document.getElementById("funding-allocation-heading");
          if (heading) {
            if (mobile) {
              heading.removeAttribute("data-scroll");
              heading.removeAttribute("data-scroll-speed");
              heading.removeAttribute("data-scroll-position");
            } else {
              heading.setAttribute("data-scroll", "");
            }
          }
          if (mobile) {
            fundingBarsMotionGen++;
            fundingSection.dataset.animated = "";
            fundingSection.classList.remove("funding-allocation--bars-collapsed");
            fundingSection.querySelectorAll(".funding-allocation-card__chart-fill").forEach(function (bar) {
              bar.style.transition = "";
              bar.style.height = "";
              bar.style.minHeight = "";
              delete bar.dataset.targetHeight;
            });
            if (typeof initPercentageBars === "function") initPercentageBars();
          } else {
            fundingBarsMotionGen++;
            fundingSection.dataset.animated = "";
            resetFundingBars();
          }
          try {
            ffScrollLayoutRefresh();
          } catch (_) {}
        }
  
        window.addEventListener("resize", function () {
          updateFundingCards();
          syncFundingAllocationMobileLayout();
          maybeInitFundingIntroDesktop();
        });
        syncFundingAllocationMobileLayout();
        updateFundingCards();
  
        const dfSection = document.getElementById("dumyat-foundation");
        const dfSticky = dfSection ? dfSection.querySelector(".df-sticky") : null;
        const eyebrow = document.getElementById("df-eyebrow");
        const eyebrowWrapper = document.getElementById("df-eyebrow-wrapper");
        const textBody = document.getElementById("df-text-body");
        const textWrapper = document.getElementById("df-text-wrapper");
        const nature = document.getElementById("df-nature");
        const chartContainer = document.getElementById("df-chart-container");
        const card1 = document.getElementById("df-card-1");
        const card2 = document.getElementById("df-card-2");
        const card3 = document.getElementById("df-card-3");
        const dfCard1Pressure = card1
          ? card1.querySelector("article.pressure-card")
          : null;
        const dfCard2Pressure = card2
          ? card2.querySelector("article.pressure-card")
          : null;
        const dfCard3Pressure = card3
          ? card3.querySelector("article.pressure-card")
          : null;
  
        const DUMYAT_MOBILE_MAX_W = 900;
  
        function dfApplyDumyatMobileStatic() {
          [
            eyebrowWrapper,
            eyebrow,
            textWrapper,
            textBody,
            nature,
            chartContainer,
            card1,
            card2,
            card3,
          ].forEach(function (el) {
            if (el) el.removeAttribute("style");
          });
          if (dfCard1Pressure) dfCard1Pressure.removeAttribute("style");
          if (dfCard2Pressure) dfCard2Pressure.removeAttribute("style");
          if (dfCard3Pressure) dfCard3Pressure.removeAttribute("style");
        }
  
        /**
         * Intro runs when `.df-sticky` has scrolled past the midpoint of its approach
         * (peak `top` while entering view → trigger at 50%). Avoids relying on a fixed px
         * that fast scroll + rAF can skip past before `top === 0`.
         */
        let dumyatStickyPeakTop = null;
  
        let dfWheelGestureSerial = 0;
        let dfWheelGestureSerialAtCardsDone = 0;
  
        /** Snapshot of section `progress` when the time-based intro ends — stage2 scrubs from here
         *  so the first scroll after the text is visible moves the wrappers (no fixed dead zone at 0). */
        let dumyatStage2AnchorProgress = null;
        /* Fraction of section progress (0–1) after intro anchor; larger = finish chart/cards nearer scroll end */
        const DUMYAT_STAGE2_SCROLL_SPAN = 0.2;
        const DUMYAT_STAGE3_SCROLL_SPAN = 0.38;
  
        /** #df-chart-container appearing animation: minimum visible duration in ms.
         *  The scroll-driven target chartP can jump to 1 in a single fast trackpad
         *  flick — this cap clamps the *displayed* progress so the chart always
         *  takes at least DUMYAT_CHART_APPEAR_MIN_MS to slide+scale into place,
         *  and at least DUMYAT_CHART_EXIT_MIN_MS to exit upward in stage 3,
         *  regardless of how fast the user scrolls. */
        const DUMYAT_CHART_APPEAR_MIN_MS = 800;
        const DUMYAT_CHART_EXIT_MIN_MS = 800;
        /** When the chart finishes appearing it must hold its centered position
         *  before the exit can begin — "scroll → chart centers → scroll again →
         *  chart exits". The gate requires BOTH:
         *   - DUMYAT_CHART_HOLD_MIN_MS of wall-clock time (so fast-flick
         *     scrollers still get a visible pause), AND
         *   - DUMYAT_CHART_HOLD_SCROLL_SPAN of section scroll past the moment
         *     the chart fully appeared (so it really takes "one more scroll").
         */
        const DUMYAT_CHART_HOLD_MIN_MS = 600;
        /** Gesture-gap window — wheel / touch / key events spaced ≤ this many
         *  ms apart are treated as the *same* scroll gesture (so trackpad
         *  momentum from a single flick doesn't count as multiple scrolls). */
        const DF_GESTURE_GAP_MS = 150;
        /** Min wall-clock hold between cards fully appearing and the section
         *  releasing the sticky, so the gesture that finished the cards doesn't
         *  bleed straight into navigating away. */
        const DUMYAT_CARDS_HOLD_MIN_MS = 250;
        let dfLastForwardScrollMs = 0;
        let dfNewGestureMs = 0;
        let dfTouchStartY = null;
        let dfSectionReleased = false;
        let dfCardsAllAppearedAtMs = null;
        /** Pressure cards reveal: each card's slide-up animation always takes at
         *  least this many ms, and they only start *after* the chart has fully
         *  exited. Card 2 (center) is offset by DUMYAT_CARDS_STAGGER_MS to keep
         *  the original visual stagger between side cards and the center card. */
        const DUMYAT_CARDS_APPEAR_MIN_MS = 800;
        const DUMYAT_CARDS_STAGGER_MS = 200;
        let dfChartAppearDisplayedP = 0;
        let dfChartAppearLastTickMs = null;
        let dfChartFullyAppearedAtMs = null;
        let dfChartFullyAppearedAtProgress = null;
        let dfChartExitDisplayedP = 0;
        let dfChartExitLastTickMs = null;
        let dfCards13DisplayedP = 0;
        let dfCards13LastTickMs = null;
        let dfCard2DisplayedP = 0;
        let dfCard2LastTickMs = null;
        /** Wall-clock ms (performance.now) when the chart finished its exit and
         *  the cards were unlocked. Drives the card2 stagger and lets a fast
         *  scroll skipping straight from stage 2 into deep stage 3 still play the
         *  card animation for at least 0.8s. */
        let dfCardsUnlockedAtMs = null;
        let dfChartTickRafPending = false;
        function dfScheduleChartTick() {
          if (dfChartTickRafPending) return;
          dfChartTickRafPending = true;
          requestAnimationFrame(function () {
            dfChartTickRafPending = false;
            updateDumyat();
          });
        }
  
        /** Reset time-based / pin trackers so reverse scroll scrubs from scroll progress. */
        function dfResetDumyatAnimState() {
          dfChartAppearDisplayedP = 0;
          dfChartAppearLastTickMs = null;
          dfChartFullyAppearedAtMs = null;
          dfChartFullyAppearedAtProgress = null;
          dfChartExitDisplayedP = 0;
          dfChartExitLastTickMs = null;
          dfCards13DisplayedP = 0;
          dfCards13LastTickMs = null;
          dfCard2DisplayedP = 0;
          dfCard2LastTickMs = null;
          dfCardsUnlockedAtMs = null;
          dfCardsAllAppearedAtMs = null;
          dfWheelGestureSerial = 0;
          dfWheelGestureSerialAtCardsDone = 0;
          dumyatStage2AnchorProgress = null;
          stage2Progress = 0;
        }
  
        /** Keep pin / release trackers aligned with scroll-scrubbed progress (reverse scroll). */
        function dfSyncDumyatScrubState(stage2P, stage3P) {
          const chartS2P = dfSpan(stage2P, 0.5, 1.0);
          const chartExitP = dfSpan(stage3P, 0.0, 0.35);
          const cardsUnlockP = dfSpan(stage3P, 0.30, 1.0);
          const card13P = dfSpan(cardsUnlockP, 0.0, 0.7);
          const card2P = dfSpan(cardsUnlockP, 0.15, 0.85);
  
          if (stage3P > 0) {
            dfChartAppearDisplayedP = 1;
            dfChartExitDisplayedP = chartExitP;
            dfCards13DisplayedP = card13P;
            dfCard2DisplayedP = card2P;
            if (chartExitP >= 1 && dfCardsUnlockedAtMs === null) {
              dfCardsUnlockedAtMs = performance.now();
            }
            if (card13P >= 1 && card2P >= 1) {
              dfNoteCardsAppeared();
            } else {
              dfCardsAllAppearedAtMs = null;
            }
          } else if (stage2P > 0) {
            dfChartAppearDisplayedP = chartS2P;
            dfChartExitDisplayedP = 0;
            dfCards13DisplayedP = 0;
            dfCard2DisplayedP = 0;
            dfCardsUnlockedAtMs = null;
            dfCardsAllAppearedAtMs = null;
          } else {
            dfChartAppearDisplayedP = 0;
            dfChartExitDisplayedP = 0;
            dfCards13DisplayedP = 0;
            dfCard2DisplayedP = 0;
            dfCardsUnlockedAtMs = null;
            dfCardsAllAppearedAtMs = null;
          }
        }
  
        // Stage 2 (scroll-scrubbed): 0 = start, 1 = complete
        let stage2Progress = 0;
        function easeSmooth(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }
        function dfSpan(p, start, end) {
          return Math.min(Math.max((p - start) / (end - start), 0), 1);
        }
  
        function updateDumyat() {
          if (
            !dfSection || !eyebrow || !eyebrowWrapper || !textBody ||
            !textWrapper || !nature || !chartContainer || !card1 || !card2 || !card3
          ) {
            dfScrollAnimInputLocked = false;
            return;
          }
  
          if (window.innerWidth <= DUMYAT_MOBILE_MAX_W) {
            dfApplyDumyatMobileStatic();
            dfScrollAnimInputLocked = false;
            return;
          }
  
          const vh = window.innerHeight;
          const rect = (dfSticky ?? dfSection).getBoundingClientRect();
          const dfRect = dfSection.getBoundingClientRect();
          const total = Math.max(dfSection.offsetHeight - window.innerHeight, 1);
          const progress = Math.min(Math.max(-dfRect.top / total, 0), 1);
  
          // ── SECTION NOT YET IN VIEW ──────────────────────────────────────────
          if (dfRect.top > vh) {
            eyebrowWrapper.style.opacity = "0";
            textWrapper.style.opacity = "0";
            nature.style.opacity = "0";
            nature.style.transform = "translateX(-50%) translateY(600px) scale(1.5)";
            eyebrow.style.transform = "translateY(100%)";
            textBody.style.transform = "translateY(100%)";
            chartContainer.style.opacity = "0";
            chartContainer.style.transform = "translateX(-50%) translateY(120vh) scale(1.2)";
            card1.style.transform = "translateY(100%)";
            card2.style.transform = "translateY(100%)";
            card3.style.transform = "translateY(100%)";
            if (dfCard1Pressure) dfCard1Pressure.style.opacity = "0";
            if (dfCard2Pressure) dfCard2Pressure.style.opacity = "0";
            if (dfCard3Pressure) dfCard3Pressure.style.opacity = "0";
            eyebrowWrapper.style.top = "128px";
            textWrapper.style.top = "184px";
            return;
          }
  
          // ── SCRUB SPANS ──────────────────────────────────────────────────────
          // Intro:  0.00 → 0.18  (eyebrow, text reveal + nature flies in)
          // Stage2: 0.18 → 0.38  (eyebrow/text move up, chart appears)
          // Stage3: 0.38 → 0.73  (chart exits, cards appear, nature moves)
          // Hold:   0.73 → 1.00
  
          const INTRO_START  = 0.00;
          const INTRO_END    = 0.18;
          const STAGE2_START = 0.18;
          const STAGE2_END   = 0.38;
          const STAGE3_START = 0.38;
          const STAGE3_END   = 0.73;
  
          const introP  = dfSpan(progress, INTRO_START, INTRO_END);
          const stage2P = dfSpan(progress, STAGE2_START, STAGE2_END);
          const stage3P = dfSpan(progress, STAGE3_START, STAGE3_END);
  
          // ── INTRO ─────────────────────────────────────────────────────────────
          // Eyebrow reveal
          const eyebrowIntroP  = dfSpan(introP, 0.0, 0.6);
          const eyebrowIntroE  = easeSmooth(eyebrowIntroP);
          eyebrowWrapper.style.opacity = String(Math.min(introP * 5, 1));
          eyebrow.style.transform = "translateY(" + (100 * (1 - eyebrowIntroE)) + "%)";
  
          // Text reveal (delayed)
          const textIntroP = dfSpan(introP, 0.25, 0.85);
          const textIntroE = easeSmooth(textIntroP);
          textWrapper.style.opacity = String(Math.min(introP * 5, 1));
          textBody.style.transform = "translateY(" + (100 * (1 - textIntroE)) + "%)";
  
          // Nature flies in
          const natureIntroP = dfSpan(introP, 0.0, 1.0);
          const natureIntroE = easeSmooth(natureIntroP);
          const natureIntroY = 600 * (1 - natureIntroE);
          const natureIntroScale = 1.5 - 0.5 * natureIntroE;
          nature.style.opacity = String(natureIntroE);
          nature.style.transform =
            "translateX(-50%) translateY(" + natureIntroY + "px) scale(" + natureIntroScale + ")";
  
          // ── STAGE 2 ───────────────────────────────────────────────────────────
          if (stage2P > 0) {
            // Eyebrow moves up: 128px → -1072px
            const eyebrow2E = easeSmooth(stage2P);
            const eyebrowY = 128 - 1200 * eyebrow2E;
            eyebrowWrapper.style.top = eyebrowY + "px";
  
            // Text moves up: 184px → -316px (delayed)
            const textS2P = dfSpan(stage2P, 0.071, 1.0);
            const textS2E = easeSmooth(textS2P);
            const textWrapperH = textWrapper.offsetHeight || 0;
            const textExitDistance = 184 + textWrapperH + 20;
            const textY = 184 - textExitDistance * textS2E;
            textWrapper.style.top = textY + "px";
  
            // Chart appears
            const chartS2P = dfSpan(stage2P, 0.5, 1.0);
            const chartS2E = easeSmooth(chartS2P);
            const chartHeight = chartContainer.offsetHeight;
            const centerY = vh / 2 - chartHeight / 2;
            const chartStartY = vh + 100;
            const chartCurrentY = chartStartY - (chartStartY - centerY) * chartS2E;
            const chartScale = 1.2 - 0.2 * chartS2E;
            chartContainer.style.opacity = chartS2P > 0 ? "1" : "0";
            chartContainer.style.transform =
              "translateX(-50%) translateY(" + chartCurrentY + "px) scale(" + chartScale + ")";
          } else {
            // Reset stage2 positions when scrolling back before stage2
            eyebrowWrapper.style.top = "128px";
            textWrapper.style.top = "184px";
            chartContainer.style.opacity = "0";
            chartContainer.style.transform = "translateX(-50%) translateY(120vh) scale(1.2)";
          }
  
          // ── STAGE 3 ───────────────────────────────────────────────────────────
          if (stage3P > 0) {
            const chartHeight = chartContainer.offsetHeight;
            const centerY = vh / 2 - chartHeight / 2;
  
            // Chart exits upward
            const chartExitP = dfSpan(stage3P, 0.0, 0.35);
            const chartExitE = easeSmooth(chartExitP);
            const chartExitY = centerY - 800 * chartExitE;
            chartContainer.style.opacity = "1";
            chartContainer.style.transform =
              "translateX(-50%) translateY(" + chartExitY + "px) scale(1.0)";
  
            // Cards appear — only after chart has mostly exited (stage3P > 0.3)
            const cardsUnlockP = dfSpan(stage3P, 0.30, 1.0);
            const card13P = dfSpan(cardsUnlockP, 0.0, 0.7);
            const card13E = easeSmooth(card13P);
            const card2P  = dfSpan(cardsUnlockP, 0.15, 0.85);
            const card2E  = easeSmooth(card2P);
  
            card1.style.transform = "translateY(" + (100 * (1 - card13E)) + "%)";
            card3.style.transform = "translateY(" + (100 * (1 - card13E)) + "%)";
            card2.style.transform = "translateY(" + (100 * (1 - card2E))  + "%)";
            if (dfCard1Pressure) dfCard1Pressure.style.opacity = String(card13E);
            if (dfCard2Pressure) dfCard2Pressure.style.opacity = String(card2E);
            if (dfCard3Pressure) dfCard3Pressure.style.opacity = String(card13E);
  
            // Nature moves up and scales down (starts mid stage3)
            const natureMoveP = dfSpan(stage3P, 0.2, 1.0);
            const natureMoveE = easeSmooth(natureMoveP);
            const natureMoveY = -320 * (window.innerWidth / 1440) * natureMoveE;
            const natureScaleP = dfSpan(stage3P, 0.35, 1.0);
            const natureScaleE = easeSmooth(natureScaleP);
            const natureScale3 = 1.0 - 0.2 * natureScaleE;
            nature.style.transform =
              "translateX(-50%) translateY(" + natureMoveY + "px) scale(" + natureScale3 + ")";
  
          } else {
            // Reset stage3 when scrolling back
            const chartHeight = chartContainer.offsetHeight;
            const centerY = vh / 2 - chartHeight / 2;
            if (stage2P >= 1) {
              chartContainer.style.opacity = "1";
              chartContainer.style.transform =
                "translateX(-50%) translateY(" + centerY + "px) scale(1.0)";
            }
            card1.style.transform = "translateY(100%)";
            card2.style.transform = "translateY(100%)";
            card3.style.transform = "translateY(100%)";
            if (dfCard1Pressure) dfCard1Pressure.style.opacity = "0";
            if (dfCard2Pressure) dfCard2Pressure.style.opacity = "0";
            if (dfCard3Pressure) dfCard3Pressure.style.opacity = "0";
  
            dfSectionReleased = false;
          }
  
          // Section scrolled past below viewport — allow reverse re-entry without a style flash
          if (dfRect.bottom < 0) {
            dfSectionReleased = false;
          }
  
          // ── FULL RESET when section scrolls back above viewport ──────────────
          const scrolledAboveDumyat = dfRect.top > Math.min(vh * 0.22, 140) && rect.top > 40;
          const dumyatIntroResetTop = (dumyatStickyPeakTop != null ? dumyatStickyPeakTop : vh * 0.48) + 56;
          if (scrolledAboveDumyat && rect.top > dumyatIntroResetTop) {
            dumyatStickyPeakTop = null;
            eyebrowWrapper.style.opacity = "0";
            textWrapper.style.opacity = "0";
            nature.style.opacity = "0";
            nature.style.transform = "translateX(-50%) translateY(600px) scale(1.5)";
            eyebrow.style.transform = "translateY(100%)";
            textBody.style.transform = "translateY(100%)";
            chartContainer.style.opacity = "0";
            chartContainer.style.transform = "translateX(-50%) translateY(120vh) scale(1.2)";
            eyebrowWrapper.style.top = "128px";
            textWrapper.style.top = "184px";
            card1.style.transform = "translateY(100%)";
            card2.style.transform = "translateY(100%)";
            card3.style.transform = "translateY(100%)";
            if (dfCard1Pressure) dfCard1Pressure.style.opacity = "0";
            if (dfCard2Pressure) dfCard2Pressure.style.opacity = "0";
            if (dfCard3Pressure) dfCard3Pressure.style.opacity = "0";
            dfResetDumyatAnimState();
            dfSectionReleased = false;
          } else {
            dfSyncDumyatScrubState(stage2P, stage3P);
          }
  
          dfScrollAnimInputLocked = false;
        }
  
        const habitatData = [
          { label: "Newly Planted Woodland Mosaic Habitat", value: 39, color: "#7AB648" },
          { label: "Grassland", value: 29, color: "#90c4a0" },
          { label: "Scrub and Bracken", value: 14, color: "#8a9e8a" },
          { label: "Heathland", value: 10, color: "#E07840" },
          { label: "Established Woodland", value: 5, color: "#b8e896" },
          { label: "Wetland", value: 3, color: "#d4724a" },
        ];
        const HABITAT_MAX_VALUE = 40;
        const HABITAT_INACTIVE = "rgba(255,255,255,0.08)";
  
        /**
         * Annular sector with rounded corners (pill-shaped segment).
         */
        function drawRoundedSegment(ctx, cx, cy, innerR, outerR, startAngle, endAngle, color, cr) {
          if (outerR <= innerR) return;
          const arcSpan = endAngle - startAngle;
          if (arcSpan <= 0) return;
  
          const thickness = outerR - innerR;
          const maxCr = Math.min(
            cr,
            thickness / 2,
            (arcSpan * outerR) / 2 - 1,
            (arcSpan * innerR) / 2 - 1
          );
          if (maxCr <= 0) {
            ctx.beginPath();
            ctx.arc(cx, cy, outerR, startAngle, endAngle, false);
            ctx.arc(cx, cy, innerR, endAngle, startAngle, true);
            ctx.closePath();
            ctx.fillStyle = color;
            ctx.fill();
            return;
          }
  
          const outerCrAngle = maxCr / outerR;
          const innerCrAngle = maxCr / innerR;
          const midR = (innerR + outerR) / 2;
  
          ctx.beginPath();
  
          ctx.arc(
            cx,
            cy,
            outerR,
            startAngle + outerCrAngle,
            endAngle - outerCrAngle,
            false
          );
  
          ctx.arcTo(
            cx + outerR * Math.cos(endAngle),
            cy + outerR * Math.sin(endAngle),
            cx + midR * Math.cos(endAngle),
            cy + midR * Math.sin(endAngle),
            maxCr
          );
          ctx.arcTo(
            cx + innerR * Math.cos(endAngle),
            cy + innerR * Math.sin(endAngle),
            cx + innerR * Math.cos(endAngle - innerCrAngle),
            cy + innerR * Math.sin(endAngle - innerCrAngle),
            maxCr
          );
  
          ctx.arc(
            cx,
            cy,
            innerR,
            endAngle - innerCrAngle,
            startAngle + innerCrAngle,
            true
          );
  
          ctx.arcTo(
            cx + innerR * Math.cos(startAngle),
            cy + innerR * Math.sin(startAngle),
            cx + midR * Math.cos(startAngle),
            cy + midR * Math.sin(startAngle),
            maxCr
          );
          ctx.arcTo(
            cx + outerR * Math.cos(startAngle),
            cy + outerR * Math.sin(startAngle),
            cx + outerR * Math.cos(startAngle + outerCrAngle),
            cy + outerR * Math.sin(startAngle + outerCrAngle),
            maxCr
          );
  
          ctx.closePath();
          ctx.fillStyle = color;
          ctx.fill();
        }
  
        let dfHabitatChart = null;
  
        function initHabitatChart() {
          const canvas = document.getElementById("df-habitat-chart");
          if (!canvas || typeof Chart === "undefined") return;
          if (dfHabitatChart) {
            dfHabitatChart.destroy();
            dfHabitatChart = null;
          }
  
          const ctx = canvas.getContext("2d");
          const legend = document.getElementById("df-chart-legend");
          if (legend) {
            legend.innerHTML = habitatData
              .map(
                (item) =>
                  '<div class="df-chart-legend-item"><span class="df-chart-legend-dot" style="background:' +
                  item.color +
                  '"></span>' +
                  item.label +
                  "</div>"
              )
              .join("");
          }
  
          const customDonutPlugin = {
            id: "customDonut",
            afterDatasetsDraw(chart) {
              const meta = chart.getDatasetMeta(0);
              if (!meta || !meta.data || !meta.data.length) return;
              const { ctx: c } = chart;
              // 2px gap at ~230px radius ≈ 0.0087 radians
              const gap = 0.0087;
              const ref = meta.data[0];
              if (
                ref == null ||
                ref.x == null ||
                ref.y == null ||
                ref.outerRadius == null
              )
                return;
  
              const cx = ref.x;
              const cy = ref.y;
              const outerR = ref.outerRadius;
              const innerR = 53.5; // donut hole: 107px diameter
              const minActiveR = 125; // min radius from center (250px diameter)
              const maxActiveR = outerR;
  
              const segmentCount = habitatData.length;
              const equalAngle = (Math.PI * 2) / segmentCount;
              const sliceAngle = equalAngle - gap;
              const ringStart = ref.startAngle;
  
              c.save();
              habitatData.forEach((item, index) => {
                const fillRatio = Math.min(
                  Math.max(item.value / HABITAT_MAX_VALUE, 0),
                  1
                );
                const activeR = Math.min(
                  maxActiveR,
                  Math.max(
                    innerR + 0.5,
                    minActiveR + (maxActiveR - minActiveR) * fillRatio
                  )
                );
                const currentStartAngle = ringStart + index * equalAngle;
  
                drawRoundedSegment(
                  c,
                  cx,
                  cy,
                  innerR,
                  outerR,
                  currentStartAngle,
                  currentStartAngle + sliceAngle,
                  HABITAT_INACTIVE,
                  16
                );
  
                drawRoundedSegment(
                  c,
                  cx,
                  cy,
                  innerR,
                  activeR,
                  currentStartAngle,
                  currentStartAngle + sliceAngle,
                  item.color,
                  16
                );
  
                const labelAngle = currentStartAngle + sliceAngle / 2;
                let labelR;
                if (activeR > innerR + 20) {
                  labelR = innerR + (activeR - innerR) * 0.6;
                } else {
                  labelR = (activeR + outerR) / 2;
                }
                const lx = cx + Math.cos(labelAngle) * labelR;
                const ly = cy + Math.sin(labelAngle) * labelR;
                c.fillStyle = item.value <= 5 ? "#000000" : "#ffffff";
                const labelPx = Math.min(
                  20,
                  Math.max(11, Math.round((chart.chartArea?.width ?? chart.width) / 14))
                );
                c.font =
                  '400 ' + labelPx + 'px "PP Radio Grotesk", sans-serif';
                c.textAlign = "center";
                c.textBaseline = "middle";
                c.fillText(item.value + "%", lx, ly);
              });
              c.restore();
            },
          };
  
          dfHabitatChart = new Chart(ctx, {
            type: "doughnut",
            data: {
              labels: habitatData.map((d) => d.label),
              datasets: [
                {
                  data: habitatData.map(() => 1),
                  backgroundColor: habitatData.map(() => "rgba(0,0,0,0.001)"),
                  hoverBackgroundColor: habitatData.map(() => "rgba(0,0,0,0.001)"),
                  borderWidth: 0,
                  spacing: 0,
                  hoverOffset: 0,
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: true,
              animation: false,
              cutout: "35%",
              layout: { padding: 4 },
              elements: {
                arc: {
                  hoverBorderWidth: 0,
                },
              },
              plugins: {
                legend: { display: false },
                tooltip: {
                  enabled: true,
                  callbacks: {
                    label(ctx) {
                      const row = habitatData[ctx.dataIndex];
                      return row ? row.label + ": " + row.value + "%" : "";
                    },
                  },
                },
              },
            },
            plugins: [customDonutPlugin],
          });
        }
  
        initHabitatChart();
  
        function ffIsTouchPrimaryDevice() {
          return (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(hover: none) and (pointer: coarse)").matches
          );
        }
  
        let heroSkyCreamTarget = 0;
        let heroSkyCreamDisplay = -1;
        let heroSkyCreamRafId = 0;
        let lastPublishedSkyCream = "";
  
        function ffEnableTouchHeroBackground() {
          document.documentElement.classList.add("is-touch-primary-hero");
          if (heroSkyCreamRafId) {
            cancelAnimationFrame(heroSkyCreamRafId);
            heroSkyCreamRafId = 0;
          }
          document.documentElement.style.removeProperty("--hero-sky-cream");
          heroSkyCreamDisplay = -1;
          lastPublishedSkyCream = "";
        }
  
        function ffDisableTouchHeroBackground() {
          document.documentElement.classList.remove("is-touch-primary-hero");
          document.documentElement.style.removeProperty("--hero-sky-cream");
          heroSkyCreamDisplay = -1;
          lastPublishedSkyCream = "";
        }
  
        function syncHeroSkyCreamTarget() {
          if (ffIsTouchPrimaryDevice()) return false;
          if (!dfSection) return false;
          const el = dfSticky || dfSection;
          const top = quantizeSigned(el.getBoundingClientRect().top);
          const vh = window.innerHeight || 1;
          let t = 1 - Math.max(0, Math.min(1, top / vh));
          t = quantizeUnitProgress(t);
          if (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ) {
            t = t > 0.5 ? 1 : 0;
          }
          heroSkyCreamTarget = t;
          return true;
        }
  
        function easeOutCubic01(n) {
          const x = Math.min(1, Math.max(0, n));
          const u = 1 - x;
          return 1 - u * u * u;
        }
  
        /** Signed 0.5px steps — use for getBoundingClientRect().top (can be negative). */
        function quantizeSigned(px) {
          return Math.round(px * 2) / 2;
        }
  
        function quantizeUnitProgress(t) {
          return Math.round(Math.max(0, Math.min(1, t)) * 2000) / 2000;
        }
  
        function tickHeroSkyCreamSmooth() {
          heroSkyCreamRafId = 0;
          if (ffIsTouchPrimaryDevice()) return;
          if (!syncHeroSkyCreamTarget()) return;
  
          const reduceMotion =
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          const staticHeroSky = reduceMotion;
  
          if (heroSkyCreamDisplay < 0) {
            heroSkyCreamDisplay = heroSkyCreamTarget;
          }
          if (staticHeroSky) {
            heroSkyCreamDisplay = heroSkyCreamTarget;
          } else {
            const dist = Math.abs(heroSkyCreamTarget - heroSkyCreamDisplay);
            if (dist < 0.0015) {
              heroSkyCreamDisplay = heroSkyCreamTarget;
            } else {
              const speed =
                0.05 + 0.16 * easeOutCubic01(Math.min(1, dist * 2.4));
              let next =
                heroSkyCreamDisplay +
                (heroSkyCreamTarget - heroSkyCreamDisplay) * speed;
              if (heroSkyCreamTarget > heroSkyCreamDisplay) {
                next = Math.min(next, heroSkyCreamTarget);
              } else {
                next = Math.max(next, heroSkyCreamTarget);
              }
              heroSkyCreamDisplay = next;
            }
          }
  
          const skyStr = heroSkyCreamDisplay.toFixed(4);
          if (skyStr !== lastPublishedSkyCream) {
            lastPublishedSkyCream = skyStr;
            document.documentElement.style.setProperty(
              "--hero-sky-cream",
              skyStr
            );
          }
  
          if (
            !staticHeroSky &&
            Math.abs(heroSkyCreamTarget - heroSkyCreamDisplay) > 0.002
          ) {
            heroSkyCreamRafId = requestAnimationFrame(tickHeroSkyCreamSmooth);
          }
        }
  
        function updateHeroGradientFade() {
          if (ffIsTouchPrimaryDevice()) return;
          if (!syncHeroSkyCreamTarget()) return;
          if (!heroSkyCreamRafId) {
            heroSkyCreamRafId = requestAnimationFrame(tickHeroSkyCreamSmooth);
          }
        }
  
        if (ffIsTouchPrimaryDevice()) {
          ffEnableTouchHeroBackground();
        }
  
        let dumyatScrollRafPending = false;
        function onDumyatRelatedScroll() {
          if (dumyatScrollRafPending) return;
          dumyatScrollRafPending = true;
          requestAnimationFrame(() => {
            dumyatScrollRafPending = false;
            dfMaintainSectionPin();
            updateHeroGradientFade();
            updateDumyat();
          });
        }
  
        /* ─────────────────────────────────────────────────────────────
         * Section pin enforcement: while inside #dumyat-foundation,
         * keep the `.df-sticky` pinned in the viewport until the three
         * pressure cards have fully appeared AND the user has done one
         * more new scroll gesture. Implemented by clamping `scrollY`
         * to the section's "max-pinned" position when a fast scroll
         * (or wheel momentum) tries to carry past too early.
         * ──────────────────────────────────────────────────────────── */
        function dfMaintainSectionPin() {
          if (!dfSection) return;
          if (window.innerWidth <= DUMYAT_MOBILE_MAX_W) return;
  
          const dfPinRect = dfSection.getBoundingClientRect();
          // Entire section above viewport: user has scrolled into #methodology (or below).
          // updateDumyat resets dfCards* / dfSectionReleased in that state; clamping here
          // would snap scroll back to the three-card Dumyat frame.
          if (dfPinRect.bottom < 1) return;
  
          // If section released but user scrolled back up into the section — re-arm the pin
          if (dfSectionReleased) {
            const rectCheck = dfSection.getBoundingClientRect();
            const sectionTopAbsCheck = rectCheck.top + window.scrollY;
            const maxScrollCheck = sectionTopAbsCheck + dfSection.offsetHeight - window.innerHeight;
            // If user scrolled back above the pinned position — reset released state
            if (window.scrollY < maxScrollCheck - 20) {
              dfSectionReleased = false;
              dfResetDumyatAnimState();
            } else {
              return;
            }
          }
          const rect = dfSection.getBoundingClientRect();
          const sectionTopAbs = rect.top + window.scrollY;
          const maxScrollWhilePinned =
            sectionTopAbs + dfSection.offsetHeight - window.innerHeight;
          if (window.scrollY < maxScrollWhilePinned - 0.5) return;
          // Below the pin (e.g. scrolling back up from #methodology) — scrub only, do not clamp
          if (window.scrollY > maxScrollWhilePinned + 0.5) return;
  
          const cardsDone =
            dfCards13DisplayedP >= 1 && dfCard2DisplayedP >= 1;
          if (!cardsDone) {
            window.scrollTo(0, maxScrollWhilePinned);
            return;
          }
  
          if (dfCardsAllAppearedAtMs === null) {
            dfCardsAllAppearedAtMs = performance.now();
          }
          const sinceCards = performance.now() - dfCardsAllAppearedAtMs;
          if (sinceCards < DUMYAT_CARDS_HOLD_MIN_MS) {
            window.scrollTo(0, maxScrollWhilePinned);
            dfScheduleChartTick();
            return;
          }
  
          // After the brief post-cards hold, either a NEW forward scroll
          // gesture (discrete users) or sustained forward scrolling past the
          // hold (fast-flick / momentum users) releases the section.
          if (
            dfNewGestureMs >
              dfCardsAllAppearedAtMs + DUMYAT_CARDS_HOLD_MIN_MS ||
            dfLastForwardScrollMs >
              dfCardsAllAppearedAtMs + DUMYAT_CARDS_HOLD_MIN_MS
          ) {
            dfSectionReleased = true;
            return;
          }
          window.scrollTo(0, maxScrollWhilePinned);
        }
  
        // Capture cards-fully-appeared timestamp from anywhere (not just the
        // scroll-driven path), so the section release timer starts even if
        // the cards finish during a RAF tick with no fresh scroll event.
        function dfNoteCardsAppeared() {
          const cardsDone =
            dfCards13DisplayedP >= 1 && dfCard2DisplayedP >= 1;
          if (cardsDone && dfCardsAllAppearedAtMs === null) {
            dfCardsAllAppearedAtMs = performance.now();
            dfScheduleChartTick();
          }
        }
  
        function dfRegisterForwardScroll(nowMs) {
          if (nowMs - dfLastForwardScrollMs > DF_GESTURE_GAP_MS) {
            dfNewGestureMs = nowMs;
            dfScheduleChartTick();
          }
          dfLastForwardScrollMs = nowMs;
        }
  
        window.addEventListener(
          "wheel",
          function (e) {
            if (e.deltaY > 0) dfRegisterForwardScroll(performance.now());
          },
          { passive: true }
        );
        window.addEventListener(
          "touchstart",
          function (e) {
            if (e.touches && e.touches.length > 0) {
              dfTouchStartY = e.touches[0].clientY;
            }
          },
          { passive: true }
        );
        window.addEventListener(
          "touchmove",
          function (e) {
            if (
              dfTouchStartY === null ||
              !e.touches ||
              e.touches.length === 0
            )
              return;
            const dy = dfTouchStartY - e.touches[0].clientY;
            if (dy > 8) dfRegisterForwardScroll(performance.now());
          },
          { passive: true }
        );
        window.addEventListener(
          "touchend",
          function () {
            dfTouchStartY = null;
          },
          { passive: true }
        );
        window.addEventListener(
          "touchcancel",
          function () {
            dfTouchStartY = null;
          },
          { passive: true }
        );
        window.addEventListener("keydown", function (e) {
          const k = e.key;
          if (
            k === "ArrowDown" ||
            k === "PageDown" ||
            k === " " ||
            k === "Spacebar"
          ) {
            dfRegisterForwardScroll(performance.now());
          }
        });
  
        if (window.visualViewport) {
          window.visualViewport.addEventListener("scroll", onDumyatRelatedScroll, {
            passive: true,
          });
        }
        window.addEventListener("resize", () => {
          if (dfHabitatChart) dfHabitatChart.resize();
          if (ffIsTouchPrimaryDevice()) {
            ffEnableTouchHeroBackground();
          } else {
            ffDisableTouchHeroBackground();
          }
          onDumyatRelatedScroll();
          initMethodologyNaturalHeight();
          updateMethod();
          try {
            resetMethodologyStickyForSmallScreens();
          } catch (_) {}
        }, { passive: true });
        onDumyatRelatedScroll();
  
        const methodScroll = document.getElementById("method-scroll");
        let methodNaturalMeasured = false;
  
        function isMethodScrollMobile() {
          return window.matchMedia("(max-width: 900px)").matches;
        }
  
        function resetMethodScrollDrivenStyles() {
          const padEl = document.getElementById("method-pad");
          if (!padEl) return;
          const banner = padEl.querySelector(".methodology-banner");
          if (!banner) return;
          padEl.style.padding = "";
          banner.style.borderRadius = "";
          banner.style.marginTop = "";
          banner.style.marginBottom = "";
          banner.style.height = "";
          banner.style.minHeight = "";
          const surface = banner.querySelector(".methodology-banner__surface");
          const cardsWrap = banner.querySelector(".methodology-banner__cards");
          const cards = banner.querySelectorAll("article.methodology-banner-card");
          const intro = banner.querySelector("header.methodology-banner__intro");
          if (cardsWrap) {
            cardsWrap.style.display = "";
            cardsWrap.style.position = "";
            cardsWrap.style.left = "";
            cardsWrap.style.right = "";
            cardsWrap.style.bottom = "";
            cardsWrap.style.width = "";
            cardsWrap.style.margin = "";
            cardsWrap.style.padding = "";
            cardsWrap.style.justifyContent = "";
          }
          cards.forEach((card) => {
            card.style.opacity = "";
            card.style.display = "";
          });
          if (surface) {
            surface.style.justifyContent = "";
          }
          if (intro) {
            intro.style.top = "";
            intro.style.transform = "";
          }
          const titleEl = banner.querySelector(".methodology-banner__title");
          if (titleEl) {
            titleEl.removeAttribute("data-scroll");
          }
        }
  
        function updateMethod() {
          if (!methodScroll) return;
          if (isMethodScrollMobile()) {
            resetMethodScrollDrivenStyles();
            return;
          }
          const rect = methodScroll.getBoundingClientRect();
          const total = methodScroll.offsetHeight - window.innerHeight;
          const progress = Math.min(Math.max(-rect.top / total, 0), 1);
  
          const padEl = document.getElementById("method-pad");
          if (!padEl) return;
  
          const banner = padEl.querySelector(".methodology-banner");
          if (!banner) return;
  
          // Animation only starts at progress 0.3
          // and completes at progress 0.8
          // giving more scroll time with visible margins
          const expandP = Math.min(
            Math.max((progress - 0.3) / 0.5, 0),
            1
          );
  
          const eased = 1 - Math.pow(1 - expandP, 3);
          const pad = 20 * (1 - eased);
          const radius = 24 * (1 - eased);
  
          padEl.style.padding = pad + "px";
          banner.style.borderRadius = radius + "px";
  
          // Smoothly expand frame margins (20px -> 0px)
          const frameMargin = 20 * (1 - eased);
          banner.style.marginTop = frameMargin + "px";
          banner.style.marginBottom = frameMargin + "px";
  
          const surface = banner.querySelector(".methodology-banner__surface");
          const cardsWrap = banner.querySelector(".methodology-banner__cards");
          const cards = banner.querySelectorAll("article.methodology-banner-card");
          const intro = banner.querySelector("header.methodology-banner__intro");

          // Cards should appear only once the orange frame fills the viewport
          // (margins -> 0) and sit at the bottom of the frame.
          const cardsP = Math.min(Math.max((eased - 0.95) / 0.05, 0), 1);
          const cardsVisible = cardsP > 0;
          if (cardsWrap) {
            cardsWrap.style.display = cardsVisible ? "flex" : "none";
            if (cardsVisible) {
              cardsWrap.style.position = "absolute";
              cardsWrap.style.left = "40px";
              cardsWrap.style.right = "40px";
              cardsWrap.style.bottom = "40px";
              cardsWrap.style.width = "auto";
              cardsWrap.style.margin = "0";
              cardsWrap.style.padding = "0";
              cardsWrap.style.justifyContent = "center";
            } else {
              cardsWrap.style.position = "";
              cardsWrap.style.left = "";
              cardsWrap.style.right = "";
              cardsWrap.style.bottom = "";
              cardsWrap.style.width = "";
              cardsWrap.style.margin = "";
              cardsWrap.style.padding = "";
              cardsWrap.style.justifyContent = "";
            }
          }

          cards.forEach((card) => {
            card.style.opacity = String(cardsP);
            card.style.display = "";
          });

          // FIX 7 - Surface justify-content
          if (surface) {
            surface.style.justifyContent = "flex-start";
          }

          const viewportFrameH = window.innerHeight - frameMargin * 2;
          let frameH = viewportFrameH;

          // Only when the cards are actually becoming visible do we need to check
          // whether they will fit without overlapping the title. Before that point,
          // behave exactly as before (no extra measuring, no frame growth) so the
          // very start of the pin/scroll does not jump or shift.
          let cardsNeededH = 0;
          let introH = 0;
          const cardsBottomGap = 40;
          const cardsTopGap = 24;
          const minTopEnd = 40;
          const surfaceVerticalPadding = 0;

          if (cardsVisible && cardsWrap) {
            const wasDisplay = cardsWrap.style.display;
            const wasPosition = cardsWrap.style.position;
            cardsWrap.style.display = "flex";
            cardsWrap.style.position = "static";
            cardsNeededH = cardsWrap.scrollHeight || 0;
            cardsWrap.style.display = wasDisplay;
            cardsWrap.style.position = wasPosition;

            introH = intro ? (intro.offsetHeight || 0) : 0;

            const minFrameHeightNeeded =
              minTopEnd + introH + cardsTopGap + cardsNeededH + cardsBottomGap + surfaceVerticalPadding;
            frameH = Math.max(viewportFrameH, minFrameHeightNeeded);
          }

          banner.style.height = frameH + "px";
          banner.style.minHeight = frameH + "px";

          // The outer sticky <section> (padEl's parent) is fixed at 100vh in CSS so
          // the very first pinned frame is symmetrically centered. But if the inner
          // banner needed to grow past 100vh to fit the cards without overlap, the
          // outer section must grow too, or the extra banner height just gets
          // visually cut off by the viewport even though nothing is clipped by CSS.
          const outerSection = padEl.parentElement;
          if (outerSection && outerSection.tagName === "SECTION") {
            if (frameH > viewportFrameH) {
              outerSection.style.height = frameH + "px";
            } else {
              outerSection.style.height = "";
            }
          }

          // Intro: centered at start, then hugs content and moves up
          if (surface && intro) {
            const surfaceH = surface.clientHeight || frameH;
            let topEnd = 80;
            if (cardsVisible) {
              const idealTopEnd = surfaceH - cardsBottomGap - cardsNeededH - cardsTopGap - introH;
              topEnd = Math.max(minTopEnd, Math.min(80, idealTopEnd));
            }

            const topStart = surfaceH * 0.5;
            const topPx = topStart + (topEnd - topStart) * eased;

            intro.style.top = topPx + "px";

            const ty = -50 + 50 * eased;
            intro.style.transform = "translateX(-50%) translateY(" + ty + "%)";
          }
  
          const methodologyTitle = banner.querySelector(".methodology-banner__title");
          if (methodologyTitle && !methodologyTitle.hasAttribute("data-scroll")) {
            methodologyTitle.setAttribute("data-scroll", "");
          }
        }
  
        function initMethodologyNaturalHeight() {
          const padEl = document.getElementById("method-pad");
          if (!padEl) return;
          const banner = padEl.querySelector(".methodology-banner");
          if (!banner) return;
  
          const cards = banner.querySelectorAll("article.methodology-banner-card");
  
          // FIX 1 - Measure natural height correctly
          cards.forEach((c) => (c.style.display = "none"));
          banner.dataset.naturalH = String(banner.offsetHeight);
          cards.forEach((c) => (c.style.display = ""));
          if (isMethodScrollMobile()) {
            cards.forEach((c) => {
              c.style.opacity = "";
              c.style.display = "";
            });
          } else {
            cards.forEach((c) => (c.style.opacity = "0"));
          }
  
          methodNaturalMeasured = true;
        }
  
        function updateFundingAllocationLayout() {
          const section = document.getElementById("funding-allocation");
          if (!section) return;
          const pin = section.querySelector(".funding-allocation__pin");
          const introEl = section.querySelector(".funding-allocation__intro");
          const titleEl = introEl
            ? introEl.querySelector(".funding-allocation__title")
            : null;
          const ledeEl = introEl
            ? introEl.querySelector(".funding-allocation__lede")
            : null;
          const cardsEl = section.querySelector(".funding-allocation__cards");
          if (!pin || !introEl || !titleEl || !ledeEl || !cardsEl) return;

          const topPad = 80;
          const bottomPad = 80;

          // Measure the title/lede content height directly (not through the
          // flex:1 intro wrapper, which would report the stretched size rather
          // than the natural content size).
          const introGap =
            parseFloat(getComputedStyle(introEl).rowGap || getComputedStyle(introEl).gap) ||
            0;
          const headerContentH =
            titleEl.offsetHeight + introGap + ledeEl.offsetHeight;
          const introMinHeight = topPad + headerContentH + bottomPad;

          const cardsH = cardsEl.offsetHeight || 0;
          const pinBottomPad =
            parseFloat(getComputedStyle(pin).paddingBottom) || 0;
          const totalMinHeight = introMinHeight + cardsH + pinBottomPad;

          introEl.style.minHeight = introMinHeight + "px";

          if (window.innerHeight < totalMinHeight) {
            pin.style.height = totalMinHeight + "px";
            pin.style.minHeight = totalMinHeight + "px";
          } else {
            pin.style.height = "";
            pin.style.minHeight = "";
          }
        }

        window.addEventListener(
          "resize",
          updateFundingAllocationLayout,
          { passive: true }
        );
        document.addEventListener("ff:components-loaded", () => {
          updateFundingAllocationLayout();
          requestAnimationFrame(updateFundingAllocationLayout);
        });

        function updateWpsLayout() {
          const section = document.getElementById("what-pressure-season");
          if (!section) return;
          const introEl = section.querySelector(".wps__intro");
          const cardsEl = section.querySelector(".wps__cards");
          const innerEl = section.querySelector(".wps__inner");
          if (!introEl || !cardsEl || !innerEl) return;

          // Measure each piece at its natural (unstretched) size, since
          // flex: 1 1 0 + justify-content: space-between on .wps__inner can
          // otherwise report stretched sizes rather than real content size.
          const wasIntroFlex = introEl.style.flex;
          introEl.style.flex = "0 0 auto";
          const introH = introEl.scrollHeight || 0;
          introEl.style.flex = wasIntroFlex;

          const wasCardsFlex = cardsEl.style.flex;
          const wasCardsMarginTop = cardsEl.style.marginTop;
          cardsEl.style.flex = "0 0 auto";
          cardsEl.style.marginTop = "0px";
          const cardsH = cardsEl.scrollHeight || 0;
          cardsEl.style.flex = wasCardsFlex;
          cardsEl.style.marginTop = wasCardsMarginTop;

          const sectionPad = 20; // matches .wps padding (var(--space-20))
          const minSectionHeightNeeded = sectionPad * 2 + introH + cardsH;

          const viewportSectionH = window.innerHeight;
          if (viewportSectionH < minSectionHeightNeeded) {
            section.style.minHeight = minSectionHeightNeeded + "px";
          } else {
            section.style.minHeight = "";
          }
        }

        window.addEventListener("resize", updateWpsLayout, { passive: true });
        document.addEventListener("ff:components-loaded", () => {
          updateWpsLayout();
          requestAnimationFrame(updateWpsLayout);
        });

        function updateOurWorkStageTop() {
          const split = document.querySelector(".methodology-split--scroll");
          if (!split) return;
          const stage = split.querySelector(".methodology-scrolly__stage");
          const sticky = document.querySelector(".methodology-scroll__sticky");
          const scrolly = split.querySelector(".methodology-scrolly");
          if (!stage || !sticky || !scrolly) return;

          const state = split.dataset.state || "0";
          const viewportH = window.innerHeight;
          const scrollyOffsetTop = scrolly.offsetTop || 0;

          let activePreRail = null;
          if (state === "1") activePreRail = split.querySelector(".methodology-scrolly__pre-rail--s1");
          else if (state === "2") activePreRail = split.querySelector(".methodology-scrolly__pre-rail--s2");
          let preH = 0;
          if (activePreRail) {
            const wasPreDisplay = activePreRail.style.display;
            activePreRail.style.display = "flex";
            preH = activePreRail.offsetHeight || 0;
            activePreRail.style.display = wasPreDisplay;
          }

          let activePostRail = null;
          if (state === "0") activePostRail = split.querySelector(".methodology-scrolly__post-rail--s0");
          else if (state === "1") activePostRail = split.querySelector(".methodology-scrolly__post-rail--s1");
          let postH = 0;
          if (activePostRail) {
            const wasDisplay = activePostRail.style.display;
            activePostRail.style.display = "flex";
            postH = activePostRail.offsetHeight || 0;
            activePostRail.style.display = wasDisplay;
          }

          const stageH = stage.scrollHeight || 0;
          const PRE_TOP = 104;
          const preBottom = PRE_TOP + preH;
          const preGap = preH > 0 ? 20 : 0;
          const scrollyH = scrolly.offsetHeight || viewportH;
          const postGap = postH > 0 ? 20 : 0;
          const minScrollyH = preBottom + preGap + stageH + postGap + postH + 20;
          const minStickyH = scrollyOffsetTop + minScrollyH;

          if (minStickyH <= viewportH) {
            sticky.style.height = "";
            sticky.style.minHeight = "";
            stage.style.top = "";
            stage.style.transform = "";
            stage.style.maxHeight = "";
            const colLightReset = split.querySelector(".methodology-split__col--light");
            if (colLightReset) colLightReset.style.minHeight = "";
            const scrollyReset = split.querySelector(".methodology-scrolly");
            if (scrollyReset) scrollyReset.style.minHeight = "";
            const preElReset = split.querySelector(".methodology-scrolly__pre");
            if (preElReset) preElReset.style.top = "";
            const eyebrowReset = split.querySelector(".methodology-split__eyebrow");
            if (eyebrowReset) eyebrowReset.style.marginTop = "";
            const postElReset = split.querySelector(".methodology-scrolly__post");
            if (postElReset) {
              postElReset.style.top = "";
              postElReset.style.bottom = "";
            }
            return;
          }

          sticky.style.height = minStickyH + "px";
          sticky.style.minHeight = minStickyH + "px";

          // Also grow the flex column and scrolly container so they don't clip
          const colLight = split.querySelector(".methodology-split__col--light");
          if (colLight) {
            colLight.style.minHeight = minStickyH + "px";
          }
          const scrollyEl = split.querySelector(".methodology-scrolly");
          if (scrollyEl) {
            scrollyEl.style.minHeight = minScrollyH + "px";
          }

          // Remove max-height constraint so stage content is not clipped
          stage.style.maxHeight = "none";

          // Available space in scrolly for pre + stage + post
          const scrollyAvailable = viewportH - scrollyOffsetTop;

          // If pre+stage doesn't fit in viewport, shift pre up so stage stays visible
          const neededForPreAndStage = preBottom + preGap + stageH + 20;
          let preTopOffset = 0;
          if (neededForPreAndStage > scrollyAvailable) {
            preTopOffset = -(neededForPreAndStage - scrollyAvailable);
          }

          // Apply pre shift
          const preEl = split.querySelector(".methodology-scrolly__pre");
          if (preEl) {
            preEl.style.top = preTopOffset < 0 ? (104 + preTopOffset) + "px" : "";
          }

          // Shift eyebrow up if stage would overlap it
          const eyebrowEl = split.querySelector(".methodology-split__eyebrow");
          if (eyebrowEl) {
            const eyebrowH = eyebrowEl.offsetHeight || 24;
            const eyebrowPad = 20;
            const eyebrowBottom = eyebrowPad + eyebrowH;
            const stageTopAbs = stageTopInScrolly;
            if (stageTopAbs < eyebrowBottom + 8) {
              const eyebrowShift = -(eyebrowBottom + 8 - stageTopAbs);
              eyebrowEl.style.marginTop = eyebrowShift + "px";
            } else {
              eyebrowEl.style.marginTop = "";
            }
          }

          // Position stage right after pre zone (accounting for pre shift)
          const stageTopInScrolly = preBottom + preGap + preTopOffset;
          stage.style.top = stageTopInScrolly + "px";
          stage.style.transform = "translateY(0)";

          // Reposition post zone
          const postEl = split.querySelector(".methodology-scrolly__post");
          if (postEl) {
            const postTopInScrolly = stageTopInScrolly + stageH + postGap;
            postEl.style.bottom = "";
            postEl.style.top = postTopInScrolly + "px";
          }
        }

                window.addEventListener("resize", updateOurWorkStageTop, { passive: true });
        document.addEventListener("ff:components-loaded", () => {
          updateOurWorkStageTop();
          requestAnimationFrame(updateOurWorkStageTop);
        });

        const methodologyScroll = document.getElementById("methodology");
        const methodologySplit = methodologyScroll
          ? methodologyScroll.querySelector(".methodology-split--scroll")
          : null;
  
        /** GSAP pin can leave inline transforms/position on `.methodology-scroll__sticky`; clear on ≤900px so mobile cards stay visible. */
        function resetMethodologyStickyForSmallScreens() {
          if (!methodologyScroll) return;
          if (typeof window.matchMedia !== "function") return;
          if (!window.matchMedia("(max-width: 900px)").matches) return;
          const sticky = methodologyScroll.querySelector(".methodology-scroll__sticky");
          if (!sticky) return;
          try {
            if (typeof window.gsap !== "undefined") {
              window.gsap.set(sticky, { clearProps: "all" });
            } else {
              sticky.removeAttribute("style");
            }
          } catch (_) {
            try {
              sticky.removeAttribute("style");
            } catch (_) {}
          }
        }
  
        document.addEventListener("ff:components-loaded", () => {
          initMethodologyNaturalHeight();
          updateMethod();
          initMethodologyScrollyGsap();
          initOverallPressureMapTabs();
          initOverallPressureMapLegendMobileCollapse();
          initOverallPressureMapMobileCardsLayout();
          initOverallPressureMapCardsReveal();
          resetMethodologyStickyForSmallScreens();
          requestAnimationFrame(() => {
            try {
              ffScrollLayoutRefresh();
            } catch (_) {}
            try {
              resetMethodologyStickyForSmallScreens();
            } catch (_) {}
          });
        });
  
        function easeSmoothScrollInset(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }

        const OUR_WORK_DESKTOP_STAT_MIN_GAP_PX = 20;

        function owGetFigureContentEl(figureStep) {
          if (!figureStep) return null;
          return (
            figureStep.querySelector(".methodology-tree-grid") ||
            figureStep.querySelector(".methodology-split__figure-img") ||
            figureStep
          );
        }

        function owDesktopFigureStatGap(figureStep, stat) {
          const content = owGetFigureContentEl(figureStep);
          if (!content || !stat) return Infinity;
          return stat.getBoundingClientRect().top - content.getBoundingClientRect().bottom;
        }

        function owSyncDesktopStatSuppression() {
          if (!methodologySplit) return;
          const darkFrame = methodologySplit.querySelector(".methodology-dark-frame");
          if (!darkFrame) return;

          const stats = darkFrame.querySelectorAll(".methodology-stat");
          const isDesktop =
            typeof window.matchMedia === "function" &&
            window.matchMedia("(min-width: 901px)").matches;
          const currentState = Number.parseInt(methodologySplit.dataset.state ?? "0", 10);

          stats.forEach((stat) => {
            const step = Number.parseInt(stat.getAttribute("data-step") ?? "0", 10);
            let suppress = false;

            if (isDesktop && step === currentState) {
              const figureStep = darkFrame.querySelector(
                '.methodology-figure-step[data-step="' + step + '"]'
              );
              suppress =
                owDesktopFigureStatGap(figureStep, stat) < OUR_WORK_DESKTOP_STAT_MIN_GAP_PX;
            }

            stat.classList.toggle("methodology-stat--suppressed", suppress);
            if (suppress) {
              stat.style.setProperty("visibility", "hidden", "important");
              stat.style.setProperty("opacity", "0", "important");
              stat.setAttribute("aria-hidden", "true");
            } else {
              stat.style.removeProperty("visibility");
              stat.style.removeProperty("opacity");
            }
          });
        }
  
        function setMethodologyState(state) {
          if (!methodologySplit) return;
          const s = Math.max(0, Math.min(2, state));
          methodologySplit.dataset.state = String(s);
          methodologySplit.querySelectorAll("[data-step]").forEach((el) => {
            const step = Number.parseInt(el.getAttribute("data-step") ?? "0", 10);
            el.setAttribute("aria-hidden", step === s ? "false" : "true");
          });
          // Update stage top position after state change
          requestAnimationFrame(() => {
            if (typeof updateOurWorkStageTop === "function") {
              updateOurWorkStageTop();
            }
            owSyncDesktopStatSuppression();
          });
        }
  
        /**
         * Our Work: Figma 540:29586 — sticky pin + scrub (min-width 641px only).
         * ≤640px: static mobile stack (Figma 327:65179); no pin — ScrollTrigger.matchMedia cleans up.
         */
        function initMethodologyScrollyGsap() {
          if (initMethodologyScrollyGsap._initialized) return;
          const scrollyRoot = document.getElementById("methodology-our-work-scrolly");
          const sticky = methodologyScroll?.querySelector(".methodology-scroll__sticky");
          const darkFrame = methodologySplit?.querySelector(".methodology-dark-frame");
          if (!methodologyScroll || !methodologySplit || !scrollyRoot || !sticky || !darkFrame) {
            return;
          }
  
          if (typeof window.gsap === "undefined" || typeof window.ScrollTrigger === "undefined") {
            return;
          }
  
          initMethodologyScrollyGsap._initialized = true;
  
          if (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ) {
            setMethodologyState(0);
            darkFrame.style.setProperty("--methodology-dark-margin", "0px");
            darkFrame.style.setProperty("--methodology-dark-radius", "0px");
            return;
          }
  
          const gsap = window.gsap;
          const ScrollTrigger = window.ScrollTrigger;
          gsap.registerPlugin(ScrollTrigger);
  
          function wireLenisToScrollTrigger() {
            const lenis = window.__ffLocoScroll?.lenisInstance;
            if (!lenis || window.__ffLenisScrollTriggerProxy) return;
            window.__ffLenisScrollTriggerProxy = true;
            ScrollTrigger.scrollerProxy(document.documentElement, {
              scrollTop(value) {
                if (arguments.length) {
                  lenis.scrollTo(value, { immediate: true });
                }
                return lenis.scroll;
              },
              getBoundingClientRect() {
                return {
                  top: 0,
                  left: 0,
                  width: window.innerWidth,
                  height: window.innerHeight,
                };
              },
            });
            lenis.on("scroll", ScrollTrigger.update);
          }
          wireLenisToScrollTrigger();
  
          ScrollTrigger.matchMedia({
            "(min-width: 641px)": () => {
              const tl = gsap
                .timeline({
                  scrollTrigger: {
                    trigger: methodologyScroll,
                    pin: sticky,
                    pinSpacing: true,
                    start: "top top",
                    end: () =>
                      "+=" +
                      Math.max(window.innerHeight * 1.85, scrollyRoot.offsetHeight * 2.6),
                    scrub: 1,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                    onUpdate(self) {
                      const p = self.progress;
                      const s = p < 1 / 3 ? 0 : p < 2 / 3 ? 1 : 2;
                      setMethodologyState(s);
                    },
                  },
                })
                .fromTo(
                  darkFrame,
                  { "--methodology-dark-margin": "20px", "--methodology-dark-radius": "16px" },
                  {
                    "--methodology-dark-margin": "0px",
                    "--methodology-dark-radius": "0px",
                    ease: "none",
                    duration: 0.12,
                  },
                  0
                )
                .to(
                  darkFrame,
                  {
                    "--methodology-dark-margin": "20px",
                    "--methodology-dark-radius": "16px",
                    ease: "none",
                    duration: 0.14,
                  },
                  0.82
                );
  
              initMethodologyScrollyGsap._pinTl = tl;

              requestAnimationFrame(() => {
                owSyncDesktopStatSuppression();
              });

              return () => {
                const st = tl.scrollTrigger;
                if (st) st.kill();
                tl.kill();
                initMethodologyScrollyGsap._pinTl = null;
                try {
                  resetMethodologyStickyForSmallScreens();
                } catch (_) {}
              };
            },
          });
  
          window.addEventListener(
            "resize",
            () => {
              clearTimeout(initMethodologyScrollyGsap._vpTimer);
              initMethodologyScrollyGsap._vpTimer = setTimeout(() => {
                try {
                  if (typeof window.ScrollTrigger !== "undefined") {
                    window.ScrollTrigger.refresh();
                  }
                } catch (_) {}
                try {
                  resetMethodologyStickyForSmallScreens();
                } catch (_) {}
                try {
                  ffScrollLayoutRefresh();
                } catch (_) {}
                try {
                  owSyncDesktopStatSuppression();
                } catch (_) {}
              }, 120);
            },
            { passive: true }
          );
  
          requestAnimationFrame(() => {
            try {
              ffScrollLayoutRefresh();
            } catch (_) {}
            try {
              resetMethodologyStickyForSmallScreens();
            } catch (_) {}
            try {
              if (typeof window.ScrollTrigger !== "undefined") {
                window.ScrollTrigger.refresh();
              }
            } catch (_) {}
            try {
              owSyncDesktopStatSuppression();
            } catch (_) {}
          });
        }
  
        function initOverallPressureMapTabs() {
          if (initOverallPressureMapTabs._initialized) return;
          initOverallPressureMapTabs._initialized = true;
          const section = document.getElementById("overall-pressure-map");
          if (!section) return;
          const tabs = Array.from(section.querySelectorAll(".overall-pressure-map__tab[data-layer]"));
          const bgImg = section.querySelector(".overall-pressure-map__bg-img");
          const titleEl = section.querySelector("[data-pressure-title]");
          const metaEl = section.querySelector("[data-pressure-meta]");
          const legendPanels = Array.from(section.querySelectorAll(".overall-pressure-map__legend-panel"));
          if (!tabs.length || !bgImg || !titleEl || !metaEl) return;
          const OVERALL_BG =
            "https://cdn.shopify.com/s/files/1/0499/9338/4102/files/Gemini_Generated_Image_4g1wrf4g1wrf4g1w_1.png?v=1781598536";
          const VEGETATION_BG =
            "https://cdn.shopify.com/s/files/1/0499/9338/4102/files/newGemini_Generated_Image_9irutv9irutv9iru_1_1.png?v=1781604537";
          const DEER_BG =
            "https://cdn.shopify.com/s/files/1/0499/9338/4102/files/DeerHeatMap-new.png?v=1781682635";
          const HUMAN_PRESSURE_BG =
            "https://cdn.shopify.com/s/files/1/0499/9338/4102/files/01_Gemini_Generated_Image_xrtzcaxrtzcaxrtz_1.png?v=1781607929";
          const layerConfig = {
            "overall-pressure": {
              bg: OVERALL_BG,
              title: "Summary Pressure Map",
              meta: ["Spring 2026", "100m survey grid", "563 squares assessed"],
              legendPanel: "overall-pressure",
              sectionClass: "overall-pressure-map--layer-overall-pressure",
            },
            "vegetation-pressure": {
              bg: VEGETATION_BG,
              title: "Gorse, Bracken & Invasive Species",
              meta: ["Spring 2026", "Vegetation overgrow & Non-Native Species"],
              legendPanel: "vegetation-pressure",
              sectionClass: "overall-pressure-map--layer-vegetation-pressure",
            },
            "deer-density": {
              bg: DEER_BG,
              title: "Deer Density Heat Map",
              meta: ["Spring 2026", "Termal Drone, stalking & walkover records"],
              legendPanel: "deer-density",
              sectionClass: "overall-pressure-map--layer-deer-density",
            },
            "human-pressure": {
              bg: HUMAN_PRESSURE_BG,
              title: "Human Behaviour Pressure",
              meta: ["Spring 2026", "Access, fire, litter & vandalism"],
              legendPanel: "human-pressure",
              sectionClass: "overall-pressure-map--layer-human-pressure",
            },
          };
          function renderMeta(items) {
            return items
              .map((item, index) => {
                const dot =
                  index < items.length - 1
                    ? '<span class="overall-pressure-map__meta-dot" aria-hidden="true"></span>'
                    : "";
                return (
                  '<span class="overall-pressure-map__meta-item">' +
                  item +
                  "</span>" +
                  dot
                );
              })
              .join("");
          }
          function setActiveTab(tab) {
            const layer = tab.getAttribute("data-layer");
            const config = layerConfig[layer];
            if (!config) return;
            tabs.forEach((btn) => {
              const isActive = btn === tab;
              btn.classList.toggle("overall-pressure-map__tab--active", isActive);
              btn.setAttribute("aria-selected", isActive ? "true" : "false");
              btn.tabIndex = isActive ? 0 : -1;
            });
            bgImg.src = config.bg;
            titleEl.textContent = config.title;
            metaEl.innerHTML = renderMeta(config.meta);
            legendPanels.forEach((panel) => {
              const show = panel.getAttribute("data-legend-panel") === config.legendPanel;
              panel.hidden = !show;
            });
            section.classList.remove(
              "overall-pressure-map--layer-overall-pressure",
              "overall-pressure-map--layer-vegetation-pressure",
              "overall-pressure-map--layer-deer-density",
              "overall-pressure-map--layer-human-pressure"
            );
            section.classList.add(config.sectionClass);
          }
          section._setActiveTab = setActiveTab;
          const tablist = section.querySelector(".overall-pressure-map__tabs");
          if (tablist && typeof window.matchMedia === "function") {
            const mobileMq = window.matchMedia("(max-width: 900px)");
            const handleTabClick = (event) => {
              const tab = event.target.closest(".overall-pressure-map__tab[data-layer]");
              if (!tab || !section.contains(tab)) return;
              if (tab.classList.contains("overall-pressure-map__tab--active")) return;
              setActiveTab(tab);
            };
            const syncClickTabs = () => {
              if (mobileMq.matches) {
                tablist.addEventListener("click", handleTabClick);
              } else {
                tablist.removeEventListener("click", handleTabClick);
              }
            };
            syncClickTabs();
            mobileMq.addEventListener("change", syncClickTabs);
          }
          const initialTab =
            tabs.find((tab) => tab.classList.contains("overall-pressure-map__tab--active")) || tabs[0];
          setActiveTab(initialTab);
        }

        function initOverallPressureMapLegendMobileCollapse() {
          const section = document.getElementById("overall-pressure-map");
          if (!section || typeof window.matchMedia !== "function") return;

          const mq = window.matchMedia("(max-width: 900px)");
          const chevronSvg =
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          function teardownPanel(panel) {
            const head = panel.querySelector(":scope > .overall-pressure-map__legend-head");
            const title = head ? head.querySelector("h3") : null;
            if (head && title) {
              panel.insertBefore(title, head);
              head.remove();
            }
            panel.classList.remove("is-legend-collapsed");
            delete panel.dataset.legendMobileInit;
          }

          function setupPanel(panel) {
            if (panel.dataset.legendMobileInit) return;
            const title = panel.querySelector(":scope > h3");
            if (!title) return;

            panel.dataset.legendMobileInit = "1";

            const head = document.createElement("div");
            head.className = "overall-pressure-map__legend-head";

            const toggle = document.createElement("button");
            toggle.type = "button";
            toggle.className = "overall-pressure-map__legend-toggle";
            toggle.setAttribute("aria-expanded", "false");
            toggle.setAttribute("aria-label", "Expand legend");
            toggle.innerHTML = chevronSvg;

            panel.insertBefore(head, title);
            head.appendChild(title);
            head.appendChild(toggle);
            panel.classList.add("is-legend-collapsed");

            toggle.addEventListener("click", () => {
              const collapsed = panel.classList.toggle("is-legend-collapsed");
              toggle.classList.toggle("is-expanded", !collapsed);
              toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
              toggle.setAttribute("aria-label", collapsed ? "Expand legend" : "Collapse legend");
            });
          }

          function sync() {
            const panels = section.querySelectorAll(".overall-pressure-map__legend-panel");
            if (mq.matches) {
              panels.forEach(setupPanel);
            } else {
              panels.forEach(teardownPanel);
            }
          }

          if (!initOverallPressureMapLegendMobileCollapse._initialized) {
            initOverallPressureMapLegendMobileCollapse._initialized = true;
            mq.addEventListener("change", sync);
          }
          sync();
        }

        function initOverallPressureMapMobileCardsLayout() {
          const section = document.getElementById("overall-pressure-map");
          if (!section || typeof window.matchMedia !== "function") return;

          const mq = window.matchMedia("(max-width: 900px)");
          const stickyStage = section.querySelector(".overall-pressure-map__sticky-stage");
          const chrome = section.querySelector(".overall-pressure-map__chrome");
          const bottom = section.querySelector(".overall-pressure-map__bottom");
          const titleWrap = section.querySelector(".overall-pressure-map__title-wrap");
          const sentinel = section.querySelector(".overall-pressure-map__sticky-sentinel");
          if (!stickyStage || !chrome || !bottom || !titleWrap) return;

          function moveToMobile() {
            if (bottom.parentElement === stickyStage) return;
            stickyStage.insertBefore(bottom, sentinel);
          }

          function moveToDesktop() {
            if (bottom.parentElement === chrome) return;
            chrome.insertBefore(bottom, titleWrap);
          }

          function sync() {
            if (mq.matches) moveToMobile();
            else moveToDesktop();
          }

          if (!initOverallPressureMapMobileCardsLayout._initialized) {
            initOverallPressureMapMobileCardsLayout._initialized = true;
            mq.addEventListener("change", sync);
          }
          sync();
        }

        const OPM_DESKTOP_CARDS_LEGEND_MIN_GAP_PX = 20;

        function opmDesktopCardsLegendGap(section, cards, setActiveTab, tabs) {
          const legendShell = section.querySelector(".overall-pressure-map__legend-shell");
          if (!legendShell || !cards || !window.gsap) return Infinity;

          const gsap = window.gsap;
          const lastTab = tabs[tabs.length - 1];
          const activeTab =
            tabs.find((tab) => tab.classList.contains("overall-pressure-map__tab--active")) || tabs[0];
          const saved = {
            yPercent: gsap.getProperty(cards, "yPercent"),
            autoAlpha: gsap.getProperty(cards, "autoAlpha"),
          };

          if (typeof setActiveTab === "function" && lastTab) {
            setActiveTab(lastTab);
          }
          gsap.set(cards, { yPercent: 0, autoAlpha: 1 });

          const legendPanel = legendShell.querySelector(
            ".overall-pressure-map__legend-panel:not([hidden])"
          );
          const legendRect = legendPanel
            ? legendPanel.getBoundingClientRect()
            : legendShell.getBoundingClientRect();
          const gap = cards.getBoundingClientRect().top - legendRect.bottom;

          if (typeof setActiveTab === "function" && activeTab) {
            setActiveTab(activeTab);
          }
          gsap.set(cards, {
            yPercent: saved.yPercent ?? 100,
            autoAlpha: saved.autoAlpha ?? 0,
          });

          return gap;
        }

        function opmShouldSkipDesktopCardsReveal(section, cards, setActiveTab, tabs) {
          try {
            if (typeof updateOpmViewportMode === "function") {
              updateOpmViewportMode();
            }
          } catch (_) {}
          return (
            opmDesktopCardsLegendGap(section, cards, setActiveTab, tabs) <
            OPM_DESKTOP_CARDS_LEGEND_MIN_GAP_PX
          );
        }

        function initOverallPressureMapCardsReveal() {
          if (initOverallPressureMapCardsReveal._initialized) return;
          initOverallPressureMapCardsReveal._initialized = true;
  
          const section = document.getElementById("overall-pressure-map");
          const stickyStage = section ? section.querySelector(".overall-pressure-map__sticky-stage") : null;
          const cards = section ? section.querySelector(".overall-pressure-map__cards") : null;
          if (!section || !stickyStage || !cards) return;
  
          if (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ) {
            return;
          }
  
          const gsap = window.gsap;
          const ScrollTrigger = window.ScrollTrigger;
          if (!gsap || !ScrollTrigger) return;
          gsap.registerPlugin(ScrollTrigger);
  
          function wireLenisToScrollTrigger() {
            const lenis = window.__ffLocoScroll?.lenisInstance;
            if (!lenis || window.__ffLenisScrollTriggerProxy) return;
            window.__ffLenisScrollTriggerProxy = true;
            ScrollTrigger.scrollerProxy(document.documentElement, {
              scrollTop(value) {
                if (arguments.length) {
                  lenis.scrollTo(value, { immediate: true });
                }
                return lenis.scroll;
              },
              getBoundingClientRect() {
                return {
                  top: 0,
                  left: 0,
                  width: window.innerWidth,
                  height: window.innerHeight,
                };
              },
            });
            lenis.on("scroll", ScrollTrigger.update);
          }
          wireLenisToScrollTrigger();
  
          ScrollTrigger.matchMedia({
            "(min-width: 901px)": () => {
              const setActiveTab = section._setActiveTab;
              const tabs = Array.from(section.querySelectorAll(".overall-pressure-map__tab[data-layer]"));
              if (typeof setActiveTab !== "function" || tabs.length < 4) return;

              const TAB_STEP = 1.2;
              const DEAD_ZONE = 0.4;
              const REVEAL = 0.6;
              const TOTAL = TAB_STEP * 4 + DEAD_ZONE + REVEAL;
              const TAB_PORTION = (TAB_STEP * 4) / TOTAL;
              let desktopCtx = null;
              let activeTabIndex = -1;
              let rebuildingDesktopCards = false;

              function buildDesktopOpmCardsTimeline() {
                if (rebuildingDesktopCards) return;
                rebuildingDesktopCards = true;

                if (desktopCtx) {
                  desktopCtx.revert();
                  desktopCtx = null;
                }
                activeTabIndex = -1;

                const skipCardsReveal = opmShouldSkipDesktopCardsReveal(
                  section,
                  cards,
                  setActiveTab,
                  tabs
                );

                desktopCtx = gsap.context(() => {
                  gsap.set(cards, { yPercent: 100, autoAlpha: 0 });

                  const tl = gsap.timeline({
                    scrollTrigger: {
                      trigger: stickyStage,
                      start: "top top",
                      end: () => "+=" + Math.round(window.innerHeight * TOTAL),
                      scrub: 1,
                      invalidateOnRefresh: true,
                      onUpdate(self) {
                        if (self.progress > TAB_PORTION) return;
                        const tabProgress = self.progress / TAB_PORTION;
                        const index = Math.min(3, Math.floor(tabProgress * 4));
                        if (index !== activeTabIndex) {
                          activeTabIndex = index;
                          setActiveTab(tabs[index]);
                        }
                      },
                    },
                  });

                  tl.to({}, { duration: TAB_STEP })
                    .to({}, { duration: TAB_STEP })
                    .to({}, { duration: TAB_STEP })
                    .to({}, { duration: TAB_STEP })
                    .to({}, { duration: DEAD_ZONE });

                  if (!skipCardsReveal) {
                    tl.to(cards, { yPercent: 0, autoAlpha: 1, ease: "none", duration: REVEAL });
                  }
                }, section);

                rebuildingDesktopCards = false;
              }

              buildDesktopOpmCardsTimeline();

              const onRefreshInit = () => {
                buildDesktopOpmCardsTimeline();
              };
              ScrollTrigger.addEventListener("refreshInit", onRefreshInit);

              return () => {
                ScrollTrigger.removeEventListener("refreshInit", onRefreshInit);
                if (desktopCtx) {
                  desktopCtx.revert();
                  desktopCtx = null;
                }
              };
            },
          });
        }
  
        const landResponseScroll = document.querySelector(".land-response-scroll");
        const landResponseSection = document.querySelector("#reading-the-land .land-response--scroll-steps");
  
        function landResponseLayoutIsMobile() {
          return (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(max-width: 640px)").matches
          );
        }
  
        function initLandResponseMobileCarousel() {
          if (initLandResponseMobileCarousel._done) return;
          initLandResponseMobileCarousel._done = true;
          const track = document.querySelector(".land-response-mobile__track");
          const figure = document.getElementById("land-response-mobile-figure");
          const dots = document.querySelectorAll(".land-response-mobile__dot");
          if (!track || !figure || !dots.length) return;
  
          const sources = [
            "https://cdn.shopify.com/s/files/1/0707/5102/7315/files/land-response-step-0.png",
            "https://cdn.shopify.com/s/files/1/0707/5102/7315/files/land-response-step-1.png",
            "https://cdn.shopify.com/s/files/1/0707/5102/7315/files/land-response-step-2.png",
            "https://cdn.shopify.com/s/files/1/0707/5102/7315/files/land-response-step-3.png",
            "https://cdn.shopify.com/s/files/1/0707/5102/7315/files/land-response-step-4.png",
          ];
  
          let raf = 0;
  
          function setActive(i) {
            const s = Math.max(0, Math.min(4, i));
            if (sources[s]) figure.setAttribute("src", sources[s]);
            dots.forEach((d, j) => {
              const on = j === s;
              d.classList.toggle("land-response-mobile__dot--active", on);
              d.setAttribute("aria-selected", on ? "true" : "false");
            });
          }
  
          function syncFromScroll() {
            const cols = track.querySelectorAll(".land-response-mobile__column");
            if (!cols.length) return;
            const trackRect = track.getBoundingClientRect();
            const center = trackRect.left + trackRect.width * 0.5;
            let best = 0;
            let bestDist = Infinity;
            cols.forEach((c, i) => {
              const r = c.getBoundingClientRect();
              const cx = (r.left + r.right) / 2;
              const dist = Math.abs(cx - center);
              if (dist < bestDist) {
                bestDist = dist;
                best = i;
              }
            });
            setActive(best);
          }
  
          function onScroll() {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(syncFromScroll);
          }
  
          track.addEventListener("scroll", onScroll, { passive: true });
  
          dots.forEach((dot) => {
            dot.addEventListener("click", () => {
              const idx = Number.parseInt(dot.getAttribute("data-dot") ?? "0", 10);
              const col = track.querySelector('.land-response-mobile__column[data-step="' + idx + '"]');
              if (!col) return;
              const targetLeft = col.offsetLeft;
              track.scrollTo({ left: Math.max(0, targetLeft - 8), behavior: "smooth" });
            });
          });
  
          window.addEventListener(
            "resize",
            () => {
              syncFromScroll();
            },
            { passive: true }
          );
  
          syncFromScroll();
        }
  
        /* One story step per deliberate wheel intent: accumulate small trackpad deltas, then require a
           quiet period before the next step. Do not reset the cooldown from scroll progress alone —
           progress can oscillate at the lead/story boundary and was clearing the gate every frame. */
        const LR_MIN_MS_BETWEEN_WHEEL_STEPS = 520;
        const LR_WHEEL_ACCUM_THRESHOLD = 52;
        /* After one forward/back step, absorb further wheel deltas from the same trackpad stroke until
           the gesture tails off (tiny delta), reverses, or this many ms — prevents 2→4 in one drag. */
        const LR_WHEEL_LATCH_TAIL_EPS = 1.75;
        const LR_WHEEL_LATCH_MAX_MS = 820;
        const LR_RESPOND_EXPAND_END_P = 0.28;
        const LR_HOLD_AFTER_BLEED_P = 0.25;
        const LR_ADVANCE_START_P = LR_RESPOND_EXPAND_END_P + LR_HOLD_AFTER_BLEED_P;
        const LR_REVERSE_INSET_START_P = 0.78;
  
        function lrResetLandResponseWheelIntent() {
          updateLandResponseScroll._lrLastWheelStepTs = 0;
          updateLandResponseScroll._lrWheelAccumPos = 0;
          updateLandResponseScroll._lrWheelAccumNeg = 0;
          updateLandResponseScroll._lrFwdStepLatch = false;
          updateLandResponseScroll._lrBackStepLatch = false;
          clearTimeout(updateLandResponseScroll._lrFwdLatchTimer);
          clearTimeout(updateLandResponseScroll._lrBackLatchTimer);
          updateLandResponseScroll._lrFwdLatchTimer = 0;
          updateLandResponseScroll._lrBackLatchTimer = 0;
        }
  
        function lrArmFwdStepLatch() {
          updateLandResponseScroll._lrFwdStepLatch = true;
          clearTimeout(updateLandResponseScroll._lrFwdLatchTimer);
          updateLandResponseScroll._lrFwdLatchTimer = setTimeout(() => {
            updateLandResponseScroll._lrFwdStepLatch = false;
            updateLandResponseScroll._lrFwdLatchTimer = 0;
          }, LR_WHEEL_LATCH_MAX_MS);
        }
  
        function lrArmBackStepLatch() {
          updateLandResponseScroll._lrBackStepLatch = true;
          clearTimeout(updateLandResponseScroll._lrBackLatchTimer);
          updateLandResponseScroll._lrBackLatchTimer = setTimeout(() => {
            updateLandResponseScroll._lrBackStepLatch = false;
            updateLandResponseScroll._lrBackLatchTimer = 0;
          }, LR_WHEEL_LATCH_MAX_MS);
        }
  
        function lrWheelStepCooldownOk() {
          const t = updateLandResponseScroll._lrLastWheelStepTs;
          if (t == null || t === 0) return true;
          return Date.now() - t >= LR_MIN_MS_BETWEEN_WHEEL_STEPS;
        }
  
        function lrMarkWheelStep() {
          updateLandResponseScroll._lrLastWheelStepTs = Date.now();
          updateLandResponseScroll._lrWheelAccumPos = 0;
          updateLandResponseScroll._lrWheelAccumNeg = 0;
        }
  
        function landResponsePinned() {
          if (!landResponseScroll) return false;
          const r = landResponseScroll.getBoundingClientRect();
          const tol = 2;
          return r.top <= tol && r.bottom >= window.innerHeight - tol;
        }
  
        function landResponseProgress() {
          if (!landResponseScroll) return null;
          const total = landResponseScroll.offsetHeight - window.innerHeight;
          if (total <= 0) return null;
          const rect = landResponseScroll.getBoundingClientRect();
          return Math.min(Math.max(-rect.top / total, 0), 1);
        }
  
        function setLandResponseState(state) {
          if (!landResponseSection) return;
          const s = Math.max(0, Math.min(4, state));
          landResponseSection.dataset.state = String(s);
  
          landResponseSection.querySelectorAll(".land-response-story-step").forEach((el) => {
            const step = Number.parseInt(el.getAttribute("data-step") ?? "0", 10);
            const on = step === s;
            el.setAttribute("aria-hidden", on ? "false" : "true");
          });
  
          landResponseSection.querySelectorAll(".land-response-figure-step").forEach((el) => {
            const step = Number.parseInt(el.getAttribute("data-step") ?? "0", 10);
            const on = step === s;
            el.setAttribute("aria-hidden", on ? "false" : "true");
          });
  
          const dots = landResponseSection.querySelectorAll(".land-response__dot");
          dots.forEach((dot, i) => {
            dot.classList.toggle("land-response__dot--filled", i <= s);
          });
        }
  
        function updateLandResponseScroll() {
          if (!landResponseScroll || !landResponseSection) return;
          if (landResponseLayoutIsMobile()) {
            const respondFrame = landResponseSection.querySelector(".land-response-respond-frame");
            if (respondFrame) {
              respondFrame.style.removeProperty("--land-response-respond-margin");
              respondFrame.style.removeProperty("--land-response-respond-radius");
            }
            return;
          }
          const rect = landResponseScroll.getBoundingClientRect();
          const total = landResponseScroll.offsetHeight - window.innerHeight;
          if (total <= 0) return;
  
          /* Section below viewport: reset for first approach from above.
             Section above viewport (scrolled past toward Our Methodology): keep slide index so
             scrolling back up restores the same reverse stepping order. */
          if (rect.top >= window.innerHeight) {
            updateLandResponseScroll._lrSlideIndex = 0;
            lrResetLandResponseWheelIntent();
          }
  
          const progress = Math.min(Math.max(-rect.top / total, 0), 1);
  
          const respondInsetExpandEndP = LR_RESPOND_EXPAND_END_P;
          const readingLandAdvanceStartP = LR_ADVANCE_START_P;
          const respondInsetReverseStartP = LR_REVERSE_INSET_START_P;
  
          const respondFrame = landResponseSection.querySelector(".land-response-respond-frame");
          if (respondFrame) {
            let m = 0;
            let r = 0;
            if (progress <= respondInsetExpandEndP) {
              const expandP = Math.min(progress / respondInsetExpandEndP, 1);
              const expandEased = easeSmoothScrollInset(expandP);
              m = 20 * (1 - expandEased);
              r = 16 * (1 - expandEased);
            } else if (progress < respondInsetReverseStartP) {
              m = 0;
              r = 0;
            } else {
              const reverseP =
                (progress - respondInsetReverseStartP) /
                Math.max(1e-6, 1 - respondInsetReverseStartP);
              const reverseEased = easeSmoothScrollInset(reverseP);
              m = 20 * reverseEased;
              r = 16 * reverseEased;
            }
            respondFrame.style.setProperty("--land-response-respond-margin", m + "px");
            respondFrame.style.setProperty("--land-response-respond-radius", r + "px");
          }
  
          /* Lead segment: always show story 0 (inset opening). Do not clear _lrSlideIndex — when
             scrolling up from Our Methodology, progress can cross this band briefly while Lenis
             catches up; keeping the index preserves reverse wheel stepping. */
          if (progress < readingLandAdvanceStartP) {
            updateLandResponseScroll._lrWheelAccumPos = 0;
            updateLandResponseScroll._lrWheelAccumNeg = 0;
            setLandResponseState(0);
          } else if (progress < respondInsetReverseStartP) {
            const idx =
              updateLandResponseScroll._lrSlideIndex === undefined
                ? 0
                : Math.max(0, Math.min(4, updateLandResponseScroll._lrSlideIndex));
            setLandResponseState(idx);
          } else {
            const idx =
              updateLandResponseScroll._lrSlideIndex === undefined
                ? 0
                : Math.max(0, Math.min(4, updateLandResponseScroll._lrSlideIndex));
            setLandResponseState(idx);
          }
        }
  
        function initLandResponseWheelNav() {
          if (updateLandResponseScroll._lrWheelInited) return;
          updateLandResponseScroll._lrWheelInited = true;
          /* Capture on window so we run before Lenis/Locomotive on document — otherwise the first
             wheel after full bleed can scroll past the whole story band in one gesture. */
          window.addEventListener(
            "wheel",
            function onLandResponseWheelCapture(e) {
              if (
                typeof window.matchMedia === "function" &&
                window.matchMedia("(prefers-reduced-motion: reduce)").matches
              ) {
                return;
              }
              if (!landResponseScroll || !landResponseSection) return;
              if (landResponseLayoutIsMobile()) return;
              if (!landResponsePinned()) return;
              const progress = landResponseProgress();
              if (progress === null) return;
              const inStoryBand =
                progress >= LR_ADVANCE_START_P && progress < LR_REVERSE_INSET_START_P;
              const inReverseTail = progress >= LR_REVERSE_INSET_START_P;
  
              let idx = updateLandResponseScroll._lrSlideIndex;
              if (idx === undefined) idx = 0;
  
              /* Ignore dominant horizontal pans (still allow slight diagonal). */
              if (Math.abs(e.deltaX) > Math.abs(e.deltaY) + 24) return;
  
              /* End forward gesture latch when user nudges up; end back latch on nudge down. */
              if (e.deltaY < 0) {
                updateLandResponseScroll._lrFwdStepLatch = false;
                clearTimeout(updateLandResponseScroll._lrFwdLatchTimer);
                updateLandResponseScroll._lrFwdLatchTimer = 0;
              }
              if (e.deltaY > 0) {
                updateLandResponseScroll._lrBackStepLatch = false;
                clearTimeout(updateLandResponseScroll._lrBackLatchTimer);
                updateLandResponseScroll._lrBackLatchTimer = 0;
              }
  
              /* Reverse inset band: wheel up steps back one slide (symmetric with scrolling up from
                 Our Methodology); wheel down still scrolls to the next section when on last slide. */
              if (inReverseTail) {
                if (e.deltaY < 0 && idx > 0) {
                  if (updateLandResponseScroll._lrBackStepLatch) {
                    if (-e.deltaY <= LR_WHEEL_LATCH_TAIL_EPS) {
                      updateLandResponseScroll._lrBackStepLatch = false;
                      clearTimeout(updateLandResponseScroll._lrBackLatchTimer);
                      updateLandResponseScroll._lrBackLatchTimer = 0;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                  if (!lrWheelStepCooldownOk()) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                  updateLandResponseScroll._lrWheelAccumNeg += -e.deltaY;
                  if (updateLandResponseScroll._lrWheelAccumNeg < LR_WHEEL_ACCUM_THRESHOLD) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                  e.preventDefault();
                  e.stopPropagation();
                  lrMarkWheelStep();
                  lrArmBackStepLatch();
                  updateLandResponseScroll._lrSlideIndex = idx - 1;
                  setLandResponseState(idx - 1);
                }
                return;
              }
  
              if (!inStoryBand) return;
  
              if (e.deltaY > 0 && idx < 4) {
                if (updateLandResponseScroll._lrFwdStepLatch) {
                  if (e.deltaY <= LR_WHEEL_LATCH_TAIL_EPS) {
                    updateLandResponseScroll._lrFwdStepLatch = false;
                    clearTimeout(updateLandResponseScroll._lrFwdLatchTimer);
                    updateLandResponseScroll._lrFwdLatchTimer = 0;
                  }
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                if (!lrWheelStepCooldownOk()) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                updateLandResponseScroll._lrWheelAccumPos += e.deltaY;
                updateLandResponseScroll._lrWheelAccumNeg = 0;
                if (updateLandResponseScroll._lrWheelAccumPos < LR_WHEEL_ACCUM_THRESHOLD) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                updateLandResponseScroll._lrWheelAccumPos = 0;
                e.preventDefault();
                e.stopPropagation();
                lrMarkWheelStep();
                lrArmFwdStepLatch();
                updateLandResponseScroll._lrSlideIndex = idx + 1;
                setLandResponseState(idx + 1);
                return;
              }
              if (e.deltaY < 0 && idx > 0) {
                if (updateLandResponseScroll._lrBackStepLatch) {
                  if (-e.deltaY <= LR_WHEEL_LATCH_TAIL_EPS) {
                    updateLandResponseScroll._lrBackStepLatch = false;
                    clearTimeout(updateLandResponseScroll._lrBackLatchTimer);
                    updateLandResponseScroll._lrBackLatchTimer = 0;
                  }
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                if (!lrWheelStepCooldownOk()) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                updateLandResponseScroll._lrWheelAccumNeg += -e.deltaY;
                updateLandResponseScroll._lrWheelAccumPos = 0;
                if (updateLandResponseScroll._lrWheelAccumNeg < LR_WHEEL_ACCUM_THRESHOLD) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                e.preventDefault();
                e.stopPropagation();
                lrMarkWheelStep();
                lrArmBackStepLatch();
                updateLandResponseScroll._lrSlideIndex = idx - 1;
                setLandResponseState(idx - 1);
              }
            },
            { passive: false, capture: true }
          );
        }
  
        function updateLrViewportMode() {
          const sticky = document.querySelector(".land-response-scroll__sticky");
          const section = document.querySelector("#reading-the-land .land-response--scroll-steps");
          if (!sticky || !section) return;

          const savedState = section.dataset.state;
          sticky.classList.add("lr-measuring");
          let maxH = 0;
          for (let n = 0; n <= 4; n++) {
            section.dataset.state = String(n);
            sticky.style.height = "auto";
            sticky.style.overflow = "visible";
            const h = sticky.offsetHeight;
            maxH = Math.max(maxH, h);
          }
          section.dataset.state = savedState;
          sticky.classList.remove("lr-measuring");

          const viewportH = window.innerHeight;
          const landResponse = sticky.querySelector(".land-response");
          const layout = sticky.querySelector(".land-response__layout");
          const readPanel = sticky.querySelector(".land-response__panel--read");
          const respondFrame = sticky.querySelector(".land-response-respond-frame");

          if (maxH > viewportH) {
            sticky.style.height = maxH + "px";
            sticky.style.minHeight = maxH + "px";
            sticky.style.top = viewportH - maxH + "px";
            sticky.style.overflow = "visible";
            if (landResponse) {
              landResponse.style.height = maxH + "px";
              landResponse.style.minHeight = maxH + "px";
            }
            if (layout) {
              layout.style.height = maxH + "px";
              layout.style.minHeight = maxH + "px";
            }
            if (readPanel) {
              readPanel.style.minHeight = maxH + "px";
              readPanel.style.overflow = "visible";
            }
            if (respondFrame) {
              respondFrame.style.minHeight = maxH + "px";
              respondFrame.style.overflow = "visible";
            }
          } else {
            sticky.style.height = "";
            sticky.style.minHeight = "";
            sticky.style.top = "";
            sticky.style.overflow = "";
            if (landResponse) {
              landResponse.style.height = "";
              landResponse.style.minHeight = "";
            }
            if (layout) {
              layout.style.height = "";
              layout.style.minHeight = "";
            }
            if (readPanel) {
              readPanel.style.minHeight = "";
              readPanel.style.overflow = "";
            }
            if (respondFrame) {
              respondFrame.style.minHeight = "";
              respondFrame.style.overflow = "";
            }
          }
        }

        function resetOpmViewportMode() {
          const section = document.getElementById('overall-pressure-map');
          if (!section) return;
          const pin = section.querySelector('.overall-pressure-map__pin');
          const chrome = section.querySelector('.overall-pressure-map__chrome');
          const toolbar = section.querySelector('.overall-pressure-map__toolbar');
          if (pin) { pin.style.height = ''; pin.style.minHeight = ''; pin.style.top = ''; }
          if (chrome) { chrome.style.minHeight = ''; }
          if (toolbar) {
            toolbar.style.position = '';
            toolbar.style.top = '';
            toolbar.style.left = '';
            toolbar.style.right = '';
            toolbar.style.zIndex = '';
          }
        }

        function updateOpmViewportMode() {
          const section = document.getElementById('overall-pressure-map');
          if (!section) return;
          const pin = section.querySelector('.overall-pressure-map__pin');
          const chrome = section.querySelector('.overall-pressure-map__chrome');
          const toolbar = section.querySelector('.overall-pressure-map__toolbar');
          if (!pin || !chrome || !toolbar) return;

          // Desktop only
          if (window.matchMedia('(max-width: 900px)').matches) {
            resetOpmViewportMode();
            return;
          }

          const viewportH = window.innerHeight;

          // Measure natural height with all constraints removed
          pin.style.setProperty('height', 'auto', 'important');
          pin.style.setProperty('min-height', '0', 'important');
          const naturalH = pin.offsetHeight;
          pin.style.removeProperty('height');
          pin.style.removeProperty('min-height');

          if (naturalH > viewportH) {
            pin.style.height = naturalH + 'px';
            pin.style.minHeight = naturalH + 'px';
            pin.style.top = (viewportH - naturalH) + 'px';
            chrome.style.minHeight = '0px';
            toolbar.style.position = 'absolute';
            toolbar.style.top = (naturalH - viewportH) + 'px';
            toolbar.style.left = '0';
            toolbar.style.right = '0';
            toolbar.style.zIndex = '10';
          } else {
            resetOpmViewportMode();
          }
        }

        document.addEventListener("ff:components-loaded", () => {
          window.addEventListener("resize", updateLandResponseScroll, { passive: true });
          window.addEventListener("resize", updateNatureGalleryCardVisibility, { passive: true });
          window.addEventListener("resize", updateLrViewportMode, { passive: true });
          window.addEventListener("resize", updateOpmViewportMode, { passive: true });
          updateLandResponseScroll._lrSlideIndex = 0;
          lrResetLandResponseWheelIntent();
          initLandResponseWheelNav();
          initLandResponseMobileCarousel();
          updateLrViewportMode();
          updateOpmViewportMode();
          updateLandResponseScroll();
        });
  
        const driversWrapper = document.getElementById("drivers-scroll-wrapper");
        const driversCard = document.getElementById("drivers-card");
        const driversTextContainer = document.getElementById("drivers-text-container");
        const driversCardsGroup = document.getElementById("drivers-cards-group");
        const expandCards = document.querySelectorAll(".driver-expand-card");
  
        function driversExpandLayoutIsMobile() {
          return (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(max-width: 640px)").matches
          );
        }
  
        function driversRestorePlainTitleEyebrow() {
          const title = document.getElementById("drivers-title");
          const eyebrow = document.getElementById("drivers-eyebrow");
          if (title && title.dataset.text) {
            title.textContent = title.dataset.text;
            delete title.dataset.prepared;
            delete title.dataset.revealIoAttached;
            delete title.dataset.revealAnimated;
          }
          if (eyebrow && eyebrow.dataset.text) {
            eyebrow.textContent = eyebrow.dataset.text;
            delete eyebrow.dataset.prepared;
          }
        }
  
        function easeSmooth(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }
  
        // Custom cubic bezier (0.50, 0.00, 0.50, 1.00)
        function easeCustom(t) {
          // Approximation of cubic-bezier(0.5, 0, 0.5, 1)
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }
  
        function updateDriversExpand() {
          if (!driversWrapper || !driversCard || !driversTextContainer || !driversCardsGroup) return;
  
          const mobile = driversExpandLayoutIsMobile();
          if (updateDriversExpand._wasMobile !== mobile) {
            updateDriversExpand._wasMobile = mobile;
            try {
              ffScrollLayoutRefresh();
            } catch (_) {}
          }
  
          if (mobile) {
            driversRestorePlainTitleEyebrow();
            driversCard.removeAttribute("style");
            driversTextContainer.removeAttribute("style");
            driversCardsGroup.removeAttribute("style");
            expandCards.forEach((card) => {
              card.removeAttribute("style");
            });
            const tEl = document.getElementById("drivers-title");
            if (tEl) {
              tEl.removeAttribute("data-scroll");
              tEl.removeAttribute("data-scroll-speed");
              tEl.removeAttribute("data-scroll-position");
            }
            return;
          }
  
          const tDesktop = document.getElementById("drivers-title");
          if (tDesktop && !tDesktop.hasAttribute("data-scroll")) {
            tDesktop.setAttribute("data-scroll", "");
          }
  
          const rect = driversWrapper.getBoundingClientRect();
          const vh = window.innerHeight;
          const maxScroll = driversWrapper.offsetHeight - vh;
          if (maxScroll <= 0) return;
  
          const scrolledRaw = -rect.top;
          const scrolled = Math.min(Math.max(scrolledRaw, 0), maxScroll);
  
          // Linear scroll used 60% of the track for motion and 40% for a static hold after
          // cards finish (~2× viewport). Use one viewport for the hold while keeping the
          // animation phase the same length as before (60% of the old 500vh track).
          const animScroll = Math.max(maxScroll - vh, 1e-6);
          const holdRange = Math.max(maxScroll - animScroll, 1e-6);
          let progress =
            scrolled <= animScroll
              ? (scrolled / animScroll) * 0.6
              : 0.6 + ((scrolled - animScroll) / holdRange) * 0.4;
          progress = Math.min(Math.max(progress, 0), 1);
  
          // Cards group height — start expanding exactly when the first card starts scaling.
          const firstCardP = Math.min(Math.max((progress - 0.282) / (0.494 - 0.282), 0), 1);
          const wasGroupHeight = driversCardsGroup.style.height;
          const wasGroupOverflow = driversCardsGroup.style.overflow;
          driversCardsGroup.style.height = "auto";
          driversCardsGroup.style.overflow = "visible";
          const expandedCardsHeight = driversCardsGroup.scrollHeight || 0;
          driversCardsGroup.style.height = wasGroupHeight;
          driversCardsGroup.style.overflow = wasGroupOverflow;
  
          if (firstCardP > 0) {
            // Grow smoothly instead of snapping to `auto`.
            if (firstCardP < 1) {
              driversCardsGroup.style.height = expandedCardsHeight * firstCardP + "px";
              driversCardsGroup.style.overflow = "hidden";
            } else {
              driversCardsGroup.style.height = "auto";
              driversCardsGroup.style.overflow = "visible";
            }
          } else {
            driversCardsGroup.style.height = "0";
            driversCardsGroup.style.overflow = "hidden";
            driversCardsGroup.style.minHeight = "0";
          }
  
          // Remap so animation completes by progress 0.6 (hold zone 0.6→1.0).
          // 1) CARD EXPAND: progress 0→0.282
          const expandP = Math.min(progress / 0.28, 1);
          const expandEased = easeSmooth(expandP);
  
          // Width: calc(100vw-40px) → 100vw
          // Height: calc(100vh-40px) → 100vh
          // Border-radius: 24px → 0px
          const margin = 20 * (1 - expandEased);
          const radius = 24 * (1 - expandEased);
  
          // Measure the minimum height actually needed: the title block at its
          // natural (unstretched) size, plus the cards group at its fully expanded
          // height, plus the existing paddings. If 100vh can't fit that, let the
          // card grow taller than the viewport instead of clipping/overlapping.
          const eyebrowEl = document.getElementById("drivers-eyebrow");
          const titleEl = document.getElementById("drivers-title");
          let textNaturalH = 0;
          if (eyebrowEl && titleEl) {
            const wasFlex = driversTextContainer.style.flex;
            const wasJustify = driversTextContainer.style.justifyContent;
            driversTextContainer.style.flex = "0 0 auto";
            driversTextContainer.style.justifyContent = "flex-start";
            textNaturalH = driversTextContainer.scrollHeight || 0;
            driversTextContainer.style.flex = wasFlex;
            driversTextContainer.style.justifyContent = wasJustify;
          }
          const cardPad = 20; // matches #drivers-card padding
          const minCardHeightNeeded =
            cardPad * 2 + textNaturalH + expandedCardsHeight;

          const viewportCardH = window.innerHeight - margin * 2;
          const finalCardH = Math.max(viewportCardH, minCardHeightNeeded);

          driversCard.style.width = "calc(100vw - " + margin * 2 + "px)";
          driversCard.style.height = finalCardH + "px";
          driversCard.style.borderRadius = radius + "px";

          // The outer sticky container is fixed at 100vh in CSS for a symmetric
          // initial pin. If the card needed to grow past that to fit its content,
          // the sticky container must grow too, or the extra height is just
          // pushed below the visible viewport.
          const driversStickyEl = driversCard.closest(".drivers-expand-sticky");
          if (driversStickyEl) {
            if (finalCardH > viewportCardH) {
              driversStickyEl.style.height = finalCardH + "px";
            } else {
              driversStickyEl.style.height = "";
            }
          }
  
          // 2) TEXT CONTAINER moves up as cards appear (progress 0.282→0.6)
          const cardsP = Math.min(Math.max((progress - 0.282) / 0.318, 0), 1);
          const cardsEased = easeSmooth(cardsP);
  
          driversTextContainer.style.paddingBottom = "76px";
  
          // 3) CARDS APPEAR with stagger (mapped to 0→0.6 range)
          const cardTimings = [
            { start: 0.282, end: 0.494 },
            { start: 0.317, end: 0.529 },
            { start: 0.353, end: 0.565 },
            { start: 0.388, end: 0.6 },
          ];
  
          expandCards.forEach((card, i) => {
            const timing = cardTimings[i];
            if (!timing) return;
            const { start, end } = timing;
            const cardP = Math.min(Math.max((progress - start) / (end - start), 0), 1);
            const cardEased = easeCustom(cardP);
            card.style.transform = "scale(" + cardEased + ")";
          });
        }
  
        document.addEventListener("ff:components-loaded", () => {
          window.addEventListener("resize", updateDriversExpand, { passive: true });
          updateDriversExpand();
        });
  
        (function initHeroShare() {
          const shareBtns = Array.from(
            document.querySelectorAll("#hero-share-btn, #recap-share-btn")
          );
          if (!shareBtns.length) return;
  
          let toastEl = null;
          let hideTimer = 0;
          let removeTimer = 0;
  
          function copyPageUrl(url) {
            if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
              return navigator.clipboard.writeText(url);
            }
            return new Promise(function (resolve, reject) {
              const textarea = document.createElement("textarea");
              textarea.value = url;
              textarea.setAttribute("readonly", "");
              textarea.style.position = "fixed";
              textarea.style.left = "-9999px";
              document.body.appendChild(textarea);
              textarea.select();
              try {
                const ok = document.execCommand("copy");
                document.body.removeChild(textarea);
                ok ? resolve() : reject(new Error("copy failed"));
              } catch (err) {
                document.body.removeChild(textarea);
                reject(err);
              }
            });
          }
  
          function ensureToastStyles() {
            if (document.getElementById("ff-share-toast-styles")) return;
            const style = document.createElement("style");
            style.id = "ff-share-toast-styles";
            style.textContent =
              ".ff-share-toast{position:fixed;z-index:10000;padding:10px 16px;border-radius:8px;" +
              "background:var(--bg-dark,#2b3824);color:var(--text-on-dark,#f2efe8);" +
              "font-family:var(--font-display,\"PP Radio Grotesk\",ui-sans-serif,system-ui,sans-serif);" +
              "font-size:14px;line-height:20px;pointer-events:none;opacity:0;" +
              "transition:opacity .25s ease,transform .25s ease}" +
              ".ff-share-toast--visible{opacity:1}" +
              ".ff-share-toast--anchor{transform:translateX(-50%) translateY(8px)}" +
              ".ff-share-toast--anchor.ff-share-toast--visible{transform:translateX(-50%) translateY(0)}" +
              ".ff-share-toast--bottom{bottom:24px;left:50%;transform:translateX(-50%) translateY(8px)}" +
              ".ff-share-toast--bottom.ff-share-toast--visible{transform:translateX(-50%) translateY(0)}" +
              ".ff-share-toast--exit{opacity:0!important}";
            document.head.appendChild(style);
          }
  
          function showShareToast(anchorBtn) {
            ensureToastStyles();
            clearTimeout(hideTimer);
            clearTimeout(removeTimer);
  
            if (!toastEl) {
              toastEl = document.createElement("div");
              toastEl.className = "ff-share-toast";
              toastEl.setAttribute("role", "status");
              toastEl.setAttribute("aria-live", "polite");
              toastEl.textContent = "Link copied";
              document.body.appendChild(toastEl);
            }
  
            toastEl.classList.remove(
              "ff-share-toast--visible",
              "ff-share-toast--exit",
              "ff-share-toast--anchor",
              "ff-share-toast--bottom"
            );
            toastEl.style.top = "";
            toastEl.style.left = "";
            toastEl.style.bottom = "";
  
            const rect = anchorBtn.getBoundingClientRect();
            const nearBottom = rect.bottom + 48 > window.innerHeight - 24;
  
            if (nearBottom) {
              toastEl.classList.add("ff-share-toast--bottom");
            } else {
              toastEl.classList.add("ff-share-toast--anchor");
              toastEl.style.top = rect.bottom + 8 + "px";
              toastEl.style.left = rect.left + rect.width / 2 + "px";
            }
  
            requestAnimationFrame(function () {
              toastEl.classList.add("ff-share-toast--visible");
            });
  
            hideTimer = setTimeout(function () {
              toastEl.classList.remove("ff-share-toast--visible");
              toastEl.classList.add("ff-share-toast--exit");
              removeTimer = setTimeout(function () {
                if (toastEl && toastEl.parentNode) {
                  toastEl.parentNode.removeChild(toastEl);
                  toastEl = null;
                }
              }, 250);
            }, 2000);
          }
  
          shareBtns.forEach(function (shareBtn) {
            shareBtn.addEventListener("click", function () {
              const url = window.location.href;
              copyPageUrl(url)
                .then(function () {
                  showShareToast(shareBtn);
                })
                .catch(function (err) {
                  console.warn("Failed to copy link:", err);
                });
            });
          });
        })();
  
        (function () {
          const overlay = document.getElementById("recap-overlay");
          const shell = document.getElementById("recap-shell");
          const deck = overlay && overlay.querySelector(".recap-deck");
          const track = document.getElementById("recap-deck-track");
          const progressRoot = document.getElementById("recap-progress");
          const btnPrev = document.getElementById("recap-btn-prev");
          const btnNext = document.getElementById("recap-btn-next");
          const footerNav = overlay && overlay.querySelector(".recap-footer-nav");
          const recapHeader = shell && shell.querySelector(".recap-slide-header");
          const recapScrollbar = document.getElementById("recap-shell-scrollbar");
          const recapScrollbarThumb = document.getElementById("recap-shell-scrollbar-thumb");
          const introPlaybar = document.getElementById("recap-intro-playbar");
          const recapScrollMQ = window.matchMedia("(max-height: 922px), (max-width: 419px)");
          const openBtn = document.getElementById("hero-play-recap");
          if (!overlay || !deck || !track || !openBtn) return;
          const slides = Array.from(track.querySelectorAll(".recap-slide:not([hidden])"));
          const total = slides.length;
          let index = 0;
          let lastFocus = null;
  
          // Build one progress segment per data slide (excluding the intro at index 0)
          let segs = [];
          if (progressRoot) {
            for (let i = 1; i < total; i++) {
              const s = document.createElement("span");
              s.className = "recap-progress__seg";
              progressRoot.appendChild(s);
            }
            segs = Array.from(progressRoot.querySelectorAll(".recap-progress__seg"));
          }
  
          function buildRecapDotGrids() {
            document.querySelectorAll("[data-recap-dots]").forEach((el) => {
              if (el.dataset.built) return;
              el.dataset.built = "1";
              const cols = +el.dataset.cols;
              const filled = +el.dataset.filledRows;
              const variant = el.dataset.variant;
              el.style.setProperty("--recap-dot-cols", String(cols));
              const map = {
                risk: "var(--status-at-risk)",
                pressure: "var(--bg-orange)",
                stable: "var(--status-stable)",
              };
              el.style.setProperty("--recap-dot-on", map[variant] || map.pressure);
              for (let r = 0; r < filled; r++) {
                for (let c = 0; c < cols; c++) {
                  const dot = document.createElement("span");
                  dot.className = "recap-dot recap-dot--on";
                  el.appendChild(dot);
                }
              }
            });
          }
  
          const RECAP_SHELL_FULL_H = 812;
  
          function resetRecapDeckScroll() {
            if (!deck) return;
            deck.scrollTop = 0;
          }
  
          function recapRectsOverlap(a, b) {
            return (
              a.right > b.left &&
              a.left < b.right &&
              a.bottom > b.top &&
              a.top < b.bottom
            );
          }
  
          function layoutRecapFooterOnImage() {
            if (!footerNav || footerNav.hidden) {
              if (footerNav) footerNav.classList.remove("recap-footer-nav--on-image");
              return;
            }
            const slide = slides[index];
            const img =
              slide &&
              slide.querySelector(
                ".recap-slide__main-body--dyk .recap-slide__floating-island--hero img"
              );
            if (!img) {
              footerNav.classList.remove("recap-footer-nav--on-image");
              return;
            }
            const imgRect = img.getBoundingClientRect();
            let onImage = false;
            footerNav.querySelectorAll(".recap-footer-nav__btn").forEach(function (btn) {
              if (onImage || btn.disabled) return;
              if (recapRectsOverlap(btn.getBoundingClientRect(), imgRect)) onImage = true;
            });
            footerNav.classList.toggle("recap-footer-nav--on-image", onImage);
          }
  
          function layoutRecapScrollbar() {
            if (!shell) return;
            const shellH = shell.getBoundingClientRect().height;
            const compactShell = shellH < RECAP_SHELL_FULL_H;
            shell.classList.toggle("recap-shell--playbar-pinned", compactShell);
            if (introPlaybar) introPlaybar.hidden = index !== 0 || !compactShell;
            if (!deck || !recapScrollbar || !recapScrollbarThumb || !recapHeader) return;
            const shortViewport = recapScrollMQ.matches;
            const scrollable = deck.scrollHeight > deck.clientHeight + 2;
            shell.classList.toggle("recap-shell--scrollable", shortViewport && scrollable);
            if (!shortViewport || !scrollable) {
              recapScrollbarThumb.style.height = "";
              recapScrollbarThumb.style.transform = "";
              return;
            }
  
            const shellRect = shell.getBoundingClientRect();
            const headerRect = recapHeader.getBoundingClientRect();
            const footerVisible = footerNav && !footerNav.hidden;
            const footerRect = footerVisible
              ? footerNav.getBoundingClientRect()
              : null;
  
            const top = Math.max(0, headerRect.bottom - shellRect.top + 8);
            const playbarRect =
              introPlaybar && !introPlaybar.hidden
                ? introPlaybar.getBoundingClientRect()
                : null;
            const bottom = footerRect
              ? Math.max(0, shellRect.bottom - footerRect.top)
              : playbarRect
                ? Math.max(0, shellRect.bottom - playbarRect.top)
                : parseFloat(getComputedStyle(shell).paddingBottom) || 8;
  
            recapScrollbar.style.top = top + "px";
            recapScrollbar.style.bottom = bottom + "px";
  
            const trackHeight = shellRect.height - top - bottom;
            if (trackHeight <= 0) return;
  
            const ratio = deck.clientHeight / deck.scrollHeight;
            const thumbHeight = Math.max(32, Math.round(trackHeight * ratio));
            const maxThumbTravel = trackHeight - thumbHeight;
            const scrollMax = deck.scrollHeight - deck.clientHeight;
            const thumbOffset =
              scrollMax > 0 ? (deck.scrollTop / scrollMax) * maxThumbTravel : 0;
  
            recapScrollbarThumb.style.height = thumbHeight + "px";
            recapScrollbarThumb.style.transform =
              "translateY(" + Math.round(thumbOffset) + "px)";
          }
  
          function scheduleRecapScrollbar() {
            requestAnimationFrame(function () {
              resetRecapDeckScroll();
              layoutRecapScrollbar();
              layoutRecapFooterOnImage();
              requestAnimationFrame(function () {
                resetRecapDeckScroll();
                layoutRecapScrollbar();
                layoutRecapFooterOnImage();
              });
            });
          }
  
          function render() {
            track.style.transform = "translateX(" + -index * 100 + "%)";
            slides.forEach((s, j) => {
              const on = j === index;
              s.setAttribute("aria-hidden", on ? "false" : "true");
              s.tabIndex = on ? 0 : -1;
            });
            // Segment j maps to slide index j+1; mark active + all preceding
            segs.forEach((seg, j) => {
              seg.classList.toggle("recap-progress__seg--active", j < index);
              seg.classList.toggle("recap-progress__seg--current", j === index - 1);
            });
            const dark = slides[index] && slides[index].getAttribute("data-progress-tone") === "dark";
            const whiteSlide =
              slides[index] && slides[index].classList.contains("recap-slide--white");
            if (shell) shell.classList.toggle("recap-shell--scrollbar-orange", whiteSlide);
            if (progressRoot) progressRoot.classList.toggle("recap-progress--dark", dark);
            if (btnPrev) btnPrev.disabled = index <= 0;
            if (btnNext) {
              const nextLabel = btnNext.querySelector(".recap-footer-nav__label");
              const nextArrow = btnNext.querySelector(".recap-footer-nav__arrow");
              const isDone = index >= total - 1;
              if (nextLabel) nextLabel.textContent = isDone ? "Done" : "Next";
              if (nextArrow) nextArrow.hidden = isDone;
              btnNext.classList.toggle("recap-footer-nav__btn--done", isDone);
            }
            if (footerNav) {
              footerNav.hidden = index === 0;
              footerNav.classList.toggle("recap-footer-nav--light", dark || whiteSlide);
            }
            resetRecapDeckScroll();
            scheduleRecapScrollbar();
          }
  
          function openRecap() {
            buildRecapDotGrids();
            lastFocus = document.activeElement;
            overlay.hidden = false;
            overlay.removeAttribute("inert");
            openBtn.setAttribute("aria-expanded", "true");
            document.body.style.overflow = "hidden";
            index = 0;
            render();
            requestAnimationFrame(function () {
              const pinned = introPlaybar && !introPlaybar.hidden;
              const firstBtn = pinned
                ? introPlaybar.querySelector(".recap-slide__playlike")
                : overlay.querySelector(
                    '.recap-slide[data-slide="0"] .recap-slide__playlike'
                  );
              if (firstBtn) firstBtn.focus();
            });
          }
  
          function closeRecap() {
            overlay.hidden = true;
            overlay.setAttribute("inert", "");
            openBtn.setAttribute("aria-expanded", "false");
            document.body.style.overflow = "";
            resetRecapDeckScroll();
            if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
          }
  
          function go(delta) {
            const next = index + delta;
            if (next < 0) return;
            if (next >= total) {
              closeRecap();
              return;
            }
            index = next;
            render();
          }
  
          if (openBtn) openBtn.addEventListener("click", openRecap);
  
          overlay.querySelectorAll("[data-recap-close]").forEach((el) => {
            el.addEventListener("click", closeRecap);
          });
  
          if (btnPrev) btnPrev.addEventListener("click", () => go(-1));
          if (btnNext) btnNext.addEventListener("click", () => go(1));
  
          overlay.querySelectorAll(".recap-slide__playlike").forEach((btn) => {
            btn.addEventListener("click", (e) => {
              e.stopPropagation();
              go(1);
            });
          });
  
          deck.addEventListener("scroll", function () {
            layoutRecapScrollbar();
            layoutRecapFooterOnImage();
          }, { passive: true });
          recapScrollMQ.addEventListener("change", scheduleRecapScrollbar);
          window.addEventListener("resize", scheduleRecapScrollbar);
  
          deck.addEventListener("click", (e) => {
            if (overlay.hidden) return;
            if (e.target.closest("button, a")) return;
            const r = deck.getBoundingClientRect();
            const x = e.clientX - r.left;
            if (x < r.width / 2) go(-1);
            else go(1);
          });
  
          let touchX = null;
          deck.addEventListener(
            "touchstart",
            (e) => {
              if (overlay.hidden) return;
              touchX = e.changedTouches[0].clientX;
            },
            { passive: true }
          );
          deck.addEventListener(
            "touchend",
            (e) => {
              if (overlay.hidden) return;
              if (touchX == null) return;
              const dx = e.changedTouches[0].clientX - touchX;
              touchX = null;
              if (Math.abs(dx) < 44) return;
              if (dx > 0) go(-1);
              else go(1);
            },
            { passive: true }
          );
  
          document.addEventListener("keydown", (e) => {
            if (overlay.hidden) return;
            if (e.key === "Escape") {
              e.preventDefault();
              closeRecap();
            }
            if (e.key === "ArrowRight" || e.key === "ArrowDown") {
              e.preventDefault();
              go(1);
            }
            if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
              e.preventDefault();
              go(-1);
            }
          });
  
          buildRecapDotGrids();
        })();
  
        let __ffPressureExistsScroll = null;
  
        (function () {
          const root = document.getElementById("pressure-exists");
          if (!root) return;
  
          const DOT_GAP = 4;
          const DOT_MIN = 16;
          const DOT_MAX = 20;
  
          const raf = typeof requestAnimationFrame === "function" ? requestAnimationFrame : (fn) => setTimeout(fn, 16);
  
          function parseFraction(text) {
            const m = String(text || "").trim().match(/^(\d+)\s*\/\s*(\d+)$/);
            if (!m) return null;
            return { current: Number(m[1]), total: Number(m[2]) };
          }
  
          function innerWidth(el) {
            const cs = window.getComputedStyle(el);
            const pl = parseFloat(cs.paddingLeft) || 0;
            const pr = parseFloat(cs.paddingRight) || 0;
            return Math.max(0, el.clientWidth - pl - pr);
          }
  
          function matrixUsableWidth(matrix, card) {
            let w = innerWidth(matrix);
            if (w > 0) return w;
            w = innerWidth(card);
            if (w > 0) return w;
            const cs = window.getComputedStyle(card);
            const pl = parseFloat(cs.paddingLeft) || 0;
            const pr = parseFloat(cs.paddingRight) || 0;
            const rw = card.getBoundingClientRect().width;
            if (rw > 0) return Math.max(0, rw - pl - pr);
            return 0;
          }
  
          function computeColsAndSize(w) {
            const minCols = Math.max(1, Math.ceil((w + DOT_GAP) / (DOT_MAX + DOT_GAP)));
            const maxCols = Math.max(1, Math.floor((w + DOT_GAP) / (DOT_MIN + DOT_GAP)));
            const cols = Math.min(Math.max(minCols, 1), Math.max(maxCols, 1));
            const size = cols <= 1 ? Math.min(DOT_MAX, Math.max(DOT_MIN, w)) : (w - DOT_GAP * (cols - 1)) / cols;
            return { cols, size: Math.max(DOT_MIN, Math.min(DOT_MAX, size)) };
          }
  
          function build() {
            root.querySelectorAll(".budget-card").forEach((card) => {
              const fractionEl = card.querySelector(".budget-card__fraction");
              const matrix = card.querySelector(".budget-card__matrix");
              if (!fractionEl || !matrix) return;
              const frac = parseFraction(fractionEl.textContent);
              if (!frac) return;
  
              const activeRows = Math.max(0, frac.current || 0);
              const renderRows = activeRows < 8 ? 8 : activeRows;
              const w = matrixUsableWidth(matrix, card);
              if (w <= 0) {
                delete matrix.dataset.builtKey;
                matrix.textContent = "";
                return;
              }
  
              const { cols, size } = computeColsAndSize(w);
              const key = renderRows + "x" + cols + "@" + Math.round(size * 10) + "-a" + activeRows;
              if (matrix.dataset.builtKey === key) return;
              matrix.dataset.builtKey = key;
  
              matrix.style.setProperty("--budget-dot-cols", String(cols));
              matrix.style.setProperty("--budget-dot-size", size.toFixed(2) + "px");
              matrix.style.setProperty("--budget-dot-gap", DOT_GAP + "px");
  
              matrix.textContent = "";
              const totalDots = renderRows * cols;
              for (let i = 0; i < totalDots; i++) {
                const dot = document.createElement("span");
                const rowIndex = Math.floor(i / cols);
                const firstActiveRow = Math.max(0, renderRows - activeRows);
                dot.className = rowIndex >= firstActiveRow ? "budget-dot budget-dot--active" : "budget-dot";
                dot.setAttribute("aria-hidden", "true");
                matrix.appendChild(dot);
              }
            });
          }
  
          let scheduled = false;
          function schedule() {
            if (scheduled) return;
            scheduled = true;
            raf(() => {
              scheduled = false;
              build();
            });
          }
  
          schedule();
          window.addEventListener("resize", schedule);
  
          const cardsGrid = root.querySelector(".pressure-exists__cards");
          if (cardsGrid && typeof ResizeObserver === "function") {
            const ro = new ResizeObserver(() => {
              root.querySelectorAll(".budget-card__matrix").forEach((m) => {
                delete m.dataset.builtKey;
              });
              schedule();
            });
            ro.observe(cardsGrid);
          }
        })();
  
        (function () {
          function initDotAnimation() {
            const root = document.getElementById("pressure-exists");
            const pin = root ? root.querySelector(".pressure-exists__pin") : null;
            const section = (root && root.querySelector(".pressure-exists__cards")) || document.querySelector(".pressure-exists__cards");
            if (!root || !pin || !section) return;
  
            /* Only active (colored) dots animate; inactive keep their CSS grey unchanged. */
            const dots = Array.from(section.querySelectorAll(".budget-dot--active"));
            if (!dots.length) return;
  
            const refInactive = section.querySelector(".budget-dot:not(.budget-dot--active)");
            const idleGrey = refInactive
              ? window.getComputedStyle(refInactive).backgroundColor
              : "rgba(13, 13, 13, 0.08)";
  
            dots.forEach((dot) => {
              const computed = window.getComputedStyle(dot);
              dot.dataset.realColor = computed.backgroundColor;
              dot.style.backgroundColor = idleGrey;
              dot.style.transition = "none";
            });
  
            const raf = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function (fn) {
              return setTimeout(fn, 16);
            };
  
            let finished = false;
            let scheduled = false;
  
            function isPinStuck() {
              const stickyTop = parseFloat(window.getComputedStyle(pin).top);
              const t = Number.isFinite(stickyTop) ? stickyTop : 0;
              return pin.getBoundingClientRect().top <= t + 0.5;
            }
  
            function runAnimation() {
              const liveDots = Array.from(section.querySelectorAll(".budget-dot--active"));
              if (!liveDots.length) return;
  
              const liveRows = {};
              liveDots.forEach((dot) => {
                const top = Math.round(dot.getBoundingClientRect().top / 4) * 4;
                if (!liveRows[top]) liveRows[top] = [];
                liveRows[top].push(dot);
              });
  
              const liveSorted = Object.keys(liveRows)
                .map(Number)
                .sort(function (a, b) {
                  return b - a;
                });
  
              const n = liveSorted.length || 1;
              const totalMs = 800;
              const ease = "cubic-bezier(0.22, 1, 0.36, 1)";
              const dotTransitionMs = 420;
              liveSorted.forEach(function (rowKey, rowIndex) {
                const delay = (rowIndex / n) * totalMs;
                liveRows[rowKey].forEach(function (dot) {
                  setTimeout(function () {
                    dot.style.transition = "background-color " + dotTransitionMs + "ms " + ease;
                    dot.style.backgroundColor = dot.dataset.realColor || "";
                  }, delay);
                });
              });
            }
  
            function detach() {
              window.removeEventListener("scroll", onScrollResize);
              window.removeEventListener("resize", onScrollResize);
            }
  
            function onScrollResize() {
              if (finished || scheduled) return;
              scheduled = true;
              raf(function () {
                scheduled = false;
                if (finished) return;
                if (!isPinStuck()) return;
                finished = true;
                detach();
                runAnimation();
              });
            }
  
            __ffPressureExistsScroll = onScrollResize;
            window.addEventListener("resize", onScrollResize);
            onScrollResize();
          }
  
          document.addEventListener("ff:components-loaded", initDotAnimation, { once: true });
        })();
  
        if (!ffIsTouchPrimaryDevice()) {
          let mouseX = 0,
            mouseY = 0;
          let ringX = 0,
            ringY = 0;
  
          const dot = document.getElementById("cursor-dot");
          const ring = document.getElementById("cursor-ring");
  
          if (dot && ring) {
            document.addEventListener("mousemove", (e) => {
              mouseX = e.clientX;
              mouseY = e.clientY;
              const rotation = dot.dataset.rotated === "1" ? " rotate(35deg)" : "";
              dot.style.transform = `translate(${mouseX}px, ${mouseY}px)${rotation}`;
            });
  
            function animateCursor() {
              const speed = 0.12;
              ringX += (mouseX - ringX) * speed;
              ringY += (mouseY - ringY) * speed;
  
              ring.style.left = ringX + "px";
              ring.style.top = ringY + "px";
  
              requestAnimationFrame(animateCursor);
            }
            animateCursor();
  
            document.querySelectorAll("a, button").forEach((el) => {
              el.addEventListener("mouseenter", () => {
                ring.style.width = "48px";
                ring.style.height = "48px";
                ring.style.borderColor = "#E67337";
                ring.style.transition =
                  "width 0.3s, height 0.3s, border-color 0.3s";
                dot.dataset.rotated = "1";
              });
              el.addEventListener("mouseleave", () => {
                ring.style.width = "32px";
                ring.style.height = "32px";
                ring.style.borderColor = "rgba(13,13,13,0.4)";
                dot.dataset.rotated = "0";
              });
            });
          }
        }
  
        function animateDriversTitle() {
          const textBlock = document.getElementById("drivers-text-container");
          const title = document.getElementById("drivers-title");
          const eyebrow = document.getElementById("drivers-eyebrow");
          if (!textBlock || !title) return;
  
          if (driversExpandLayoutIsMobile()) {
            return;
          }
  
          if (!title.dataset.prepared) {
            title.dataset.prepared = "true";
            const originalText = title.dataset.text || title.textContent.trim();
            title.dataset.text = originalText;
            const words = originalText.split(" ");
  
            title.innerHTML = "";
            words.forEach((word) => {
              const wrap = document.createElement("span");
              wrap.className = "word-wrap";
              const inner = document.createElement("span");
              inner.className = "word-inner";
              inner.textContent = word;
              wrap.appendChild(inner);
              title.appendChild(wrap);
            });
          }
  
          if (eyebrow && !eyebrow.dataset.prepared) {
            eyebrow.dataset.prepared = "true";
            const originalEyebrow = eyebrow.dataset.text || eyebrow.textContent.trim();
            eyebrow.dataset.text = originalEyebrow;
            const eyebrowWords = originalEyebrow.split(" ");
  
            eyebrow.innerHTML = "";
            eyebrowWords.forEach((word) => {
              const wrap = document.createElement("span");
              wrap.className = "word-wrap";
              const inner = document.createElement("span");
              inner.className = "word-inner";
              inner.textContent = word;
              wrap.appendChild(inner);
              eyebrow.appendChild(wrap);
            });
          }
  
          if (title.dataset.revealAnimated) return;
          if (title.dataset.revealIoAttached) return;
          title.dataset.revealIoAttached = "true";
  
          function runReveal() {
            if (title.dataset.revealAnimated) return;
            title.dataset.revealAnimated = "true";
  
            const wordEls = title.querySelectorAll(".word-inner");
            wordEls.forEach((el, i) => {
              setTimeout(() => el.classList.add("visible"), 200 + i * 120);
            });
  
            if (eyebrow) {
              const titleWordCount = wordEls.length;
              const totalDelay = 200 + titleWordCount * 120;
              const eyebrowWordEls = eyebrow.querySelectorAll(".word-inner");
              eyebrowWordEls.forEach((el, i) => {
                setTimeout(() => el.classList.add("visible"), totalDelay + 100 + i * 45);
              });
            }
          }
  
          const io = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry || !entry.isIntersecting) return;
              runReveal();
              io.disconnect();
            },
            { threshold: 0.06, rootMargin: "0px" }
          );
          io.observe(textBlock);
        }
  
        function animateWpsTitle() {
          const intro = document.querySelector("#what-pressure-season .wps__intro");
          const title = document.getElementById("wps-heading");
          if (!intro || !title) return;
  
          const reduced =
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  
          if (!title.dataset.prepared) {
            title.dataset.prepared = "true";
            title.querySelectorAll(".wps__title-line").forEach((lineEl) => {
              const words = lineEl.textContent.trim().split(/\s+/);
              lineEl.innerHTML = "";
              words.forEach((word) => {
                const wrap = document.createElement("span");
                wrap.className = "word-wrap";
                const inner = document.createElement("span");
                inner.className = "word-inner";
                inner.textContent = word;
                wrap.appendChild(inner);
                lineEl.appendChild(wrap);
              });
            });
          }
  
          if (reduced) {
            title.querySelectorAll(".word-inner").forEach((el) => el.classList.add("visible"));
            return;
          }
  
          if (title.dataset.revealAnimated) return;
          if (title.dataset.revealIoAttached) return;
          title.dataset.revealIoAttached = "true";
  
          function runReveal() {
            if (title.dataset.revealAnimated) return;
            title.dataset.revealAnimated = "true";
            title.querySelectorAll(".word-inner").forEach((el, i) => {
              setTimeout(() => el.classList.add("visible"), 200 + i * 120);
            });
          }
  
          const io = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry || !entry.isIntersecting) return;
              runReveal();
              io.disconnect();
            },
            { threshold: 0.06, rootMargin: "0px" }
          );
          io.observe(intro);
        }
  
        function animateNatureWorkingTitle() {
          const intro = document.querySelector("#nature-working .nature-working__intro");
          const title = document.getElementById("nature-working-heading");
          const body = intro ? intro.querySelector(".nature-working__body") : null;
          if (!intro || !title) return;
  
          const reduced =
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  
          if (!title.dataset.prepared) {
            title.dataset.prepared = "true";
            title.querySelectorAll(".nature-working__title-line").forEach((lineEl) => {
              const words = lineEl.textContent.trim().split(/\s+/);
              lineEl.innerHTML = "";
              words.forEach((word) => {
                const wrap = document.createElement("span");
                wrap.className = "word-wrap";
                const inner = document.createElement("span");
                inner.className = "word-inner";
                inner.textContent = word;
                wrap.appendChild(inner);
                lineEl.appendChild(wrap);
              });
            });
  
            if (body && !body.dataset.prepared) {
              body.dataset.prepared = "true";
              const words = body.textContent.trim().split(/\s+/);
              body.innerHTML = "";
              words.forEach((word) => {
                const wrap = document.createElement("span");
                wrap.className = "word-wrap";
                const inner = document.createElement("span");
                inner.className = "word-inner";
                inner.textContent = word;
                wrap.appendChild(inner);
                body.appendChild(wrap);
              });
            }
          }
  
          if (reduced) {
            intro.querySelectorAll(".word-inner").forEach((el) => el.classList.add("visible"));
            return;
          }
  
          if (title.dataset.revealAnimated) return;
          if (title.dataset.revealIoAttached) return;
          title.dataset.revealIoAttached = "true";
  
          function runReveal() {
            if (title.dataset.revealAnimated) return;
            title.dataset.revealAnimated = "true";
            const titleWords = title.querySelectorAll(".word-inner");
            titleWords.forEach((el, i) => {
              setTimeout(() => el.classList.add("visible"), 200 + i * 120);
            });
  
            if (body) {
              const bodyWordEls = body.querySelectorAll(".word-inner");
              const titleWordCount = titleWords.length;
              const totalDelay = 200 + titleWordCount * 120;
              bodyWordEls.forEach((el, i) => {
                setTimeout(() => el.classList.add("visible"), totalDelay + 40 + i * 22);
              });
            }
          }
  
          const io = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry || !entry.isIntersecting) return;
              runReveal();
              io.disconnect();
            },
            { threshold: 0.06, rootMargin: "0px" }
          );
          io.observe(intro);
        }

        function updateNatureGalleryCardVisibility() {
          const pin = document.querySelector('.nature-gallery-pin');
          if (!pin) return;

          const cards = pin.querySelectorAll('.nature-gallery-card');
          const logos = pin.querySelectorAll('.nature-gallery-card__logo-mark');
          if (!cards.length) return;

          const viewportH = window.innerHeight;

          // Measure tallest card (they are position:absolute so offsetHeight is reliable)
          let maxCardH = 0;
          cards.forEach(card => {
            maxCardH = Math.max(maxCardH, card.offsetHeight);
          });

          // Logo: 80px height + 40px top padding = 120px
          // Card: maxCardH + 40px bottom padding
          // Gap between logo bottom and card top: at least 20px
          const minRequired = 120 + 20 + maxCardH + 40;

          const shouldHide = viewportH < minRequired;

          cards.forEach(card => {
            card.style.display = shouldHide ? 'none' : '';
          });
          logos.forEach(logo => {
            logo.style.display = shouldHide ? 'none' : '';
          });
        }

        function animateMethodologyBannerIntro() {
          const section = document.getElementById("our-methodology");
          if (!section) return;
          const intro = section.querySelector("header.methodology-banner__intro");
          const title = intro ? intro.querySelector(".methodology-banner__title") : null;
          const eyebrow = intro ? intro.querySelector(".methodology-banner__eyebrow") : null;
          if (!intro || !title) return;
  
          if (window.innerWidth <= 640) {
            title.removeAttribute("data-scroll");
            return;
          }
  
          if (!title.dataset.prepared) {
            title.dataset.prepared = "true";
            title.querySelectorAll(".methodology-banner__title-line").forEach((line) => {
              const originalText = line.dataset.text || line.textContent.trim();
              line.dataset.text = originalText;
              const words = originalText.split(" ");
  
              line.innerHTML = "";
              words.forEach((word) => {
                const wrap = document.createElement("span");
                wrap.className = "word-wrap";
                const inner = document.createElement("span");
                inner.className = "word-inner";
                inner.textContent = word;
                wrap.appendChild(inner);
                line.appendChild(wrap);
              });
            });
          }
  
          if (eyebrow && !eyebrow.dataset.prepared) {
            eyebrow.dataset.prepared = "true";
            const originalEyebrow = eyebrow.dataset.text || eyebrow.textContent.trim();
            eyebrow.dataset.text = originalEyebrow;
            const eyebrowWords = originalEyebrow.split(" ");
  
            eyebrow.innerHTML = "";
            eyebrowWords.forEach((word) => {
              const wrap = document.createElement("span");
              wrap.className = "word-wrap";
              const inner = document.createElement("span");
              inner.className = "word-inner";
              inner.textContent = word;
              wrap.appendChild(inner);
              eyebrow.appendChild(wrap);
            });
          }
  
          if (intro.dataset.textAnimated) return;
          if (intro.dataset.revealIoAttached) return;
          intro.dataset.revealIoAttached = "true";
  
          function runMethodReveal() {
            if (intro.dataset.textAnimated) return;
            intro.dataset.textAnimated = "true";
  
            const titleWordEls = title.querySelectorAll(".word-inner");
            titleWordEls.forEach((el, i) => {
              setTimeout(() => el.classList.add("visible"), 200 + i * 120);
            });
  
            if (eyebrow) {
              const titleWordCount = titleWordEls.length;
              const totalDelay = 200 + titleWordCount * 120;
              const eyebrowWordEls = eyebrow.querySelectorAll(".word-inner");
              eyebrowWordEls.forEach((el, i) => {
                setTimeout(() => el.classList.add("visible"), totalDelay + 100 + i * 45);
              });
            }
          }
  
          const io = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry || !entry.isIntersecting) return;
              runMethodReveal();
              io.disconnect();
            },
            { threshold: 0.08, rootMargin: "0px" }
          );
          io.observe(intro);
        }
  
        function animateFundingAllocationIntro() {
          const section = document.getElementById("funding-allocation");
          if (!section) return;
          const intro = section.querySelector("header.funding-allocation__intro");
          const title = intro ? intro.querySelector(".funding-allocation__title") : null;
          const lede = intro ? intro.querySelector(".funding-allocation__lede") : null;
          const ledeP = lede ? lede.querySelector("p") : null;
          if (!intro || !title) return;
  
          if (window.innerWidth <= 640) {
            title.removeAttribute("data-scroll");
            title.removeAttribute("data-scroll-speed");
            title.removeAttribute("data-scroll-position");
            return;
          }
  
          function fundingTitleLinesFromH2(h2) {
            const lines = [];
            let buf = "";
            h2.childNodes.forEach((node) => {
              if (node.nodeType === 1 && String(node.tagName).toUpperCase() === "BR") {
                if (buf.trim()) lines.push(buf.trim());
                buf = "";
              } else if (node.nodeType === 3) {
                buf += node.nodeValue || "";
              }
            });
            if (buf.trim()) lines.push(buf.trim());
            return lines.length ? lines : [String(h2.textContent || "").trim()].filter(Boolean);
          }
  
          if (!title.dataset.prepared) {
            title.dataset.prepared = "true";
            const lineTexts = fundingTitleLinesFromH2(title);
            title.innerHTML = "";
            lineTexts.forEach((lineText) => {
              const line = document.createElement("span");
              line.className = "funding-allocation__title-line";
              line.dataset.text = lineText;
              const words = lineText.split(" ");
              line.innerHTML = "";
              words.forEach((word) => {
                const wrap = document.createElement("span");
                wrap.className = "word-wrap";
                const inner = document.createElement("span");
                inner.className = "word-inner";
                inner.textContent = word;
                wrap.appendChild(inner);
                line.appendChild(wrap);
              });
              title.appendChild(line);
            });
          }
  
          if (ledeP && !ledeP.dataset.prepared) {
            ledeP.dataset.prepared = "true";
            const raw = ledeP.dataset.text || ledeP.textContent;
            const originalText = String(raw).replace(/\s+/g, " ").trim();
            ledeP.dataset.text = originalText;
            const words = originalText.split(/\s+/).filter(Boolean);
            ledeP.innerHTML = "";
            words.forEach((word) => {
              const wrap = document.createElement("span");
              wrap.className = "word-wrap";
              const inner = document.createElement("span");
              inner.className = "word-inner";
              inner.textContent = word;
              wrap.appendChild(inner);
              ledeP.appendChild(wrap);
            });
          }
  
          if (intro.dataset.textAnimated) return;
          if (intro.dataset.revealIoAttached) return;
          intro.dataset.revealIoAttached = "true";
  
          function runFundingReveal() {
            if (intro.dataset.textAnimated) return;
            intro.dataset.textAnimated = "true";
  
            const titleWordEls = title.querySelectorAll(".word-inner");
            titleWordEls.forEach((el, i) => {
              setTimeout(() => el.classList.add("visible"), 200 + i * 120);
            });
  
            if (ledeP) {
              const titleWordCount = titleWordEls.length;
              const totalDelay = 200 + titleWordCount * 120;
              const ledeWords = ledeP.querySelectorAll(".word-inner");
              ledeWords.forEach((el, i) => {
                setTimeout(() => el.classList.add("visible"), totalDelay + 100 + i * 45);
              });
            }
          }
  
          const io = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry || !entry.isIntersecting) return;
              runFundingReveal();
              io.disconnect();
            },
            { threshold: 0.08, rootMargin: "0px" }
          );
          io.observe(intro);
        }
  
        function maybeInitFundingIntroDesktop() {
          if (window.innerWidth <= 640) return;
          const section = document.getElementById("funding-allocation");
          if (!section) return;
          const intro = section.querySelector("header.funding-allocation__intro");
          if (!intro || intro.dataset.revealIoAttached) return;
          animateFundingAllocationIntro();
        }
  
        document.addEventListener("ff:components-loaded", animateDriversTitle);
  
        document.addEventListener("ff:components-loaded", animateWpsTitle);
  
        document.addEventListener("ff:components-loaded", animateNatureWorkingTitle);
  
        document.addEventListener("ff:components-loaded", animateMethodologyBannerIntro);
  
        document.addEventListener("ff:components-loaded", animateFundingAllocationIntro);
  
        function onScrollResize() {
          if (typeof __ffPressureExistsScroll === "function") __ffPressureExistsScroll();
          if (typeof window.__ffNatureGalleryScroll === "function") window.__ffNatureGalleryScroll();
        }
  
        function updateNatureGalleryScroll() {
          if (
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ) {
            return;
          }
          const runway = document.getElementById("nature-gallery-runway");
          const track = document.getElementById("nature-gallery-track");
          if (!runway || !track) return;
  
          const vh = window.innerHeight;
          const scrollY = ffScrollY();
          const runwayRect = runway.getBoundingClientRect();
          const runwayTop = runwayRect.top + scrollY;
          const runwayHeight = runway.offsetHeight;
  
          /* Sticky span = scroll distance while runway pins.
             leadHoldPx: first ~1 viewport after pin — slider stays on slide 1 ("next scroll"
             before horizontal motion). Then horizontalSpan drives 0→1; then holdPx at end. */
          const stickySpan = Math.max(1, runwayHeight - vh);
          const leadHoldPx = vh;
          const holdPx = vh;
          const horizontalSpan = Math.max(1, stickySpan - holdPx - leadHoldPx);
  
          let scrolledIntoRunway = scrollY - runwayTop;
          scrolledIntoRunway = Math.max(0, Math.min(stickySpan, scrolledIntoRunway));
  
          let progress = 1;
          if (scrolledIntoRunway < leadHoldPx) {
            progress = 0;
          } else if (scrolledIntoRunway < leadHoldPx + horizontalSpan) {
            progress = (scrolledIntoRunway - leadHoldPx) / horizontalSpan;
          }
  
          const vw = window.innerWidth;
          const tx = -progress * 2 * vw;
          track.style.transform = "translate3d(" + tx + "px, 0, 0)";
  
          /* Tail segment only (slide 3 locked after horizontal motion): without this, the
             sticky pin and Locomotive-smoothed scroll can make the slide-3 card creep upward
             faster than `.nature-gallery-pin`. Enable Locomotive parallax only while the user
             is scrolling inside that tail zone — not during slides 1–2 horizontal motion. */
          const tailScrollStart = leadHoldPx + horizontalSpan;
          const prevIntoRunway = updateNatureGalleryScroll._prevIntoRunway;
          if (scrolledIntoRunway < tailScrollStart) {
            updateNatureGalleryScroll._natureTailParallaxGate = false;
          } else if (
            scrolledIntoRunway >= tailScrollStart &&
            (prevIntoRunway === undefined || prevIntoRunway < tailScrollStart)
          ) {
            updateNatureGalleryScroll._natureTailParallaxGate = true;
          }
          updateNatureGalleryScroll._prevIntoRunway = scrolledIntoRunway;
  
          const cardSlide3 = track.querySelector(
            ".nature-gallery-slide--3 .nature-gallery-card"
          );
          if (cardSlide3) {
            const tailParallaxOn =
              scrolledIntoRunway >= tailScrollStart &&
              updateNatureGalleryScroll._natureTailParallaxGate === true;
            const wasOn =
              cardSlide3.getAttribute("data-nature-tail-parallax") === "1";
            if (tailParallaxOn !== wasOn) {
              if (tailParallaxOn) {
                cardSlide3.setAttribute("data-scroll", "");
                cardSlide3.setAttribute("data-scroll-speed", "0.48");
                cardSlide3.setAttribute("data-nature-tail-parallax", "1");
              } else {
                cardSlide3.removeAttribute("data-scroll");
                cardSlide3.removeAttribute("data-scroll-speed");
                cardSlide3.removeAttribute("data-nature-tail-parallax");
              }
              requestAnimationFrame(() => {
                try {
                  ffScrollLayoutRefresh();
                } catch (_) {}
              });
            }
          }
        }
  
        window.__ffNatureGalleryScroll = updateNatureGalleryScroll;

        function initNatureGalleryCardMobileExpand() {
          if (typeof window.matchMedia !== "function") return;

          const mq = window.matchMedia("(max-width: 900px)");

          function teardown() {
            document.querySelectorAll(".nature-gallery-card").forEach((card) => {
              const quote = card.querySelector(".nature-gallery-card__quote");
              const toggle = card.querySelector(".nature-gallery-card__toggle");
              if (quote) quote.classList.remove("is-expanded");
              if (toggle) toggle.remove();
              delete card.dataset.mobileExpandInit;
            });
          }

          function setup() {
            if (!mq.matches) {
              teardown();
              return;
            }

            document.querySelectorAll(".nature-gallery-card").forEach((card) => {
              if (card.dataset.mobileExpandInit) return;

              const main = card.querySelector(".nature-gallery-card__main");
              const quote = main ? main.querySelector(".nature-gallery-card__quote") : null;
              if (!main || !quote) return;

              const needsClamp = quote.scrollHeight > quote.clientHeight + 1;
              if (!needsClamp) return;

              card.dataset.mobileExpandInit = "1";

              const toggle = document.createElement("button");
              toggle.type = "button";
              toggle.className = "nature-gallery-card__toggle";
              toggle.textContent = "Show more";
              toggle.setAttribute("aria-expanded", "false");

              if (!quote.id) {
                quote.id =
                  "nature-gallery-quote-" + Math.random().toString(36).slice(2, 9);
              }
              toggle.setAttribute("aria-controls", quote.id);

              quote.insertAdjacentElement("afterend", toggle);

              toggle.addEventListener("click", () => {
                const expanded = quote.classList.toggle("is-expanded");
                toggle.textContent = expanded ? "Show less" : "Show more";
                toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
              });
            });
          }

          setup();
          mq.addEventListener("change", setup);
        }

        document.addEventListener("ff:components-loaded", () => {
          updateNatureGalleryScroll();
          initNatureGalleryCardMobileExpand();
          updateNatureGalleryCardVisibility();
        });
  
        window.addEventListener(
          "resize",
          () => {
            updateNatureGalleryScroll();
          },
          { passive: true }
        );
  
        document.dispatchEvent(new CustomEvent("ff:components-loaded"));
  
        requestAnimationFrame(() => {
          updateReportNavActive();
          syncFundingAllocationMobileLayout();
        });
  
        window.addEventListener("scroll", function onScrollAll() {
          updateFundingCards();
          onDumyatRelatedScroll();
          updateMethod();
          updateLandResponseScroll();
          updateDriversExpand();
          onScrollResize();
          updateReportNavActive();
        }, { passive: true });
    // Nav pill: scroll to correct progress position
    document.querySelectorAll('a.nav-pill[href^="#"]').forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        const href = pill.getAttribute('href');
        const targetId = href.slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;
        const isMobile = window.innerWidth <= 900;
        e.preventDefault();
        const currentScroll = window.__ffLocoScroll.lenisInstance.scroll;
        let scrollY;
        if (!isMobile && targetId === 'dumyat-foundation') {
          const total = Math.max(target.offsetHeight - window.innerHeight, 1);
          scrollY = target.getBoundingClientRect().top + currentScroll + total * 0.18;
          setTimeout(function() {
            window.__ffLocoScroll.lenisInstance.scrollTo(scrollY, { duration: 1.15 });
          }, 500);
        } else {
          scrollY = target.getBoundingClientRect().top + currentScroll;
          setTimeout(function() {
            window.__ffLocoScroll.lenisInstance.scrollTo(scrollY, { duration: 1.15 });
          }, 500);
        }
      });
    });
  }
  
  (function() {
    function initFundingScrollbar() {
      const cards = document.querySelector('#funding-allocation .funding-allocation__cards');
      if (!cards) return;
  
      const track = document.createElement('div');
      track.style.cssText = 'position:relative;height:4px;background:rgba(255,255,255,0.15);border-radius:2px;margin:12px 0 0;flex-shrink:0;';
  
      const thumb = document.createElement('div');
      thumb.style.cssText = 'position:absolute;top:0;left:0;height:4px;background:rgba(255,255,255,0.5);border-radius:2px;transition:left 0.1s;';
  
      track.appendChild(thumb);
      cards.parentNode.insertBefore(track, cards.nextSibling);
  
      function update() {
        const ratio = cards.clientWidth / cards.scrollWidth;
        const thumbW = Math.max(ratio * 100, 10);
        const maxScroll = cards.scrollWidth - cards.clientWidth;
        const scrollRatio = maxScroll > 0 ? cards.scrollLeft / maxScroll : 0;
        thumb.style.width = thumbW + '%';
        thumb.style.left = (scrollRatio * (100 - thumbW)) + '%';
      }
  
      update();
      cards.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFundingScrollbar);
    } else {
      initFundingScrollbar();
    }
  })();
